import imApp from '../app.module.ajs';
import { BjsTestComponent } from '@app/views/components/bjs-test/bjs-test.component';
import { MainMenuComponent } from '@app/views/components/mainmenu/mainmenu.component';
//import { KlnTestComponent } from "../../app/views/kln-test/kln-test.component";
import { JlrTestComponent } from '@app/views/components/jlr-test/jlr-test.component';
import { ChecklistDataComponent } from '@app/views/components/checklist-data/checklist-data.component';
import { CustactEditComponent } from '@app/views/components/custact-edit/custact-edit.component';
import { WorkDetailsComponent } from '@app/views/components/work-details/work-details.component';
import { ChargeViewComponent } from '@app/views/components/charge/charge-view/charge-view.component';
import { ChargeTestViewComponent } from '@app/views/components/charge-test/charge-test-view/charge-test-view.component';
import { CalViewViewComponent } from '@app/views/components/cal-view/cal-view-view/cal-view-view.component';
import { TimeSheetDiaryComponent } from '@app/views/components/time-sheet-diary/time-sheet-diary.component';
import { OrderHeadComponent } from '@app/views/components/order-head/order-head.component';
import { ProductComponent } from '@app/views/components/product/product.component';
import { ComponentComponent } from '@app/views/components/component/component.component';
import { DocArcComponent } from '@app/views/components/doc-arc/doc-arc.component';
import { WebpageSettingComponent } from '@app/views/components/webpage-setting/webpage-setting.component';
import { WebpageSettingMenuComponent } from '@app/views/components/webpage-setting-menu/webpage-setting-menu.component';
// import { CheckListComponent } from '@app/views/components/check-list/check-list.component';
import { SirvSetupComponent } from '@app/views/components/sirv-setup/sirv-setup.component';
import { PictureBankComponent } from '@app/views/components/picture-bank/picture-bank.component';
import { PictureBanksComponent } from '@app/views/components/picture-banks/picture-banks.component';
import { ProductCreateComponent } from '@app/views/components/product-create/product-create.component';
import { SelectProjectViewComponent } from '@app/views/components/select-project/select-project-view/select-project-view.component';
import { StudentTestComponent } from '@app/views/components/student-test/student-test.component';
import { BankReconciliationComponent } from '@app/views/components/bank-reconciliation/bank-reconciliation.component';
import { ShopFloorComponent } from '@app/views/components/shop-floor/shop-floor.component';
import { WebpagemenuComponent } from '@app/core/components/webpagemenu/webpagemenu.component';
import { TranslateEditComponent } from '@app/core/components/translate-edit/translate-edit.component';
import { MyActivitiesComponent } from '@app/views/components/my-activities/my-activities.component';
import { EconomyMenuComponent } from '@app/views/components/economy-menu/economy-menu.component';
import { ProductionMenuComponent } from '@app/views/components/production-menu/production-menu.component';
import { CrmMenuComponent } from '@app/views/components/crm-menu/crm-menu.component';
import { ConsignmentMenuComponent } from '@app/views/components/consignment-menu/consignment-menu.component';
import { DynamicDatataskGotoComponent } from '@app/views/components/dynamic-datatask-goto/dynamic-datatask-goto.component';
import { StockMenuComponent } from '@app/views/components/stock-menu/stock-menu.component';
import { ProductMenuComponent } from '@app/views/components/product-menu/product-menu.component';
import { PurchaseMenuComponent } from '@app/views/components/purchase-menu/purchase-menu.component';
import { EcommerceMenuComponent } from '@app/views/components/ecommerce-menu/ecommerce-menu.component';
import { TimestampMenuComponent } from '@app/views/components/timestamp-menu/timestamp-menu.component';
import { ExternalProductionMenuComponent } from '@app/views/components/external-production-menu/external-production-menu.component';
import { ToolsMenuComponent } from '@app/views/components/tools-menu/tools-menu.component';
import { DocarticleMenuComponent } from '@app/views/components/docarticle-menu/docarticle-menu.component';
import { DocArticleEditViewComponent } from '@app/views/components/doc-article-edit-view/doc-article-edit-view.component';
import { DocArticleViewComponent } from '@app/views/components/doc-article-view/doc-article-view.component';
import { DocArticlesComponent } from '@app/views/components/doc-articles/doc-articles.component';
import { MyPageComponent } from '@app/views/components/my-page/my-page.component';
import { DevelopMenuComponent } from '@app/views/components/develop-menu/develop-menu.component';
import { HrMenuComponent } from '@app/views/components/hr-menu/hr-menu.component';
import { BusinesscoSettingSmtpComponent } from '@app/views/components/businessco-setting-smtp/businessco-setting-smtp.component';
import { P2DatataskLogsComponent } from '@app/views/components/p2-datatask-logs/p2-datatask-logs.component';
import { P2DatataskLogComponent } from '@app/views/components/p2-datatask-log/p2-datatask-log.component';
import { P2UpdateScriptEditViewComponent } from '@app/views/components/p2-update-script-edit-view/p2-update-script-edit-view.component';
import { P2UpdateScriptsComponent } from '@app/views/components/p2-update-scripts/p2-update-scripts.component';
import { DispatchPlanningComponent } from '@app/views/components/dispatch-planning/dispatch-planning.component';
import { DeviationSettingsComponent } from '@app/views/components/deviation-settings/deviation-settings.component';
import { DeviationTypeViewComponent } from '@app/views/components/deviation-type-view/deviation-type-view.component';
import { DeviationSourceViewComponent } from '@app/views/components/deviation-source-view/deviation-source-view.component';
import { DeviationSource2ViewComponent } from '@app/views/components/deviation-source2-view/deviation-source2-view.component';
import { KpiCompComponent } from '@app/views/components/kpi-comp/kpi-comp.component';
import { ProductSettingMcItemComponent } from '@app/views/components/product-setting-mc-item/product-setting-mc-item.component';
import { AccountingBsComponent } from '@app/views/components/accounting-bs/accounting-bs.component';
import { StockBatchLoggComponent } from '@app/views/components/stock-batch-logg/stock-batch-logg.component';
import { ConsignmentPlansDeliveryComponent } from '@app/views/components/consignment-plans-delivery/consignment-plans-delivery.component';
import { ConsignmentPlansConsignmentsComponent } from '@app/views/components/consignment-plans-consignments/consignment-plans-consignments.component';
// import { SettingsComponent } from "@app/views/components/settings/settings.component";
import { HtmlReportComponent } from '@app/core/components/html-report/html-report.component';
import { DoDataImpViewComponent } from '@app/views/components/do-data-imp/do-data-imp-view/do-data-imp-view.component';
import { SaftExportComponent } from '@app/views/components/saft-export/saft-export.component';
import { PurchReceivalPlanningComponent } from '@app/views/components/purch-receival-planning/purch-receival-planning.component';
import { CustactDialogsComponent } from '@app/views/components/custact-dialogs/custact-dialogs.component';
import { PickJobGroupComponent } from '@app/views/components/pick-job-group/pick-job-group.component';
import { InterbranchEquipmentInvoicingComponent } from '@app/views/components/interbranch-equipment-invoicing/interbranch-equipment-invoicing.component';
import { ChecklistItemComponent } from '@app/views/components/checklist-item/checklist-item.component';
import { HelpdocComponent } from '@app/views/components/helpdoc/helpdoc.component';
import { VideoTutorialsComponent } from '@app/views/components/video-tutorials/video-tutorials.component';
import { VideoTutorialComponent } from '@app/views/components/video-tutorial/video-tutorial.component';
import { MetaColumnItemComponent } from '@app/views/components/meta-column-item/meta-column-item.component';
import { ProductsComponent } from '@app/views/components/products/products.component';
import { ProductBomComponent } from '@app/views/components/product-bom/product-bom.component';
import { EmailComponent } from '@app/views/components/email/email.component';
import { ConcernOrdersGridComponent } from '@app/views/components/concern-orders-grid/concern-orders-grid.component';
import { OrderheadExternalCostComponent } from '@app/views/components/orderhead-external-cost/orderhead-external-cost.component';
import { PurchPlanningOverviewComponent } from '@app/views/components/purch-planning-overview/purch-planning-overview.component';
import { ProductsOverviewComponent } from '@app/views/components/products-overview/products-overview.component';
import { AccountproductComponent } from '@app/views/components/accountproduct/accountproduct.component';
import { ProductsConfigComponent } from '@app/views/components/products-config/products-config.component';
import { PurchHeadViewComponent } from '@app/views/components/purch-head/purch-head-view/purch-head-view.component';
import { OrderPickNewViewComponent } from '@app/views/components/order-pick-new/order-pick-new-view/order-pick-new-view.component';
import { OrderPickViewViewComponent } from '@app/views/components/order-pick-view/order-pick-view-view/order-pick-view-view.component';
import { PurchHeadsComponent } from '@app/views/components/purch-heads/purch-heads.component';
import { ProductsConfigViewComponent } from '@app/views/components/products-config-view/products-config-view.component';
import { SelectLineModelViewComponent } from '@app/views/components/select-line-model/select-line-model-view/select-line-model-view.component';
import { SelectLineProductsViewComponent } from '@app/views/components/select-line-products/select-line-products-view/select-line-products-view.component';
import { OrderPurchComponent } from '@app/views/components/order-purch/order-purch.component';
import { TravelWageMenuComponent } from '@app/views/components/travel-wage-menu/travel-wage-menu.component';
import { DeviantVatComponent } from '@app/views/components/deviant-vat/deviant-vat.component';
import { DocumentsComponent } from '@app/views/components/documents/documents.component';
import { DocumentsViewComponent } from '@app/views/components/documents-view/documents-view.component';
import { DoDataImpsWizardComponent } from '@app/views/components/do-data-imps-wizard/do-data-imps-wizard.component';
import { CustactCalcComponent } from '@app/views/components/custact-calc/custact-calc.component';
import { AboutViewComponent } from '@app/views/components/about-view/about-view.component';
import { PrognosisPurchaseOverviewComponent } from '@app/views/components/prognosis-purchase-overview/prognosis-purchase-overview.component';
import { PrognosisPurchaseHistoryComponent } from '@app/views/components/prognosis-purchase-history/prognosis-purchase-history.component';
import { ProjectComponent } from '@app/views/components/project/project.component';
import { ProjectProcessViewComponent } from '@app/views/components/project-process/project-process-view/project-process-view.component';
import { ProjectProgressLogViewComponent } from '@app/views/components/project-progress-log/project-progress-log-view/project-progress-log-view.component';
import { ProjectMenuComponent } from '@app/views/components/project-menu/project-menu.component';
import { ProjectMenuViewComponent } from '@app/views/components/project-menu-view/project-menu-view.component';
import { ProjectFoldersViewComponent } from '@app/views/components/project-folders/project-folders-view/project-folders-view.component';
import { P2WebpageTableComponent } from '@app/views/components/p2-webpage-table/p2-webpage-table.component';
import { WebpageTableEditComponent } from '@app/views/components/webpage-table-edit/webpage-table-edit.component';
import { P2SettingEditViewComponent } from '@app/views/components/p2-setting-edit-view/p2-setting-edit-view.component';
import { P2SettingsComponent } from '@app/views/components/p2-settings/p2-settings.component';
import { ActStatusesComponent } from '@app/views/components/act-statuses/act-statuses.component';
import { ActivityTypeActStatusesComponent } from '@app/views/components/activity-type-act-statuses/activity-type-act-statuses.component';
import { ActStatusMenuComponent } from '@app/views/components/act-status-menu/act-status-menu.component';
import { ActivityTypeActStatusComponent } from '@app/views/components/activity-type-act-status/activity-type-act-status.component';
import { ActivityTypeLangsComponent } from '@app/views/components/activity-type-langs/activity-type-langs.component';
import { ActStatusLangsComponent } from '@app/views/components/act-status-langs/act-status-langs.component';
import { ActivityTypesComponent } from '@app/views/components/activity-types/activity-types.component';
import { ActivityTypeDevTypesComponent } from '@app/views/components/activity-type-dev-types/activity-type-dev-types.component';
import { ActivityTypeDevTypeComponent } from '@app/views/components/activity-type-dev-type/activity-type-dev-type.component';
import { AcReportLayoutsComponent } from '@app/views/components/ac-report-layouts/ac-report-layouts.component';
import { AcReportLayoutComponent } from '@app/views/components/ac-report-layout/ac-report-layout.component';
import { AcReportLayoutLineComponent } from '@app/views/components/ac-report-layout-line/ac-report-layout-line.component';
import { BusinesscoSettingsComponent } from '@app/views/components/businessco-settings/businessco-settings.component';
import { BusinessSitesComponent } from '@app/views/components/business-sites/business-sites.component';
import { BusinessSiteComponent } from '@app/views/components/business-site/business-site.component';
import { StockPlacesToComponent } from '@app/views/components/stock-places-to/stock-places-to.component';
import { StockPlaceDelTimeComponent } from '@app/views/components/stock-place-del-time/stock-place-del-time.component';
import { PickJobGrpsComponent } from '@app/views/components/pick-job-grps/pick-job-grps.component';
import { TransportAreasComponent } from '@app/views/components/transport-areas/transport-areas.component';
import { TransportAreaMenuComponent } from '@app/views/components/transport-area-menu/transport-area-menu.component';
import { TransportAreaComponent } from '@app/views/components/transport-area/transport-area.component';
import { TransportAreaPpAddComponent } from '@app/views/components/transport-area-pp-add/transport-area-pp-add.component';
import { TransportAreaPpMoveComponent } from '@app/views/components/transport-area-pp-move/transport-area-pp-move.component';
import { StockPlaceDelTimesComponent } from '@app/views/components/stock-place-del-times/stock-place-del-times.component';
import { CategoryListMainComponent } from '@app/views/components/category-list-main/category-list-main.component';
import { PoConnectedPositionsComponent } from '@app/views/components/po-connected-positions/po-connected-positions.component';
import { OrderLineCreditCausesComponent } from '@app/views/components/order-line-credit-causes/order-line-credit-causes.component';
import { OrderLineCreditCauseComponent } from '@app/views/components/order-line-credit-cause/order-line-credit-cause.component';
import { OrderLineCreditCauseLangComponent } from '@app/views/components/order-line-credit-cause-lang/order-line-credit-cause-lang.component';
import { TransportAreaPpComponent } from '@app/views/components/transport-area-pp/transport-area-pp.component';
import { BaseCurrenciesComponent } from '@app/views/components/base-currencies/base-currencies.component';
import { CurrencyTypesComponent } from '@app/views/components/currency-types/currency-types.component';
import { CurrencyExRatesComponent } from '@app/views/components/currency-ex-rates/currency-ex-rates.component';
import { CurrencyExRateHistComponent } from '@app/views/components/currency-ex-rate-hist/currency-ex-rate-hist.component';
import { CurrencyExRateComponent } from '@app/views/components/currency-ex-rate/currency-ex-rate.component';
import { CustGrpsComponent } from '@app/views/components/cust-grps/cust-grps.component';
import { CustGrp2sComponent } from '@app/views/components/cust-grp2s/cust-grp2s.component';
import { CustGrp2ViewComponent } from '@app/views/components/cust-grp2/cust-grp2-view/cust-grp2-view.component';
import { CustGrpMenuComponent } from '@app/views/components/cust-grp-menu/cust-grp-menu.component';
import { CustGrpLangsComponent } from '@app/views/components/cust-grp-langs/cust-grp-langs.component';
import { ValutaComponent } from '@app/views/components/valuta/valuta.component';
import { CustomsTarifsComponent } from '@app/views/components/customs-tarifs/customs-tarifs.component';
import { CustomsTarifMenuComponent } from '@app/views/components/customs-tarif-menu/customs-tarif-menu.component';
import { CustomsTarifLangComponent } from '@app/views/components/customs-tarif-lang/customs-tarif-lang.component';
import { CustomsTarifComponent } from '@app/views/components/customs-tarif/customs-tarif.component';
import { DbStationComponent } from '@app/views/components/db-station/db-station.component';
import { StockPlacesComponent } from '@app/views/components/stock-places/stock-places.component';
import { DeliveryMethodsComponent } from '@app/views/components/delivery-methods/delivery-methods.component';
import { DeliveryMethodServicesComponent } from '@app/views/components/delivery-method-services/delivery-method-services.component';
import { TranscarrierServiceActiveComponent } from '@app/views/components/transcarrier-service-active/transcarrier-service-active.component';
import { DeliveryMethodLangsComponent } from '@app/views/components/delivery-method-langs/delivery-method-langs.component';
import { DeliveryTermsComponent } from '@app/views/components/delivery-terms/delivery-terms.component';
import { DeliveryTermComponent } from '@app/views/components/delivery-term/delivery-term.component';
import { DeliveryTermLangsComponent } from '@app/views/components/delivery-term-langs/delivery-term-langs.component';
import { DepartmentsComponent } from '@app/views/components/departments/departments.component';
import { DepartmentMenuComponent } from '@app/views/components/department-menu/department-menu.component';
import { DepartmentLangComponent } from '@app/views/components/department-lang/department-lang.component';
import { DiscGrpCustsComponent } from '@app/views/components/disc-grp-custs/disc-grp-custs.component';
import { DiscGrpCustComponent } from '@app/views/components/disc-grp-cust/disc-grp-cust.component';
import { DiscGrpCustLangsComponent } from '@app/views/components/disc-grp-cust-langs/disc-grp-cust-langs.component';
import { DiscGrpProdsComponent } from '@app/views/components/disc-grp-prods/disc-grp-prods.component';
import { DiscGrpProdComponent } from '@app/views/components/disc-grp-prod/disc-grp-prod.component';
import { DiscGrpProdLangsComponent } from '@app/views/components/disc-grp-prod-langs/disc-grp-prod-langs.component';
import { DiscGrpDatasComponent } from '@app/views/components/disc-grp-datas/disc-grp-datas.component';
import { DocCategoriesComponent } from '@app/views/components/doc-categories/doc-categories.component';
import { DocCategoryComponent } from '@app/views/components/doc-category/doc-category.component';
import { DocCategoryLangComponent } from '@app/views/components/doc-category-lang/doc-category-lang.component';
import { ConsignmentPlansConsignmentContentComponent } from '@app/views/components/consignment-plans-consignment-content/consignment-plans-consignment-content.component';
import { DocPackTypesComponent } from '@app/views/components/doc-pack-types/doc-pack-types.component';
import { DocPackTypeMenuComponent } from '@app/views/components/doc-pack-type-menu/doc-pack-type-menu.component';
import { DocPackTypeComponent } from '@app/views/components/doc-pack-type/doc-pack-type.component';
import { DocPackComponent } from '@app/views/components/doc-pack/doc-pack.component';
import { DocPackTypeChapterComponent } from '@app/views/components/doc-pack-type-chapter/doc-pack-type-chapter.component';
import { EmailTemplatesComponent } from '@app/views/components/email-templates/email-templates.component';
import { EmailTemplateComponent } from '@app/views/components/email-template/email-template.component';
import { FabricsGrpsComponent } from '@app/views/components/fabrics-grps/fabrics-grps.component';
import { FabricsGrpComponent } from '@app/views/components/fabrics-grp/fabrics-grp.component';
import { FactoriesComponent } from '@app/views/components/factories/factories.component';
import { FactoryComponent } from '@app/views/components/factory/factory.component';
import { FactoryMenuComponent } from '@app/views/components/factory-menu/factory-menu.component';
import { OperationFactoriesComponent } from '@app/views/components/operation-factories/operation-factories.component';
import { OperationFactoryComponent } from '@app/views/components/operation-factory/operation-factory.component';
import { EquipmentListComponent } from '@app/views/components/equipment-list/equipment-list.component';
import { OeeStateEquipmentsComponent } from '@app/views/components/oee-state-equipments/oee-state-equipments.component';
import { OeeStateEquipmentComponent } from '@app/views/components/oee-state-equipment/oee-state-equipment.component';
import { OeeStateRemarksComponent } from '@app/views/components/oee-state-remarks/oee-state-remarks.component';
import { OeeStateRemarkComponent } from '@app/views/components/oee-state-remark/oee-state-remark.component';
import { WorkGrpsComponent } from '@app/views/components/work-grps/work-grps.component';
import { WorkGrpMenuComponent } from '@app/views/components/work-grp-menu/work-grp-menu.component';
import { WorkGrpComponent } from '@app/views/components/work-grp/work-grp.component';
import { EquipmentGrpsComponent } from '@app/views/components/equipment-grps/equipment-grps.component';
import { EquipmentGrpMenuComponent } from '@app/views/components/equipment-grp-menu/equipment-grp-menu.component';
import { EquipmentGrpLangComponent } from '@app/views/components/equipment-grp-lang/equipment-grp-lang.component';
import { EquipmentGrpComponent } from '@app/views/components/equipment-grp/equipment-grp.component';
import { FactoringsComponent } from '@app/views/components/factorings/factorings.component';
import { EmailCreateViewComponent } from '@app/views/components/email-create/email-create-view/email-create-view.component';
import { MaterialGradesViewComponent } from '@app/views/components/material-grades/material-grades-view/material-grades-view.component';
import { MaterialGradeViewComponent } from '@app/views/components/material-grade/material-grade-view/material-grade-view.component';
import { CertificateRequirementsViewComponent } from '@app/views/components/certificate-requirements/certificate-requirements-view/certificate-requirements-view.component';
import { UltraSonicClassesViewComponent } from '@app/views/components/ultra-sonic-classes/ultra-sonic-classes-view/ultra-sonic-classes-view.component';
import { MatcertCreateComponent } from '@app/views/components/oh-material-certificates/matcert-create/matcert-create.component';
import { MatcertComponent } from '@app/views/components/oh-material-certificates/matcert/matcert.component';
import { MaterialItemViewComponent } from '@app/views/components/material-item/material-item-view/material-item-view.component';
import { MaterialItemPickComponent } from '@app/views/components/material-item-pick/material-item-pick.component';
import { FactoringComponent } from '@app/views/components/factoring/factoring.component';
import { ForecastsComponent } from '@app/views/components/forecasts/forecasts.component';
import { ForecastComponent } from '@app/views/components/forecast/forecast.component';
import { FreightRateTypesComponent } from '@app/views/components/freight-rate-types/freight-rate-types.component';
import { FreightRateTypeComponent } from '@app/views/components/freight-rate-type/freight-rate-type.component';
import { FtpAccountsComponent } from '@app/views/components/ftp-accounts/ftp-accounts.component';
import { FtpAccountComponent } from '@app/views/components/ftp-account/ftp-account.component';
import { FurnitureFabricsSComponent } from '@app/views/components/furniture-fabrics-s/furniture-fabrics-s.component';
import { FurnitureFabricsMenuComponent } from '@app/views/components/furniture-fabrics-menu/furniture-fabrics-menu.component';
import { FurnitureFabricsColorsComponent } from '@app/views/components/furniture-fabrics-colors/furniture-fabrics-colors.component';
import { FurnitureFabricsColorComponent } from '@app/views/components/furniture-fabrics-color/furniture-fabrics-color.component';
import { AccountsComponent } from '@app/views/components/accounts/accounts.component';
import { AccountComponent } from '@app/views/components/account/account.component';
import { BusinessSComponent } from '@app/views/components/business-s/business-s.component';
import { BusinessMenuComponent } from '@app/views/components/business-menu/business-menu.component';
import { BusinessLangComponent } from '@app/views/components/business-lang/business-lang.component';
import { BusinessComponent } from '@app/views/components/business/business.component';
import { InterbranchMultiComponent } from '@app/views/components/interbranch-multi/interbranch-multi.component';
import { InterbranchMultiGetComponent } from '@app/views/components/interbranch-multi-get/interbranch-multi-get.component';
import { InterbranchLevelComponent } from '@app/views/components/interbranch-level/interbranch-level.component';
import { InvoiceMethodsComponent } from '@app/views/components/invoice-methods/invoice-methods.component';
import { InvoiceMethodComponent } from '@app/views/components/invoice-method/invoice-method.component';
import { InvoiceMethodLangsComponent } from '@app/views/components/invoice-method-langs/invoice-method-langs.component';
import { KpiCompsComponent } from '@app/views/components/kpi-comps/kpi-comps.component';
import { LanguagesComponent } from '@app/views/components/languages/languages.component';
import { LanguageLangsComponent } from '@app/views/components/language-langs/language-langs.component';
import { LanguageComponent } from '@app/views/components/language/language.component';
import { CarrierListComponent } from '@app/views/components/carrier-list/carrier-list.component';
import { ModelsComponent } from '@app/views/components/models/models.component';
import { ModelLangsComponent } from '@app/views/components/model-langs/model-langs.component';
import { ModelMenuComponent } from '@app/views/components/model-menu/model-menu.component';
import { ModelComponent } from '@app/views/components/model/model.component';
import { OperationMenuComponent } from '@app/views/components/operation-menu/operation-menu.component';
import { OperationLangsComponent } from '@app/views/components/operation-langs/operation-langs.component';
import { OperationComponent } from '@app/views/components/operation/operation.component';
import { OrderLineCancelCausesComponent } from '@app/views/components/order-line-cancel-causes/order-line-cancel-causes.component';
import { OrderLineCancelCauseComponent } from '@app/views/components/order-line-cancel-cause/order-line-cancel-cause.component';
import { OrderLineCancelCauseLangComponent } from '@app/views/components/order-line-cancel-cause-lang/order-line-cancel-cause-lang.component';
import { PersFactsComponent } from '@app/views/components/pers-facts/pers-facts.component';
import { PersFactsEditComponent } from '@app/views/components/pers-facts-edit/pers-facts-edit.component';
import { MetaTableViewsComponent } from '@app/views/components/meta-table-views/meta-table-views.component';
import { MetaTableViewComponent } from '@app/views/components/meta-table-view/meta-table-view.component';
import { MetaTableMenuComponent } from '@app/views/components/meta-table-menu/meta-table-menu.component';
import { MetaTableComponent } from '@app/views/components/meta-table/meta-table.component';
import { MetaColumnsComponent } from '@app/views/components/meta-columns/meta-columns.component';
import { MetaColumnComponent } from '@app/views/components/meta-column/meta-column.component';
import { MetaTablesComponent } from '@app/views/components/meta-tables/meta-tables.component';
import { ProdBeoMethodsComponent } from '@app/views/components/prod-beo-methods/prod-beo-methods.component';
import { PriceIndexesComponent } from '@app/views/components/price-indexes/price-indexes.component';
import { PriceIndexComponent } from '@app/views/components/price-index/price-index.component';
import { PriceIndexMenuComponent } from '@app/views/components/price-index-menu/price-index-menu.component';
import { ProductSettingsComponent } from '@app/views/components/product-settings/product-settings.component';
import { ProdGrpsComponent } from '@app/views/components/prod-grps/prod-grps.component';
import { ProdGrpComponent } from '@app/views/components/prod-grp/prod-grp.component';
import { ProdGrpLangsComponent } from '@app/views/components/prod-grp-langs/prod-grp-langs.component';
import { ProdGrp2Component } from '@app/views/components/prod-grp2/prod-grp2.component';
import { ProdGrp2MenuComponent } from '@app/views/components/prod-grp2-menu/prod-grp2-menu.component';
import { ProdGrp3MenuComponent } from '@app/views/components/prod-grp3-menu/prod-grp3-menu.component';
import { ProdGrp4MenuComponent } from '@app/views/components/prod-grp4-menu/prod-grp4-menu.component';
import { ProdGrp4Component } from '@app/views/components/prod-grp4/prod-grp4.component';
import { TextileModelCategory6sComponent } from '@app/views/components/textile-model-category6s/textile-model-category6s.component';
import { TextileModelCategory6Component } from '@app/views/components/textile-model-category6/textile-model-category6.component';
import { TextileModelCategory6LangComponent } from '@app/views/components/textile-model-category6-lang/textile-model-category6-lang.component';
import { ProductCategorysComponent } from '@app/views/components/product-categorys/product-categorys.component';
import { ProductCategoryComponent } from '@app/views/components/product-category/product-category.component';
import { ProductCategoryLangComponent } from '@app/views/components/product-category-lang/product-category-lang.component';
import { ProductCompositionsComponent } from '@app/views/components/product-compositions/product-compositions.component';
import { ProductCompositionComponent } from '@app/views/components/product-composition/product-composition.component';
import { ProductCompositionLangComponent } from '@app/views/components/product-composition-lang/product-composition-lang.component';
import { TextileModelCategory5sComponent } from '@app/views/components/textile-model-category5s/textile-model-category5s.component';
import { TextileModelCategory5Component } from '@app/views/components/textile-model-category5/textile-model-category5.component';
import { TextileModelCategory5LangComponent } from '@app/views/components/textile-model-category5-lang/textile-model-category5-lang.component';
import { TextileModelCategory4sComponent } from '@app/views/components/textile-model-category4s/textile-model-category4s.component';
import { TextileModelCategory4Component } from '@app/views/components/textile-model-category4/textile-model-category4.component';
import { TextileModelCategory4LangComponent } from '@app/views/components/textile-model-category4-lang/textile-model-category4-lang.component';
import { TextileModelCategory7sComponent } from '@app/views/components/textile-model-category7s/textile-model-category7s.component';
import { TextileModelCategory7Component } from '@app/views/components/textile-model-category7/textile-model-category7.component';
import { TextileModelCategory7LangComponent } from '@app/views/components/textile-model-category7-lang/textile-model-category7-lang.component';
import { TextileModelCategory8sComponent } from '@app/views/components/textile-model-category8s/textile-model-category8s.component';
import { TextileModelCategory8Component } from '@app/views/components/textile-model-category8/textile-model-category8.component';
import { TextileModelCategory8LangComponent } from '@app/views/components/textile-model-category8-lang/textile-model-category8-lang.component';
import { ProdBeoMethodLangsComponent } from '@app/views/components/prod-beo-method-langs/prod-beo-method-langs.component';
import { ProductionRoutingsComponent } from '@app/views/components/production-routings/production-routings.component';
import { ProductionRoutingMenuComponent } from '@app/views/components/production-routing-menu/production-routing-menu.component';
import { ProductionRoutingComponent } from '@app/views/components/production-routing/production-routing.component';
import { ProductionRoutingCompViewComponent } from '@app/views/components/production-routing-comp/production-routing-comp-view/production-routing-comp-view.component';
import { OperationsComponent } from '@app/views/components/operations/operations.component';
import { PropertyClassesComponent } from '@app/views/components/property-classes/property-classes.component';
import { PropertyClassLangsComponent } from '@app/views/components/property-class-langs/property-class-langs.component';
import { SaftMainGroupsComponent } from '@app/views/components/saft-main-groups/saft-main-groups.component';
import { SaftMainGroupComponent } from '@app/views/components/saft-main-group/saft-main-group.component';
import { OrderStatusesComponent } from '@app/views/components/order-statuses/order-statuses.component';
import { OrderStatusLangsComponent } from '@app/views/components/order-status-langs/order-status-langs.component';
import { UserGroupsComponent } from '@app/views/components/user-groups/user-groups.component';
import { UserGroupViewComponent } from '@app/views/components/user-group/user-group-view/user-group-view.component';
import { SeasonalitiesComponent } from '@app/views/components/seasonalities/seasonalities.component';
import { SeasonalityComponent } from '@app/views/components/seasonality/seasonality.component';
import { CustomerEditComponent } from '@app/views/components/customer-edit/customer-edit.component';
import { CustomersMenuComponent } from '@app/views/components/customers-menu/customers-menu.component';
import { CustomerClaimsComponent } from '@app/views/components/customer-claims/customer-claims.component';
import { PersonComponent } from '@app/views/components/person/person.component';
import { PostplaceViewComponent } from '@app/views/components/postplace/postplace-view/postplace-view.component';
import { SopsComponent } from '@app/views/components/sops/sops.component';
import { SopMenuComponent } from '@app/views/components/sop-menu/sop-menu.component';
import { SopComponent } from '@app/views/components/sop/sop.component';
import { ServiceObjectTypesComponent } from '@app/views/components/service-object-types/service-object-types.component';
import { ServiceObjectTypeMenuComponent } from '@app/views/components/service-object-type-menu/service-object-type-menu.component';
import { ServiceObjectTypeIntsComponent } from '@app/views/components/service-object-type-ints/service-object-type-ints.component';
import { ServiceObjectTypeComponent } from '@app/views/components/service-object-type/service-object-type.component';
import { SkillsCertificateTypesComponent } from '@app/views/components/skills-certificate-types/skills-certificate-types.component';
import { SelectGlyphiconComponent } from '@app/views/components/select-glyphicon/select-glyphicon.component';
import { P2StatSourceComponent } from '@app/views/components/p2-stat-source/p2-stat-source.component';
import { P2StatSourceEditComponent } from '@app/views/components/p2-stat-source-edit/p2-stat-source-edit.component';
import { StockCorrCodesComponent } from '@app/views/components/stock-corr-codes/stock-corr-codes.component';
import { StockCorrCodeComponent } from '@app/views/components/stock-corr-code/stock-corr-code.component';
import { StockCorrCodeLangsComponent } from '@app/views/components/stock-corr-code-langs/stock-corr-code-langs.component';
import { StockZoneMenuComponent } from '@app/views/components/stock-zone-menu/stock-zone-menu.component';
import { StockZoneComponent } from '@app/views/components/stock-zone/stock-zone.component';
import { StockLocationComponent } from '@app/views/components/stock-location/stock-location.component';
import { P2TerminalsComponent } from '@app/views/components/p2-terminals/p2-terminals.component';
import { P2TerminalComponent } from '@app/views/components/p2-terminal/p2-terminal.component';
import { PaymentsComponent } from '@app/views/components/payments/payments.component';
import { PaymentComponent } from '@app/views/components/payment/payment.component';
import { PaymentLangsComponent } from '@app/views/components/payment-langs/payment-langs.component';
import { AcLedgerViewComponent } from '@app/views/components/ac-ledger-view/ac-ledger-view.component';
import { AcLedgerComponent } from '@app/views/components/ac-ledger/ac-ledger.component';
import { CoopsComponent } from '@app/views/components/coops/coops.component';
import { CoopComponent } from '@app/views/components/coop/coop.component';
import { CoopLangsComponent } from '@app/views/components/coop-langs/coop-langs.component';
import { TravExpTypeMenuComponent } from '@app/views/components/trav-exp-type-menu/trav-exp-type-menu.component';
import { TravExpTypesComponent } from '@app/views/components/trav-exp-types/trav-exp-types.component';
import { TravelWageSetsComponent } from '@app/views/components/travel-wage-sets/travel-wage-sets.component';
import { TravelWageSetMenuComponent } from '@app/views/components/travel-wage-set-menu/travel-wage-set-menu.component';
import { TravelWageSetComponent } from '@app/views/components/travel-wage-set/travel-wage-set.component';
import { UnitsComponent } from '@app/views/components/units/units.component';
import { UnitLangComponent } from '@app/views/components/unit-lang/unit-lang.component';
import { AcVatCodesComponent } from '@app/views/components/ac-vat-codes/ac-vat-codes.component';
import { AcVatCodeComponent } from '@app/views/components/ac-vat-code/ac-vat-code.component';
import { AcVatCodeDataComponent } from '@app/views/components/ac-vat-code-data/ac-vat-code-data.component';
import { DomObjectTypesComponent } from '@app/views/components/dom-object-types/dom-object-types.component';
import { DomObjectTypeMenuComponent } from '@app/views/components/dom-object-type-menu/dom-object-type-menu.component';
import { DomObjectTypePropComponent } from '@app/views/components/dom-object-type-prop/dom-object-type-prop.component';
import { DomObjectTypeComponent } from '@app/views/components/dom-object-type/dom-object-type.component';
import { DomObjectComponent } from '@app/views/components/dom-object/dom-object.component';
import { ChoicePossRuleComponent } from '@app/views/components/choice-poss-rule/choice-poss-rule.component';
import { ChoicePossRulesComponent } from '@app/views/components/choice-poss-rules/choice-poss-rules.component';
import { ChoicePossRulesRunComponent } from '@app/views/components/choice-poss-rules-run/choice-poss-rules-run.component';
import { PostPlacesComponent } from '@app/views/components/post-places/post-places.component';
import { AccountingAllocationsComponent } from '@app/views/components/accounting-allocations/accounting-allocations.component';
import { AccountingAllocationComponent } from '@app/views/components/accounting-allocation/accounting-allocation.component';
import { AccountingAllocationBasisComponent } from '@app/views/components/accounting-allocation-basis/accounting-allocation-basis.component';
import { AccountingAllocationLineComponent } from '@app/views/components/accounting-allocation-line/accounting-allocation-line.component';
import { GuardListComponent } from '@app/views/components/guard-list/guard-list.component';
import { CheckInMenuComponent } from '@app/views/components/check-in-menu/check-in-menu.component';
import { CheckInStatusComponent } from '@app/views/components/check-in-status/check-in-status.component';
import { P2OffDutyDatasComponent } from '@app/views/components/p2-off-duty-datas/p2-off-duty-datas.component';
import { PayCheckBatchesComponent } from '@app/views/components/pay-check-batches/pay-check-batches.component';
import { PowTimeApprovalsComponent } from '@app/views/components/pow-time-approvals/pow-time-approvals.component';
import { SalaryTypesComponent } from '@app/views/components/salary-types/salary-types.component';
import { SalaryTypeLangComponent } from '@app/views/components/salary-type-lang/salary-type-lang.component';
import { LabourSalaryTypesComponent } from '@app/views/components/labour-salary-types/labour-salary-types.component';
import { LabourSalaryTypeComponent } from '@app/views/components/labour-salary-type/labour-salary-type.component';
import { OffDutyCodesComponent } from '@app/views/components/off-duty-codes/off-duty-codes.component';
import { OffDutyCodeComponent } from '@app/views/components/off-duty-code/off-duty-code.component';
import { HolidaysViewComponent } from '@app/views/components/holidays-view/holidays-view.component';
import { HolidaysComponent } from '@app/views/components/holidays/holidays.component';
import { HolidayComponent } from '@app/views/components/holiday/holiday.component';
import { SubscriptionGridComponent } from '@app/views/components/subscription-grid/subscription-grid.component';
import { InfoScreenComponent } from '@app/views/components/info-screen/info-screen.component';
import { ServiceObjectsComponent } from '@app/views/components/service-objects/service-objects.component';
import { ServiceObjectComponent } from '@app/views/components/service-object/service-object.component';
import { FindPersonComponent } from '@app/views/components/find-person/find-person.component';
import { CustomerPersonsComponent } from '@app/views/components/customer-persons/customer-persons.component';
import { CustomerDiscGrpProdComponent } from '@app/views/components/customer-disc-grp-prod/customer-disc-grp-prod.component';
import { CheckListDatasComponent } from '@app/views/components/check-list-datas/check-list-datas.component';
import { CustFactsComponent } from '@app/views/components/cust-facts/cust-facts.component';
import { ActivityGridComponent } from '@app/views/components/activity-grid/activity-grid.component';
import { CustactDeadLinesComponent } from '@app/views/components/custact-dead-lines/custact-dead-lines.component';
import { RfidSearchComponent } from '@app/views/components/rfid-search/rfid-search.component';
import { IncomingCallComponent } from '@app/views/components/incoming-call/incoming-call.component';
import { VisitorComponent } from '@app/views/components/visitor/visitor.component';
import { WebPageSubscriptionComponent } from '@app/views/components/web-page-subscription/web-page-subscription.component';
import { WebPageLinkComponent } from '@app/views/components/web-page-link/web-page-link.component';
import { WebsitesComponent } from '@app/views/components/websites/websites.component';
import { MetaTableDatasComponent } from '@app/views/components/meta-table-datas/meta-table-datas.component';
import { SelectArticlesComponent } from '@app/views/components/select-articles/select-articles.component';
import { PurchPlanningComponent } from '@app/views/components/purch-planning/purch-planning.component';
import { StockGetComponent } from '@app/views/components/stock-get/stock-get.component';
import { StockOnLocationComponent } from '@app/views/components/stock-on-location/stock-on-location.component';
import { StockAllComponent } from '@app/views/components/stock-all/stock-all.component';
import { StockIncomingComponent } from '@app/views/components/stock-incoming/stock-incoming.component';
import { CreatePoPuComponent } from '@app/views/components/create-po-pu/create-po-pu.component';
import { StockHistoryComponent } from '@app/views/components/stock-history/stock-history.component';
import { PohTopComponent } from '@app/views/components/poh-top/poh-top.component';
import { OrderlineCalcFormViewComponent } from '@app/views/components/orderline-calc-form/orderline-calc-form-view/orderline-calc-form-view.component';
import { CalcCopyFromViewComponent } from '@app/views/components/calc-copy-from/calc-copy-from-view/calc-copy-from-view.component';
import { PohComponent } from '@app/views/components/poh/poh.component';
import { StockOutgoingComponent } from '@app/views/components/stock-outgoing/stock-outgoing.component';
import { StockStatusComponent } from '@app/views/components/stock-status/stock-status.component';
import { StockStatusDrillDownComponent } from '@app/views/components/stock-status-drill-down/stock-status-drill-down.component';
import { SelectCheckListAddComponent } from '@app/views/components/select-check-list-add/select-check-list-add.component';
import { ProductPricesComponent } from '@app/views/components/product-prices/product-prices.component';
import { PriceComponent } from '@app/views/components/price/price.component';
import { PriceListFactorsComponent } from '@app/views/components/price-list-factors/price-list-factors.component';
import { ComponentsComponent } from '@app/views/components/components/components.component';
import { ComponentAlternativesComponent } from '@app/views/components/component-alternatives/component-alternatives.component';
import { ComponentAlternativeComponent } from '@app/views/components/component-alternative/component-alternative.component';
import { ProductPicsComponent } from '@app/views/components/product-pics/product-pics.component';
import { ProductPicComponent } from '@app/views/components/product-pic/product-pic.component';
import { ChoicesComponent } from '@app/views/components/choices/choices.component';
import { ChoiceComponent } from '@app/views/components/choice/choice.component';
import { ChoicePossibilityListComponent } from '@app/views/components/choice-possibility-list/choice-possibility-list.component';
import { ProdSizesComponent } from '@app/views/components/prod-sizes/prod-sizes.component';
import { ProdSizeEditComponent } from '@app/views/components/prod-size-edit/prod-size-edit.component';
import { ProdSizeColliComponent } from '@app/views/components/prod-size-colli/prod-size-colli.component';
import { ProductLinksComponent } from '@app/views/components/product-links/product-links.component';
import { ProductLinkComponent } from '@app/views/components/product-link/product-link.component';
import { ProductLinksChangeComponent } from '@app/views/components/product-links-change/product-links-change.component';
import { ProductMultiUnitComponent } from '@app/views/components/product-multi-unit/product-multi-unit.component';
import { ProductUnitsComponent } from '@app/views/components/product-units/product-units.component';
import { ProductUnitComponent } from '@app/views/components/product-unit/product-unit.component';
import { ProductUnitsEditComponent } from '@app/views/components/product-units-edit/product-units-edit.component';
import { ProductUnitDataComponent } from '@app/views/components/product-unit-data/product-unit-data.component';
import { ProductEansComponent } from '@app/views/components/product-eans/product-eans.component';
import { EdgeRelationsComponent } from '@app/views/components/edge-relations/edge-relations.component';
import { SelectableProductsComponent } from '@app/views/components/selectable-products/selectable-products.component';
import { ComponentReplacementsComponent } from '@app/views/components/component-replacements/component-replacements.component';
import { ProductWasteComponent } from '@app/views/components/product-waste/product-waste.component';
import { PriceListsComponent } from '@app/views/components/price-lists/price-lists.component';
import { PriceListComponent } from '@app/views/components/price-list/price-list.component';
import { PriceListBusCosComponent } from '@app/views/components/price-list-bus-cos/price-list-bus-cos.component';
import { PriceListBusCoComponent } from '@app/views/components/price-list-bus-co/price-list-bus-co.component';
import { CollectionsComponent } from '@app/views/components/collections/collections.component';
import { CollectionMenuComponent } from '@app/views/components/collection-menu/collection-menu.component';
import { CollectionLangsComponent } from '@app/views/components/collection-langs/collection-langs.component';
import { CollectionComponent } from '@app/views/components/collection/collection.component';
import { ProductLangsComponent } from '@app/views/components/product-langs/product-langs.component';
import { ProductLangComponent } from '@app/views/components/product-lang/product-lang.component';
import { PrepareBomsComponent } from '@app/views/components/prepare-boms/prepare-boms.component';
import { TextileStockSearchComponent } from '@app/views/components/textile-stock-search/textile-stock-search.component';
import { StockBatchSearchComponent } from '@app/views/components/stock-batch-search/stock-batch-search.component';
import { StockBatchCorrQtyComponent } from '@app/views/components/stock-batch-corr-qty/stock-batch-corr-qty.component';
import { StockCorrectionsComponent } from '@app/views/components/stock-corrections/stock-corrections.component';
import { DefaultCountersComponent } from '@app/views/components/default-counters/default-counters.component';
import { StockHistoricComponent } from '@app/views/components/stock-historic/stock-historic.component';
import { StockControlSpListComponent } from '@app/views/components/stock-control-sp-list/stock-control-sp-list.component';
import { BusinessCoDefaultCountersComponent } from '@app/views/components/business-co-default-counters/business-co-default-counters.component';
import { BusinessCoDefaultCounterComponent } from '@app/views/components/business-co-default-counter/business-co-default-counter.component';
import { StockCountsComponent } from '@app/views/components/stock-counts/stock-counts.component';
import { StockCountMenuComponent } from '@app/views/components/stock-count-menu/stock-count-menu.component';
import { StockCountDataComponent } from '@app/views/components/stock-count-data/stock-count-data.component';
import { ChargesComponent } from '@app/views/components/charges/charges.component';
import { StockCountDatasComponent } from '@app/views/components/stock-count-datas/stock-count-datas.component';
import { StockCountRefreshComponent } from '@app/views/components/stock-count-refresh/stock-count-refresh.component';
import { StockCountComponent } from '@app/views/components/stock-count/stock-count.component';
import { StockCountResultComponent } from '@app/views/components/stock-count-result/stock-count-result.component';
import { StockTransfersComponent } from '@app/views/components/stock-transfers/stock-transfers.component';
import { StockTransferCreateComponent } from '@app/views/components/stock-transfer-create/stock-transfer-create.component';
import { RequisitionsComponent } from '@app/views/components/requisitions/requisitions.component';
import { RequisitionComponent } from '@app/views/components/requisition/requisition.component';
import { RequisitionSimplifiedComponent } from '@app/views/components/requisition-simplified/requisition-simplified.component';
import { AiChatComponent } from '@app/core/components/ai-chat/ai-chat.component';
import { CuttingPlansComponent } from '@app/views/components/cutting-plans/cutting-plans.component';
import { CuttingPlanPoAddComponent } from '@app/views/components/cutting-plan-po-add/cutting-plan-po-add.component';
import { PoLoadPlanComponent } from '@app/views/components/po-load-plan/po-load-plan.component';
import { PoComponent } from '@app/views/components/po/po.component';
import { ShopFloorSelectOhComponent } from '@app/views/components/shop-floor-select-oh/shop-floor-select-oh.component';
import { RequisitionPlanViewComponent } from '@app/views/components/requisition-plan-view/requisition-plan-view.component';
import { RequisitionCreateComponent } from '@app/views/components/requisition-create/requisition-create.component';
import { StockTransferLogComponent } from '@app/views/components/stock-transfer-log/stock-transfer-log.component';
import { OeeStatesComponent } from '@app/views/components/oee-states/oee-states.component';
import { OeeStateEditComponent } from '@app/views/components/oee-state-edit/oee-state-edit.component';
import { EquipmentsComponent } from '@app/views/components/equipments/equipments.component';
import { MaterialItemsComponent } from '@app/views/components/material-items/material-items.component';
import { LabourPositionsComponent } from '@app/views/components/labour-positions/labour-positions.component';
import { PaperlessProductionComponent } from '@app/views/components/paperless-production/paperless-production.component';
import { PaperlessPoComponent } from '@app/views/components/paperless-po/paperless-po.component';
import { OrderLineCreditsComponent } from '@app/views/components/order-line-credits/order-line-credits.component';
import { ConsignmentShipmentsComponent } from '@app/views/components/consignment-shipments/consignment-shipments.component';
import { ConsignmentShipmentComponent } from '@app/views/components/consignment-shipment/consignment-shipment.component';
import { PickJobGrpBatchesPickerComponent } from '@app/views/components/pick-job-grp-batches-picker/pick-job-grp-batches-picker.component';
import { PickJobGrpBatchesComponent } from '@app/views/components/pick-job-grp-batches/pick-job-grp-batches.component';
//import { SubtasksComponent } from '@app/views/components/subtasks/subtasks.component';
import { ConsignmentBatchConsignmentsComponent } from '@app/views/components/consignment-batch-consignments/consignment-batch-consignments.component';
import { RequisitionsBetweenComponent } from '@app/views/components/requisitions-between/requisitions-between.component';
import { TravelBillsComponent } from '@app/views/components/travel-bills/travel-bills.component';
import { TravelWageDataComponent } from '@app/views/components/travel-wage-data/travel-wage-data.component';
import { TravelBillMenuComponent } from '@app/views/components/travel-bill-menu/travel-bill-menu.component';
import { AcCustTransesAgeComponent } from '@app/views/components/ac-cust-transes-age/ac-cust-transes-age.component';
import { VatReportsComponent } from '@app/views/components/vat-reports/vat-reports.component';
import { VatReportComponent } from '@app/views/components/vat-report/vat-report.component';
import { VatSpesificationComponent } from '@app/views/components/vat-spesification/vat-spesification.component';
import { ReceivablesComponent } from '@app/views/components/receivables/receivables.component';
import { BankReconciliationsComponent } from '@app/views/components/bank-reconciliations/bank-reconciliations.component';
import { CollectionCalculationComponent } from '@app/views/components/collection-calculation/collection-calculation.component';
import { InterbranchInvoicingComponent } from '@app/views/components/interbranch-invoicing/interbranch-invoicing.component';
import { InterbranchInvoicingMiComponent } from '@app/views/components/interbranch-invoicing-mi/interbranch-invoicing-mi.component';
import { CustomerInvoicingsComponent } from '@app/views/components/customer-invoicings/customer-invoicings.component';
import { CustomerInvoicingComponent } from '@app/views/components/customer-invoicing/customer-invoicing.component';
import { DataMiningListComponent } from '@app/views/components/data-mining-list/data-mining-list.component';
import { DataMiningTableComponent } from '@app/views/components/data-mining-table/data-mining-table.component';
import { AccountingBuntsComponent } from '@app/views/components/accounting-bunts/accounting-bunts.component';
import { AcVoucherTypesComponent } from '@app/views/components/ac-voucher-types/ac-voucher-types.component';
import { FactoringBuntsComponent } from '@app/views/components/factoring-bunts/factoring-bunts.component';
import { FactoringBuntComponent } from '@app/views/components/factoring-bunt/factoring-bunt.component';
import { ProjectInvoicingsComponent } from '@app/views/components/project-invoicings/project-invoicings.component';
import { ProjectInvoicingComponent } from '@app/views/components/project-invoicing/project-invoicing.component';
import { TimeInOutsComponent } from '@app/views/components/time-in-outs/time-in-outs.component';
import { PowTimePayCheckLsComponent } from '@app/views/components/pow-time-pay-check-ls/pow-time-pay-check-ls.component';
import { DeviationsComponent } from '@app/views/components/deviations/deviations.component';
import { DeviationComponent } from '@app/views/components/deviation/deviation.component';
import { CustactMembersComponent } from '@app/views/components/custact-members/custact-members.component';
import { CustactCustomersComponent } from '@app/views/components/custact-customers/custact-customers.component';
import { CustactCustomerComponent } from '@app/views/components/custact-customer/custact-customer.component';
import { BiReportsComponent } from '@app/views/components/bi-reports/bi-reports.component';
import { AcSuppTransesAgeComponent } from '@app/views/components/ac-supp-transes-age/ac-supp-transes-age.component';
import { AcSuppTransComponent } from '@app/views/components/ac-supp-trans/ac-supp-trans.component';
import { AcSuppTransesComponent } from '@app/views/components/ac-supp-transes/ac-supp-transes.component';
import { AcCustTransComponent } from '@app/views/components/ac-cust-trans/ac-cust-trans.component';
import { AcCustTransesComponent } from '@app/views/components/ac-cust-transes/ac-cust-transes.component';
import { DoDataImpsComponent } from '@app/views/components/do-data-imps/do-data-imps.component';
import { DataImpsComponent } from '@app/views/components/data-imps/data-imps.component';
import { DataImpComponent } from '@app/views/components/data-imp/data-imp.component';
import { GridExportsComponent } from '@app/views/components/grid-exports/grid-exports.component';
import { P2ExportProcsComponent } from '@app/views/components/p2-export-procs/p2-export-procs.component';
import { P2ExportProcMenuComponent } from '@app/views/components/p2-export-proc-menu/p2-export-proc-menu.component';
import { P2ExportProcUserGroupsComponent } from '@app/views/components/p2-export-proc-user-groups/p2-export-proc-user-groups.component';
import { P2ImportProcsComponent } from '@app/views/components/p2-import-procs/p2-import-procs.component';
import { P2ImportProcComponent } from '@app/views/components/p2-import-proc/p2-import-proc.component';
import { JobSchedulesComponent } from '@app/views/components/job-schedules/job-schedules.component';
import { JobQueueMonitorComponent } from '@app/views/components/job-queue-monitor/job-queue-monitor.component';
import { DocArticleSearchComponent } from '@app/views/components/doc-article-search/doc-article-search.component';
import { EdiImportsComponent } from '@app/views/components/edi-imports/edi-imports.component';
import { EdiExportsComponent } from '@app/views/components/edi-exports/edi-exports.component';
import { EdiSourcesComponent } from '@app/views/components/edi-sources/edi-sources.component';
import { EdiDestinationsComponent } from '@app/views/components/edi-destinations/edi-destinations.component';
import { EdiImportFileUploadComponent } from '@app/views/components/edi-import-file-upload/edi-import-file-upload.component';
import { TimeSheetsComponent } from '@app/views/components/time-sheets/time-sheets.component';
import { BspsComponent } from '@app/views/components/bsps/bsps.component';
import { MieTablesComponent } from '@app/views/components/mie-tables/mie-tables.component';
import { MsgCreateComponent } from '@app/views/components/msg-create/msg-create.component';
import { MenuGrpsComponent } from '@app/views/components/menu-grps/menu-grps.component';
import { BatchDeliveriesComponent } from '@app/views/components/batch-deliveries/batch-deliveries.component';
import { BatchDelPurchLineComponent } from '@app/views/components/batch-del-purch-line/batch-del-purch-line.component';
import { BatchDelPurchLinesBsComponent } from '@app/views/components/batch-del-purch-lines-bs/batch-del-purch-lines-bs.component';
import { BatchDeliveryAddComponent } from '@app/views/components/batch-delivery-add/batch-delivery-add.component';
import { BatchDeliveryListComponent } from '@app/views/components/batch-delivery-list/batch-delivery-list.component';
import { BatchDelReceiveLinesComponent } from '@app/views/components/batch-del-receive-lines/batch-del-receive-lines.component';
import { BatchDelControlComponent } from '@app/views/components/batch-del-control/batch-del-control.component';
import { BdScanDetailComponent } from '@app/views/components/bd-scan-detail/bd-scan-detail.component';
import { BatchDelReceiveLineComponent } from '@app/views/components/batch-del-receive-line/batch-del-receive-line.component';
import { BusinessCosComponent } from '@app/views/components/business-cos/business-cos.component';
import { CheckListsComponent } from '@app/views/components/check-lists/check-lists.component';
import { CheckPointsComponent } from '@app/views/components/check-points/check-points.component';
import { CheckPointHeadsComponent } from '@app/views/components/check-point-heads/check-point-heads.component';
import { ColorGrpsComponent } from '@app/views/components/color-grps/color-grps.component';
import { ColorGrpMenuComponent } from '@app/views/components/color-grp-menu/color-grp-menu.component';
import { ColorGrpLangComponent } from '@app/views/components/color-grp-lang/color-grp-lang.component';
import { ColorGrpComponent } from '@app/views/components/color-grp/color-grp.component';
import { ConsignmentLineComponent } from '@app/views/components/consignment-line/consignment-line.component';
import { ConsignmentLinesBsComponent } from '@app/views/components/consignment-lines-bs/consignment-lines-bs.component';
import { ConsignmentLinesBComponent } from '@app/views/components/consignment-lines-b/consignment-lines-b.component';
import { ConsignmentLinesComponent } from '@app/views/components/consignment-lines/consignment-lines.component';
import { ConsignmentOlComponent } from '@app/views/components/consignment-ol/consignment-ol.component';
import { CustactWorksComponent } from '@app/views/components/custact-works/custact-works.component';
import { CustactMemberEditComponent } from '@app/views/components/custact-member-edit/custact-member-edit.component';
import { CustomerBusCosComponent } from '@app/views/components/customer-bus-cos/customer-bus-cos.component';
import { CustomerBusCoComponent } from '@app/views/components/customer-bus-co/customer-bus-co.component';
import { DataMiningCreateComponent } from '@app/views/components/data-mining-create/data-mining-create.component';
import { DeliveryCustomersComponent } from '@app/views/components/delivery-customers/delivery-customers.component';
import { DeliveryCustomerComponent } from '@app/views/components/delivery-customer/delivery-customer.component';
import { DeviationTypeMenuComponent } from '@app/views/components/deviation-type-menu/deviation-type-menu.component';
import { DeviationTypeLangsComponent } from '@app/views/components/deviation-type-langs/deviation-type-langs.component';
import { EdiDestinationComponent } from '@app/views/components/edi-destination/edi-destination.component';
import { EdiSourceComponent } from '@app/views/components/edi-source/edi-source.component';
import { ExternalApisComponent } from '@app/views/components/external-apis/external-apis.component';
import { ExternalApiComponent } from '@app/views/components/external-api/external-api.component';
import { FreightRateSetsComponent } from '@app/views/components/freight-rate-sets/freight-rate-sets.component';
import { FreightRateComponent } from '@app/views/components/freight-rate/freight-rate.component';
import { InvoiceMakeMultiOrdersComponent } from '@app/views/components/invoice-make-multi-orders/invoice-make-multi-orders.component';
import { InvoiceMakeOverviewComponent } from '@app/views/components/invoice-make-overview/invoice-make-overview.component';
import { LabourJobNoteComponent } from '@app/views/components/labour-job-note/labour-job-note.component';
import { OhDirectDeliveryComponent } from '@app/views/components/oh-direct-delivery/oh-direct-delivery.component';
import { OhDispatchesComponent } from '@app/views/components/oh-dispatches/oh-dispatches.component';
import { OrderHeadCalcsComponent } from '@app/views/components/order-head-calcs/order-head-calcs.component';
import { OrderDeliveryInfoComponent } from '@app/views/components/order-delivery-info/order-delivery-info.component';
import { OrderHeadSetDiscComponent } from '@app/views/components/order-head-set-disc/order-head-set-disc.component';
import { OrderLineMsComponent } from '@app/views/components/order-line-ms/order-line-ms.component';
import { OrderLineStatusComponent } from '@app/views/components/order-line-status/order-line-status.component';
import { OrderPurchMenuComponent } from '@app/views/components/order-purch-menu/order-purch-menu.component';
import { PoMenuComponent } from '@app/views/components/po-menu/po-menu.component';
import { PortalUserSignatureComponent } from '@app/views/components/portal-user-signature/portal-user-signature.component';
import { PositionsComponent } from '@app/views/components/positions/positions.component';
import { PositionComponent } from '@app/views/components/position/position.component';
import { PrepaymentsComponent } from '@app/views/components/prepayments/prepayments.component';
import { PrepaymentComponent } from '@app/views/components/prepayment/prepayment.component';
import { PrepickCreateComponent } from '@app/views/components/prepick-create/prepick-create.component';
import { SelectShiftComponent } from '@app/views/components/select-shift/select-shift.component';
import { SelectOperationPuComponent } from '@app/views/components/select-operation-pu/select-operation-pu.component';
import { SelectPortalUserComponent } from '@app/views/components/select-portal-user/select-portal-user.component';
import { SelectEquipmentPuComponent } from '@app/views/components/select-equipment-pu/select-equipment-pu.component';
import { CuttingPlanComponent } from '@app/views/components/cutting-plan/cutting-plan.component';
import { CuttingPlanRealComponent } from '@app/views/components/cutting-plan-real/cutting-plan-real.component';
import { TT_VIEW_NAVIGATOR, createPageNavigator, createPopupNavigator } from '../../app/modal/state-modal/state-modal.component';
import { Transition } from '@uirouter/angularjs';
import { OrderHeadsComponent } from '../../app/views/components/order-heads/order-heads.component';
import { OrderHeadMiComponent } from '../../app/views/components/order-head-mi/order-head-mi.component';
import { RelatedPurchOrdersComponent } from '@app/views/components/related-purch-orders/related-purch-orders.component';
import { RequisitionCreateFromComponent } from '@app/views/components/requisition-create-from/requisition-create-from.component';
import { ProjectProcessesComponent } from '@app/views/components/project-processes/project-processes.component';
import { ProductViewComponent } from '@app/views/components/product-view/product-view.component';
import { ServiceObjectNewActComponent } from '@app/views/components/service-object-new-act/service-object-new-act.component';
import { ShipmentContainersComponent } from '@app/views/components/shipment-containers/shipment-containers.component';
import { ShipmentContainerComponent } from '@app/views/components/shipment-container/shipment-container.component';
import { SopClsComponent } from '@app/views/components/sop-cls/sop-cls.component';
import { AccountingProcessingComponent } from '../../app/views/components/accounting-processing/accounting-processing.component';
import { SopClComponent } from '../../app/views/components/sop-cl/sop-cl.component';
import { StockBatchListComponent } from '../../app/views/components/stock-batch-list/stock-batch-list.component';
import { StockStockBatchAssignedComponent } from '../../app/views/components/stock-stock-batch-assigned/stock-stock-batch-assigned.component';
import { StockTransAllocationsComponent } from '../../app/views/components/stock-trans-allocations/stock-trans-allocations.component';
import { StockTransMenuComponent } from '../../app/views/components/stock-trans-menu/stock-trans-menu.component';
import { StockVariantsComponent } from '../../app/views/components/stock-variants/stock-variants.component';
import { SubscriptionsComponent } from '../../app/views/components/subscriptions/subscriptions.component';
import { TimeCustomersComponent } from '../../app/views/components/time-customers/time-customers.component';
import { TimeCustomersWoComponent } from '@app/views/components/time-customers-wo/time-customers-wo.component';
import { TimeProjectsComponent } from '@app/views/components/time-projects/time-projects.component';
import { TimeSheetPowTimeListComponent } from '@app/views/components/time-sheet-pow-time-list/time-sheet-pow-time-list.component';
import { TravelWagesComponent } from '@app/views/components/travel-wages/travel-wages.component';
import { ValutasComponent } from '@app/views/components/valutas/valutas.component';
import { VisitorConfirmComponent } from '@app/views/components/visitor-confirm/visitor-confirm.component';
import { UnitComponent } from '@app/views/components/unit/unit.component';
import { TravExpTypeComponent } from '@app/views/components/trav-exp-type/trav-exp-type.component';
import { TrMenuComponent } from '@app/views/components/tr-menu/tr-menu.component';
import { TrNewJobSelectOpComponent } from '@app/views/components/tr-new-job-select-op/tr-new-job-select-op.component';
import { TravelBillRejectComponent } from '@app/views/components/travel-bill-reject/travel-bill-reject.component';
import { SopValidComponent } from '@app/views/components/sop-valid/sop-valid.component';
import { SelectTextileModelComponent } from '@app/views/components/select-textile-model/select-textile-model.component';
import { SelectStockLocationComponent } from '@app/views/components/select-stock-location/select-stock-location.component';
import { MultiDocComponent } from '@app/views/components/multi-doc/multi-doc.component';
import { DeviationTypesComponent } from '@app/views/components/deviation-types/deviation-types.component';
import { CustactCalcAdjustDiscComponent } from '@app/views/components/custact-calc-adjust-disc/custact-calc-adjust-disc.component';
import { CustactCalcPickSelectComponent } from '@app/views/components/custact-calc-pick-select/custact-calc-pick-select.component';
import { CheckListItemItemsComponent } from '@app/views/components/check-list-item-items/check-list-item-items.component';
import { CheckListItemItemComponent } from '@app/views/components/check-list-item-item/check-list-item-item.component';
import { CargonizerPrintersComponent } from '@app/views/components/cargonizer-printers/cargonizer-printers.component';
import { CargonizerPrinterEditComponent } from '@app/views/components/cargonizer-printer-edit/cargonizer-printer-edit.component';
import { ConsignmentLineSelectComponent } from '@app/views/components/consignment-line-select/consignment-line-select.component';
import { ConsignmentSplitLineComponent } from '@app/views/components/consignment-split-line/consignment-split-line.component';
import { CustGrpComponent } from '@app/views/components/cust-grp/cust-grp.component';
import { FreightRateSetCreateComponent } from '@app/views/components/freight-rate-set-create/freight-rate-set-create.component';
import { FinishPohScanComponent } from '@app/views/components/finish-poh-scan/finish-poh-scan.component';
import { ActivityTypeComponent } from '@app/views/components/activity-type/activity-type.component';
import { ActStatusComponent } from '@app/views/components/act-status/act-status.component';
import { BusinessCoSettingCargonizerComponent } from '@app/views/components/business-co-setting-cargonizer/business-co-setting-cargonizer.component';
import { CategoryLinkAddComponent } from '@app/views/components/category-link-add/category-link-add.component';
import { TrNewJobConfComponent } from '@app/views/components/tr-new-job-conf/tr-new-job-conf.component';
import { OrderDialogComponent } from '@app/views/components/order-dialog/order-dialog.component';
import { OrderHeadCopyComponent } from '@app/views/components/order-head-copy/order-head-copy.component';
import { CheckInComponent } from '@app/views/components/check-in/check-in.component';
import { ChoiceProdPriceGrpsComponent } from '@app/views/components/choice-prod-price-grps/choice-prod-price-grps.component';
import { ChoiceProdPriceGrpComponent } from '@app/views/components/choice-prod-price-grp/choice-prod-price-grp.component';
import { ConsignmentColliDetailComponent } from '@app/views/components/consignment-colli-detail/consignment-colli-detail.component';
import { FurnitureFabricsComponent } from '@app/views/components/furniture-fabrics/furniture-fabrics.component';
import { OeeStateLogComponent } from '@app/views/components/oee-state-log/oee-state-log.component';
import { OrderHeadCreateIbPurchComponent } from '@app/views/components/order-head-create-ib-purch/order-head-create-ib-purch.component';
import { PoFinishComponent } from '@app/views/components/po-finish/po-finish.component';
import { PoFinishProdListComponent } from '@app/views/components/po-finish-prod-list/po-finish-prod-list.component';
import { PoFinishProdWorkComponent } from '@app/views/components/po-finish-prod-work/po-finish-prod-work.component';
import { PoFinishProdWorksComponent } from '@app/views/components/po-finish-prod-works/po-finish-prod-works.component';
import { PohCompAddScanComponent } from '@app/views/components/poh-comp-add-scan/poh-comp-add-scan.component';
import { PohCompAddComponent } from '@app/views/components/poh-comp-add/poh-comp-add.component';
import { PoFinishProdCompsBsComponent } from '@app/views/components/po-finish-prod-comps-bs/po-finish-prod-comps-bs.component';
import { PoFinishProdCompsBComponent } from '@app/views/components/po-finish-prod-comps-b/po-finish-prod-comps-b.component';
import { PoFinishPoFinishCompsComponent } from '@app/views/components/po-finish-po-finish-comps/po-finish-po-finish-comps.component';
import { PoFinishProdCompComponent } from '@app/views/components/po-finish-prod-comp/po-finish-prod-comp.component';
import { PoFinishProdCompQtyComponent } from '@app/views/components/po-finish-prod-comp-qty/po-finish-prod-comp-qty.component';
import { StockBatchGetComponent } from '@app/views/components/stock-batch-get/stock-batch-get.component';
import { TracesBComponent } from '@app/views/components/traces-b/traces-b.component';
import { StockLocationCtrlComponent } from '@app/views/components/stock-location-ctrl/stock-location-ctrl.component';
import { DocArticleTopUserGroupsComponent } from '@app/views/components/doc-article-top-user-groups/doc-article-top-user-groups.component';
import { DocArticleTopUserGroupComponent } from '@app/views/components/doc-article-top-user-group/doc-article-top-user-group.component';
import { DocArticlePorusComponent } from '@app/views/components/doc-article-porus/doc-article-porus.component';
import { ECommerceStatusComponent } from '@app/views/components/e-commerce-status/e-commerce-status.component';
import { InventoryArticleSearchComponent } from '@app/views/components/inventory-article-search/inventory-article-search.component';
import { GisPositionAddComponent } from '@app/views/components/gis-position-add/gis-position-add.component';
import { GisPositionComponent } from '@app/views/components/gis-position/gis-position.component';
import { OlmRequisitionComponent } from '@app/views/components/olm-requisition/olm-requisition.component';
import { P2OffDutyDataComponent } from '@app/views/components/p2-off-duty-data/p2-off-duty-data.component';
import { SubOperationsComponent } from '@app/views/components/sub-operations/sub-operations.component';
import { SubOperationComponent } from '@app/views/components/sub-operation/sub-operation.component';
import { SubOperationLangComponent } from '@app/views/components/sub-operation-lang/sub-operation-lang.component';
import { TraceSearchComponent } from '@app/views/components/trace-search/trace-search.component';
import { TimeProjectsWoComponent } from '@app/views/components/time-projects-wo/time-projects-wo.component';
import { TimeRegisterSplitComponent } from '@app/views/components/time-register-split/time-register-split.component';
import { TimeSheetsStatusComponent } from '@app/views/components/time-sheets-status/time-sheets-status.component';
import { TravelBillLogComponent } from '@app/views/components/travel-bill-log/travel-bill-log.component';
import { TravelBillLogsComponent } from '@app/views/components/travel-bill-logs/travel-bill-logs.component';
import { TravelExpenceComponent } from '@app/views/components/travel-expence/travel-expence.component';
import { TravelWageComponent } from '@app/views/components/travel-wage/travel-wage.component';
import { WorkingOrdersComponent } from '@app/views/components/working-orders/working-orders.component';
import { BusinessCoComponent } from '@app/views/components/business-co/business-co.component';
import { ProductSettingComponent } from '@app/views/components/product-setting/product-setting.component';
import { ProductSearchComponent } from '@app/views/components/product-search/product-search.component';
import { CheckListComponent } from '@app/views/components/check-list/check-list.component';
import { HelpDocTtChangedComponent } from '@app/views/components/help-doc-tt-changed/help-doc-tt-changed.component';
import { CustactWorkComponent } from '@app/views/components/custact-work/custact-work.component';
import { PohKeynoTopStatusComponent } from '@app/views/components/poh-keyno-top-status/poh-keyno-top-status.component';
import { PostCalcComponent } from '@app/views/components/post-calc/post-calc.component';
import { PostCalcMComponent } from '@app/views/components/post-calc-m/post-calc-m.component';
import { ProductionStatusComponent } from '@app/views/components/production-status/production-status.component';
import { ConsignmentDeliveryComponent } from '@app/views/components/consignment-delivery/consignment-delivery.component';
import { ConsignmentPlansDeliverySettingsComponent } from '@app/views/components/consignment-plans-delivery-settings/consignment-plans-delivery-settings.component';
import { ConsignmentScanComponent } from '@app/views/components/consignment-scan/consignment-scan.component';
import { ConsignmentPlansDeliveryDriverComponent } from '@app/views/components/consignment-plans-delivery-driver/consignment-plans-delivery-driver.component';
import { ConsignmentPlansDeliveryLabourComponent } from '@app/views/components/consignment-plans-delivery-labour/consignment-plans-delivery-labour.component';
import { ConsignmentPlansDeliveryLocationComponent } from '@app/views/components/consignment-plans-delivery-location/consignment-plans-delivery-location.component';
import { ConsignmentSplitComponent } from '@app/views/components/consignment-split/consignment-split.component';
import { ConsignmentSplitEditComponent } from '@app/views/components/consignment-split-edit/consignment-split-edit.component';
import { ConsignmentCarrierOneComponent } from '@app/views/components/consignment-carrier-one/consignment-carrier-one.component';
import { ComponentReplaceAblesComponent } from '@app/views/components/component-replace-ables/component-replace-ables.component';
import { CustProdAccBcsComponent } from '@app/views/components/cust-prod-acc-bcs/cust-prod-acc-bcs.component';
import { SkillsCertificatesComponent } from '@app/views/components/skills-certificates/skills-certificates.component';
import { SkillsCertificateComponent } from '@app/views/components/skills-certificate/skills-certificate.component';
import { SkillsCertificateTableComponent } from '@app/views/components/skills-certificate-table/skills-certificate-table.component';
import { SkillsCertificateTypeComponent } from '@app/views/components/skills-certificate-type/skills-certificate-type.component';
import { TimeStampStartCorrComponent } from '@app/views/components/time-stamp-start-corr/time-stamp-start-corr.component';
import { AcReminderProposalComponent } from '@app/views/components/ac-reminder-proposal/ac-reminder-proposal.component';
import { AccessInfoComponent } from '@app/views/components/access-info/access-info.component';
import { HelpDocSearchComponent } from '@app/views/components/help-doc-search/help-doc-search.component';
import { P2SubscriptionsEditComponent } from '@app/views/components/p2-subscriptions-edit/p2-subscriptions-edit.component';
import { P2ClientUpdateComponent } from '@app/views/components/p2-client-update/p2-client-update.component';
import { P2ClientUpdateEditComponent } from '@app/views/components/p2-client-update-edit/p2-client-update-edit.component';
import { MenuGrpComponent } from '@app/views/components/menu-grp/menu-grp.component';
import { SearchStockComponent } from '@app/views/components/search-stock/search-stock.component';
import { CountersComponent } from '@app/views/components/counters/counters.component';
import { CounterComponent } from '@app/views/components/counter/counter.component';
import { PostCalcWComponent } from '@app/views/components/post-calc-w/post-calc-w.component';
import { FurnitureFabricsSuppliersComponent } from '@app/views/components/furniture-fabrics-suppliers/furniture-fabrics-suppliers.component';
import { DepartmentComponent } from '@app/views/components/department/department.component';
import { BulkMailsComponent } from '@app/views/components/bulk-mails/bulk-mails.component';
import { BulkMailComponent } from '@app/views/components/bulk-mail/bulk-mail.component';
import { TextileModelCategory3sComponent } from '@app/views/components/textile-model-category3s/textile-model-category3s.component';
import { TextileModelCategory3Component } from '@app/views/components/textile-model-category3/textile-model-category3.component';
import { TextileModelCategory3LangComponent } from '@app/views/components/textile-model-category3-lang/textile-model-category3-lang.component';
import { ListsComponent } from '@app/views/components/lists/lists.component';
import { ListDatasComponent } from '@app/views/components/list-datas/list-datas.component';
import { ListDataComponent } from '@app/views/components/list-data/list-data.component';
import { ListDataLangComponent } from '@app/views/components/list-data-lang/list-data-lang.component';
import { ListNameComponent } from '@app/views/components/list-name/list-name.component';
import { PoFinishProdCompListAccsComponent } from '@app/views/components/po-finish-prod-comp-list-accs/po-finish-prod-comp-list-accs.component';
import { SelectNewDocTypeComponent } from '@app/views/components/select-new-doc-type/select-new-doc-type.component';
import { WebSiteNewComponent } from '@app/views/components/web-site-new/web-site-new.component';
import { PurchRequestCreateComponent } from '@app/views/components/purch-request-create/purch-request-create.component';
import { OrderHeadChoicesComponent } from '@app/views/components/order-head-choices/order-head-choices.component';
import { OrderHeadChoiceComponent } from '@app/views/components/order-head-choice/order-head-choice.component';
import { OrderHeadCreateProjectComponent } from '@app/views/components/order-head-create-project/order-head-create-project.component';
import { ProjectActivityTypesComponent } from '@app/views/components/project-activity-types/project-activity-types.component';
import { ProjectActivityTypeComponent } from '@app/views/components/project-activity-type/project-activity-type.component';
import { OrderCustComComponent } from '@app/views/components/order-cust-com/order-cust-com.component';
import { OeeDashBoardComponent } from '@app/views/components/oee-dash-board/oee-dash-board.component';
import { EquipmentEditComponent } from '@app/views/components/equipment-edit/equipment-edit.component';
import { CustactPlansComponent } from '@app/views/components/custact-plans/custact-plans.component';
import { CategoryLinksComponent } from '@app/views/components/category-links/category-links.component';
import { CheckListItemTwsComponent } from '@app/views/components/check-list-item-tws/check-list-item-tws.component';
import { CheckListItemTwComponent } from '@app/views/components/check-list-item-tw/check-list-item-tw.component';
import { DeliveryMethodComponent } from '@app/views/components/delivery-method/delivery-method.component';
import { DispatchPlanningBlockOrderComponent } from '@app/views/components/dispatch-planning-block-order/dispatch-planning-block-order.component';
import { EdiExportComponent } from '@app/views/components/edi-export/edi-export.component';
import { EdiImportComponent } from '@app/views/components/edi-import/edi-import.component';
import { InterBranchInvoiceLineComponent } from '@app/views/components/inter-branch-invoice-line/inter-branch-invoice-line.component';
import { InvoiceHeadEhfComponent } from '@app/views/components/invoice-head-ehf/invoice-head-ehf.component';
import { InvoiceMakeMultiComponent } from '@app/views/components/invoice-make-multi/invoice-make-multi.component';
import { JobScheduleComponent } from '@app/views/components/job-schedule/job-schedule.component';
import { InvoiceHeadComponent } from '@app/views/components/invoice-head/invoice-head.component';
import { SelectReportComponent } from '@app/views/components/select-report/select-report.component';
import { ProductMoveChoicesComponent } from '@app/views/components/product-move-choices/product-move-choices.component';
import { ProductMoveChoiceComponent } from '@app/views/components/product-move-choice/product-move-choice.component';
import { ProductDataHarvestComponent } from '@app/views/components/product-data-harvest/product-data-harvest.component';
import { ProductionRoutingAddComponent } from '@app/views/components/production-routing-add/production-routing-add.component';
import { CategoryDatasComponent } from '@app/views/components/category-datas/category-datas.component';
import { BrRegComponent } from '@app/views/components/br-reg/br-reg.component';
import { BrRegViewComponent } from '@app/views/components/br-reg-view/br-reg-view.component';
import { PoJobLaboursComponent } from '@app/views/components/po-job-labours/po-job-labours.component';
import { AccountingBuntComponent } from '@app/views/components/accounting-bunt/accounting-bunt.component';
import { CalculationSeasonYearComponent } from '@app/views/components/calculation-season-year/calculation-season-year.component';
import { CalculationOverviewComponent } from '@app/views/components/calculation-overview/calculation-overview.component';
import { BankReconciliationAnalysisComponent } from '@app/views/components/bank-reconciliation-analysis/bank-reconciliation-analysis.component';
import { BusinessCoOnBoardingComponent } from '@app/views/components/business-co-on-boarding/business-co-on-boarding.component';
import { CampaignsComponent } from '@app/views/components/campaigns/campaigns.component';
import { CampaignEditComponent } from '@app/views/components/campaign-edit/campaign-edit.component';
import { CampaignProductsComponent } from '@app/views/components/campaign-products/campaign-products.component';
import { BusinessCoAccountingComponent } from '@app/views/components/business-co-accounting/business-co-accounting.component';
import { AcRemLtrComponent } from '@app/views/components/ac-rem-ltr/ac-rem-ltr.component';
import { BusinessCoBankAccountComponent } from '@app/views/components/business-co-bank-account/business-co-bank-account.component';
import { ForecastDataGridComponent } from '@app/views/components/forecast-data-grid/forecast-data-grid.component';
import { SpecialCustProdCalcComponent } from '@app/views/components/special-cust-prod-calc/special-cust-prod-calc.component';
import { FindCustomersComponent } from '@app/views/components/find-customers/find-customers.component';
import { CsvExportArgComponent } from '@app/views/components/csv-export-arg/csv-export-arg.component';
import { CsvExportsComponent } from '@app/views/components/csv-exports/csv-exports.component';
import { CustactCalcPickComponent } from '@app/views/components/custact-calc-pick/custact-calc-pick.component';
import { CustactCalcJobExitComponent } from '@app/views/components/custact-calc-job-exit/custact-calc-job-exit.component';
import { PohTopOpComponent } from '@app/views/components/poh-top-op/poh-top-op.component';
import { CategoryDataSelectComponent } from '@app/views/components/category-data-select/category-data-select.component';
import { PoPurchPlanningComponent } from '@app/views/components/po-purch-planning/po-purch-planning.component';
import { OrderHeadCapJobComponent } from '@app/views/components/order-head-cap-job/order-head-cap-job.component';

(function () {
    'use strict';

    imApp.config([
        '$stateProvider',
        '$urlRouterProvider',
        '$locationProvider',
        'appConfigProvider',
        'utilityServiceProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider, appConfigProvider, utilityServiceProvider) {
            $locationProvider.hashPrefix('');
            //$locationProvider.html5Mode(true);
            //$locationProvider.html5Mode({
            //    enabled: false,
            //    requireBase: false,
            //    rewriteLinks: true
            //});

            $urlRouterProvider.otherwise('/mainmenu');

            var appConfig = appConfigProvider.$get();
            var us = utilityServiceProvider.$get();

            var version = '?v=' + appConfig.version;

            // BJS 20220707 - Adding dynamic routes from database. These are retrieved in module.js
            //                before bootstrapping the application.
            angular.forEach(appConfig.appRoutes, function (route) {
                var state = {
                    url: route.path,
                    component: route.component,
                };

                // route_id is used with generic components to differentiate
                // between implementations
                if (us.isStringValue(route.routeId, true)) {
                    state.resolve = {
                        route: function () {
                            return route.routeId;
                        },
                    };
                }

                $stateProvider.state(route.id, state);
            });

            $stateProvider
                .state('docarticles', {
                    url: '/docarticles',
                    component: DocArticlesComponent,
                })
                .state('prognosispurchaseoverviewhistory', {
                    url: '/prognosispurchaseoverviewhistory/:prognosispurchasehistory_keyno',
                    component: PrognosisPurchaseHistoryComponent,
                })
                .state('prognosispurchaseoverview', {
                    url: '/prognosispurchaseoverview',
                    component: PrognosisPurchaseOverviewComponent,
                })
                .state('deviantvat', {
                    url: '/deviantvat/:prod_id',
                    component: DeviantVatComponent,
                    resolve: [VIEW_NAVIGATOR(DeviantVatComponent)],
                })
                .state('accountproduct', {
                    url: '/accountproduct/:prod_id',
                    component: AccountproductComponent,
                    resolve: [VIEW_NAVIGATOR(AccountproductComponent)],
                })
                .state('productsoverview', {
                    url: '/productsoverview',
                    component: ProductsOverviewComponent,
                })
                .state('purchplanningoverview', {
                    url: '/purchplanningoverview',
                    component: PurchPlanningOverviewComponent,
                })
                .state('orderheadexternalcost', {
                    url: '/orderheadexternalcost/:order_internal_no',
                    component: OrderheadExternalCostComponent,
                })
                .state('purchreceivalplanning', {
                    url: '/purchreceivalplanning',
                    component: PurchReceivalPlanningComponent,
                })
                .state('concernordersgrid', {
                    url: '/concernordersgrid',
                    component: ConcernOrdersGridComponent,
                })
                .state('saftexport', {
                    url: '/saftexport',
                    component: 'saftExportComponent',
                    //component: SaftExportComponent,
                })
                .state('tempstock', {
                    url: '/tempstock',
                    component: 'tempstock',
                })
                .state('bjstestview', {
                    url: '/bjstestview',
                    component: BjsTestComponent,
                })
                //.state('klntestview', {
                //    url: '/klntestview',
                //    component: KlnTestComponent
                //})
                .state('orderlinecalcform', {
                    url: '/orderlinecalcform/:order_internal_no/:argtype/:argvalue',
                    component: OrderlineCalcFormViewComponent,
                })
                .state('calccopyfrom', {
                    url: '/calccopyfrom/:calc_keyno',
                    component: CalcCopyFromViewComponent,
                })
                .state('jlrtest', {
                    url: '/jlrtest/:order_internal_no',
                    // component: DocumentsComponent,
                    // component: EmailComponent,
                    // component: KpiCompComponent,
                    // component: TranslateEditComponent,
                    // component: DeviationComponent,
                    // component: CustactCalcComponent,
                    // component: P2SettingsComponent,
                    // component: DocArticlesComponent,
                    // component: PrognosisPurchaseHistoryComponent,
                    // component: ProjectComponent,
                    component: ProductsConfigComponent,
                    component: PurchHeadViewComponent,
                    component: JlrTestComponent,
                    // component: CustomerEditComponent,
                    component: JlrTestComponent,
                    // component: ChecklistDataViewComponent,
                    component: AccountingProcessingComponent,
                    component: TimeSheetDiaryComponent,
                    // resolve: [VIEW_NAVIGATOR(AccountingProcessingComponent)],
                    // resolve: [VIEW_NAVIGATOR(TimeSheetDiaryComponent)],
                    component: OrderHeadComponent,
                    resolve: [VIEW_NAVIGATOR(OrderHeadComponent)],
                })
                .state('captaskplannerdev', {
                    url: '/captaskplannerdev',
                    component: JlrTestComponent,
                })
                .state('studenttest', {
                    url: '/studenttest',
                    component: StudentTestComponent,
                })
                .state('bankreconciliations', {
                    url: '/bankreconciliations',
                    //component: 'bankReconciliations',
                    component: BankReconciliationsComponent,
                })
                .state('tshtmlreport', {
                    url: '/tshtmlreport/:htmlreport_keyno',
                    component: HtmlReportComponent,
                })
                .state('wbpagemenutest', {
                    url: '/webpagemenutest',
                    component: WebpagemenuComponent,
                })
                .state('bankreconciliation', {
                    url: '/bankreconciliation/:businessco_bankaccount_keyno',
                    component: BankReconciliationComponent,
                })
                .state('bankreconciliationanalysis', {
                    url: '/bankreconciliationanalysis/:businessco_bankaccount_keyno',
                    //component: 'bankReconciliationAnalysis',
                    component: BankReconciliationAnalysisComponent,
                })
                .state('interbranchequipmentinvoicing', {
                    url: '/interbranchequipmentinvoicing',
                    component: InterbranchEquipmentInvoicingComponent,
                })
                .state('videotutorials', {
                    url: '/videotutorials/:argtype/:argvalue',
                    component: VideoTutorialsComponent,
                })
                .state('videotutorial', {
                    url: '/videotutorial/:index',
                    component: VideoTutorialComponent,
                })
                .state('bankreconciliationsbt', {
                    url: '/bankreconciliationsbt/:businessco_bankaccount_keyno',
                    component: 'bankReconciliationsBt',
                })
                .state('bankreconciliationsat', {
                    url: '/bankreconciliationsat/:businessco_bankaccount_keyno',
                    component: 'bankReconciliationsAt',
                })
                // .state('jlrtest', {
                //     url: '/jlrtest',
                //     component: 'bislabSetup',
                // })
                .state('bislabsetup', {
                    url: '/bislabsetup/:businessco_no',
                    component: 'bislabSetup',
                })
                .state('kpicomp', {
                    url: '/kpicomp/:kpicomp_keyno',
                    // component: 'kpiComp',
                    component: KpiCompComponent,
                    resolve: [VIEW_NAVIGATOR(KpiCompComponent)],
                })
                .state('kpicomps', {
                    url: '/kpicomps',
                    //component: 'kpiComps',
                    component: KpiCompsComponent,
                })
                .state('collectioncalculation', {
                    url: '/collectioncalculation',
                    //component: 'collectionCalculation',
                    component: CollectionCalculationComponent,
                })
                .state('cuttingplan', {
                    url: '/cuttingplan/:cuttingplan_keyno',
                    component: CuttingPlanComponent,
                    resolve: [VIEW_NAVIGATOR(CuttingPlanComponent)],
                })
                .state('cuttingplanreal', {
                    url: '/cuttingplanreal/:cuttingplan_keyno',
                    component: CuttingPlanRealComponent,
                    resolve: [VIEW_NAVIGATOR(CuttingPlanRealComponent)],
                })
                .state('cuttingplanpoadd', {
                    url: '/cuttingplanpoadd/:cuttingplan_keyno',
                    component: CuttingPlanPoAddComponent,
                    resolve: [VIEW_NAVIGATOR(CuttingPlanPoAddComponent)],
                })
                .state('cuttingplans', {
                    url: '/cuttingplans',
                    //component: 'cuttingPlans',
                    component: CuttingPlansComponent,
                })
                .state('myactivities', {
                    url: '/myactivities',
                    // component: 'myActivities'
                    component: MyActivitiesComponent,
                })
                .state('gpximport', {
                    url: '/gpximport/:argtype/:argvalue',
                    component: 'gpximport',
                })
                .state('mapview3d', {
                    url: '/mapview3d/:argtype/:argvalue',
                    component: 'mapView3d',
                })
                .state('purchrequestcreate', {
                    url: '/purchrequestcreate/:purch_internal_no',
                    //component: 'purchRequestCreate',
                    component: PurchRequestCreateComponent,
                })
                .state('activitymanager', {
                    url: '/activitymanager',
                    component: 'activityManager',
                })
                .state('customerbonus', {
                    url: '/customerbonus/:cust_no',
                    component: 'customerBonus',
                })
                .state('customerclaims', {
                    url: '/customerclaims/:cust_no',
                    // component: 'customerClaims',
                    component: CustomerClaimsComponent,
                    resolve: [VIEW_NAVIGATOR(CustomerClaimsComponent)],
                })
                .state('prodtmsizestockplace', {
                    url: '/prodtmsizestockplace/:textilemodel_id',
                    component: 'prodTmSizeStockplace',
                })
                .state('mainmenu', {
                    url: '/mainmenu/:companyid/:userid/:pwd',
                    // component: 'mainMenu',
                    component: MainMenuComponent,
                    params: {
                        companyid: { squash: true, value: null },
                        userid: { squash: true, value: null },
                        pwd: { squash: true, value: null },
                    },
                    header: {
                        text: 'main_menu',
                        backButton: {
                            text: 'log_out',
                            visible: false,
                        },
                        homeButton: {
                            visible: false,
                        },
                    },
                })
                .state('carriersbuilder', {
                    url: '/carriersbuilder',
                    component: 'genericTerminalScanA',
                    resolve: {
                        route: function () {
                            return 'carriersbuilder';
                        },
                    },
                })
                .state('orderlinebackorders', {
                    url: '/orderlinebackorders/:backorder_only',
                    component: 'orderlineBackorders',
                })
                .state('orderpicknew', {
                    url: '/orderpicknew/:argtype/:argvalue',
                    component: 'orderPickNew',
                    component: OrderPickNewViewComponent,
                })
                .state('orderpickview', {
                    url: '/orderpickview/:orderpick_keyno',
                    component: 'orderPickView',
                    component: OrderPickViewViewComponent,
                })
                .state('ordershipmentstatus', {
                    url: '/ordershipmentstatus/:order_internal_no',
                    component: 'orderShipmentStatus',
                })
                .state('orderspecial', {
                    url: '/orderspecial',
                    component: 'orderSpecial',
                })
                .state('poshipmentplanningcontainers', {
                    url: '/poshipmentplanningcontainers/:poh_keyno',
                    component: 'poShipmentPlanningContainers',
                })
                //.state('printtest', {
                //    url: '/printtest',
                //    templateUrl: 'views/session/printtest.html' + version,
                //    component: 'mainMenu',
                //    header: {
                //        text: 'p2_m_printtest',
                //        backButton: {
                //            text: 'p2_m_developmenu',
                //            fallback: {
                //                state: 'developmenu'
                //            }
                //        }
                //    }
                //})
                .state('printtestclientdetails', {
                    url: '/printtestclientdetails/:printClientKeyno',
                    component: 'printTestClientDetails',
                    header: {
                        text: 'p2_m_printtestclientdetails',
                        backButton: {
                            text: 'p2_m_printtest',
                            fallback: {
                                state: 'printtest',
                            },
                        },
                    },
                })
                .state('printtestclientprinters', {
                    url: '/printtestclientprinters/:printClientKeyno/:printClientName',
                    component: 'printTestClientPrinters',
                    header: {
                        text: 'p2_m_printtestclientprinters',
                        backButton: {
                            text: 'p2_m_printtest',
                            fallback: {
                                state: 'printtest',
                            },
                        },
                    },
                })
                .state('printtestprinterdetails', {
                    url: '/printtestprinterdetails/:printClientKeyno/:printClientName/:printerName',
                    component: 'printTestPrinterDetails',
                    header: {
                        text: 'p2_m_printtestprinterdetails',
                        backButton: {
                            text: 'p2_m_printtestclientprinters',
                            fallback: {
                                state: 'printtestclientprinters',
                            },
                        },
                    },
                })
                .state('printtestprinters', {
                    url: '/printtestprinters/:reportKeyno',
                    component: 'printTestPrinters',
                    header: {
                        text: 'p2_m_printtestprinters',
                        backButton: {
                            text: 'p2_m_printtestreports',
                            fallback: {
                                state: 'printtestreports',
                            },
                        },
                    },
                })
                .state('printtestreports', {
                    url: '/printtestreports',
                    component: 'printTestReports',
                    header: {
                        text: 'p2_m_printtestreports',
                        backButton: {
                            text: 'p2_m_printtest',
                            fallback: {
                                state: 'printtest',
                            },
                        },
                    },
                })
                .state('textilesizes', {
                    url: '/textilesizes/',
                    component: 'textileSizes',
                })
                .state('timesheet', {
                    url: '/timesheet',
                    component: 'timeSheet',
                    header: {
                        text: 'p2_m_timeregister',
                        backButton: {
                            text: 'main_menu',
                            fallback: {
                                state: 'mainmenu',
                            },
                        },
                    },
                })

                .state('timesheetdiary', {
                    url: '/timesheetdiary/:argtype/:argvalue',
                    //component: 'timeSheetDiary',
                    component: TimeSheetDiaryComponent,
                    resolve: [VIEW_NAVIGATOR(TimeSheetDiaryComponent)],
                })
                .state('ordercustcom', {
                    url: '/ordercustcom/:ordercustcom_keyno',
                    //component: 'orderCustCom',
                    component: OrderCustComComponent,
                })
                .state('orderdeliveryinfo', {
                    url: '/orderdeliveryinfo/:argtype/:argvalue',
                    //component: 'orderDeliveryInfo',
                    component: OrderDeliveryInfoComponent,
                })
                .state('orderdialog', {
                    url: '/orderdialog/:order_internal_no',
                    component: 'orderDialog',
                    //component: OrderDialogComponent,
                })
                .state('orderpriceupdate', {
                    url: '/orderpriceupdate/',
                    component: 'orderPriceUpdate',
                })
                .state('orderprocurement', {
                    url: '/orderprocurement/:argtype/:argvalue',
                    component: 'orderProCurement',
                })
                .state('orderpurch', {
                    url: '/orderpurch/:order_internal_no',
                    component: 'orderPurch',
                    component: OrderPurchComponent,
                })
                .state('orderpurchmenu', {
                    url: '/orderpurchmenu/:order_internal_no',
                    //component: 'orderPurchMenu',
                    component: OrderPurchMenuComponent,
                })
                .state('oeemenu', {
                    url: '/oeemenu',
                    component: 'oeeMenu',
                })
                .state('oeestates', {
                    url: '/oeestates',
                    //component: 'oeeStates',
                    component: OeeStatesComponent,
                })
                .state('oeestateedit', {
                    url: '/oeestateedit/:oeestate_keyno',
                    //component: 'oeeStateEdit',
                    component: OeeStateEditComponent,
                })
                .state('oeestate_equipments', {
                    url: '/oeestate_equipments/:argtype/:argvalue',
                    //component: 'oeeStateEquipments',
                    component: OeeStateEquipmentsComponent,
                })
                .state('oeestate_equipment', {
                    url: '/oeestate_equipment/:oeestate_equipment_keyno',
                    //component: 'oeeStateEquipment',
                    component: OeeStateEquipmentComponent,
                })
                .state('oeestateremarks', {
                    url: '/oeestateremarks/:oeestate_keyno',
                    //component: 'oeeStateRemarks',
                    component: OeeStateRemarksComponent,
                })
                .state('oeestateremark', {
                    url: '/oeestateremark/:oeestate_keyno/:oeestateremark_keyno',
                    //component: 'oeeStateRemark',
                    component: OeeStateRemarkComponent,
                })
                .state('oeedatacurrent', {
                    url: '/oeedatacurrent',
                    component: 'oeeDataCurrent',
                })
                .state('oeedata', {
                    url: '/oeedata/:oeedata_keyno',
                    component: 'oeeData',
                })
                .state('oeedashboard', {
                    url: '/oeedashboard',
                    //component: 'oeeDashBoard',
                    component: OeeDashBoardComponent,
                })
                .state('oeestatelog', {
                    url: '/oeestatelog/:equipment_id',
                    //component: 'oeeStateLog',
                    component: OeeStateLogComponent,
                })
                .state('prepickcreate', {
                    url: '/prepickcreate/:argtype/:argvalue',
                    //component: 'prePickCreate',
                    component: PrepickCreateComponent,
                })
                .state('equipments', {
                    url: '/equipments',
                    //component: 'equipments',
                    component: EquipmentsComponent,
                })
                .state('equipmentedit', {
                    url: '/equipmentedit/:equipment_id',
                    //component: 'equipmentEdit',
                    component: EquipmentEditComponent,
                })
                .state('batchdelivery_list', {
                    url: '/batchdelivery_list',
                    //component: 'batchDeliveryList',
                    component: BatchDeliveryListComponent,
                })
                .state('batchdelcontrol', {
                    url: '/batchdelcontrol/:batchdelivery_keyno/:purch_internal_no',
                    //component: 'batchDelControl',
                    component: BatchDelControlComponent,
                })
                .state('batchdelivery', {
                    url: '/batchdelivery/:batchdelivery_keyno',
                    component: 'batchDelivery',
                })
                .state('batchdelpurchline', {
                    url: '/batchdelpurchline/:batchdelpurchline_keyno',
                    //component: 'batchDelPurchLine',
                    component: BatchDelPurchLineComponent,
                })
                .state('batchdelpurchlinesb', {
                    url: '/batchdelpurchlinesb/:batchdelpurchlinesb_keyno',
                    component: 'batchDelPurchLinesB',
                })
                .state('batchdelpurchlinesbs', {
                    url: '/batchdelpurchlinesbs/:batchdelpurchline_keyno/:batchdelivery_keyno',
                    //component: 'batchDelPurchLinesBs',
                    component: BatchDelPurchLinesBsComponent,
                })
                .state('batchdeliveryadd', {
                    url: '/batchdeliveryadd/:batchdelivery_keyno',
                    //component: 'batchDeliveryAdd',
                    component: BatchDeliveryAddComponent,
                })
                .state('batchdelivery_addpurchline', {
                    url: '/batchdelivery_addpurchline/:supplier_no/:batchdelivery_keyno/:purch_internal_no',
                    component: 'batchDeliveryAddPurchLine',
                })
                .state('batchdelreceivelines', {
                    url: '/batchdelreceivelines/:batchdelivery_keyno/:purch_internal_no/:purchline_keyno/:prodsizecolli_keyno/:stocklocation_keyno/:controlled/:placed',
                    //component: 'batchDelReceiveLines',
                    component: BatchDelReceiveLinesComponent,
                })
                .state('batchdelreceiveline', {
                    url: '/batchdelreceiveline/:batchdelreceiveline_keyno',
                    //component: 'batchDelReceiveLine',
                    component: BatchDelReceiveLineComponent,
                })
                .state('batchdelivery_select_purchhead', {
                    url: '/batchdelivery_select_purchhead/:supplier_no/:batchdelivery_keyno',
                    component: 'batchDeliverySelectPurchHead',
                })
                .state('bdscandetail', {
                    url: '/bdscandetail/:batchdelivery_keyno/:purch_internal_no/:purchline_keyno/:prodsizecolli_keyno',
                    //component: 'bdScanDetail',
                    component: BdScanDetailComponent,
                })
                .state('bireports', {
                    url: '/bireports',
                    //component: 'biReports',
                    component: BiReportsComponent,
                })
                .state('bireportembed', {
                    url: '/bireportembed/:bi_report_keyno',
                    component: 'biReportEmbed',
                })
                .state('bonustypesoverview', {
                    url: '/bonustypesoverview',
                    component: 'bonusTypesOverview',
                })
                .state('brreg', {
                    url: '/brreg',
                    //component: 'brReg',
                    component: BrRegComponent,
                })
                .state('brregview', {
                    url: '/brregview/:orgno/:resource_id',
                    //component: 'brRegView',
                    component: BrRegViewComponent,
                })
                .state('collidispatch', {
                    url: '/collidispatch',
                    component: 'colliDispatch',
                })
                .state('componentalternative', {
                    url: '/componentalternative/:prod_id/:comp_keyno/:componentalternative_keyno',
                    //component: 'componentAlternative',
                    component: ComponentAlternativeComponent,
                })
                .state('componentalternatives', {
                    url: '/componentalternatives/:prod_id/:comp_keyno',
                    //component: 'componentAlternatives',
                    component: ComponentAlternativesComponent,
                })
                .state('trstart', {
                    url: '/trstart',
                    component: 'timeRegisterStart',
                })
                .state('timestampsettings', {
                    url: '/timestampsettings',
                    component: 'timestampSettings',
                })
                .state('sizematrix', {
                    url: '/sizematrix',
                    component: 'sizematrix',
                })
                .state('stockbatchcorrqty', {
                    url: '/stockbatchcorrqty/:stockbatch_keyno',
                    //component: 'stockBatchCorrQty',
                    component: StockBatchCorrQtyComponent,
                })
                .state('stockbatchsearch', {
                    url: '/stockbatchsearch',
                    //component: 'stockBatchSearch',
                    component: StockBatchSearchComponent,
                })
                .state('stockbatchlogg', {
                    url: '/stockbatchlogg/:argtype/:argvalue',
                    //component: 'stockBatchSearch',
                    component: StockBatchLoggComponent,
                })
                .state('stockcorrcode', {
                    url: '/stockcorrcode/:stockcorrcode_keyno',
                    //component: 'stockCorrCode',
                    component: StockCorrCodeComponent,
                })
                .state('stockcorrcodelangs', {
                    url: '/stockcorrcodelangs/:stockcorrcode_keyno',
                    //component: 'stockCorrCodeLangs',
                    component: StockCorrCodeLangsComponent,
                })
                .state('stockcorrcodes', {
                    url: '/stockcorrcodes',
                    //component: 'stockCorrCodes',
                    component: StockCorrCodesComponent,
                })
                .state('stockcorrections', {
                    url: '/stockcorrections/:argtype/:argvalue',
                    //component: 'stockCorrections',
                    component: StockCorrectionsComponent,
                })
                .state('stocklimits', {
                    url: '/stocklimits',
                    component: 'stockLimits',
                })
                .state('operations', {
                    url: '/operations',
                    //component: 'operations',
                    component: OperationsComponent,
                })
                .state('operation', {
                    url: '/operation/:operation_id',
                    //component: 'operation',
                    component: OperationComponent,
                })
                .state('pojoblabours', {
                    url: '/pojoblabours/:argtype/:argvalue',
                    //component: 'poJobLabours',
                    component: PoJobLaboursComponent,
                })
                .state('pojobs', {
                    url: '/pojobs/:argtype/:argvalue',
                    component: 'poJobs',
                })

                .state('pow', {
                    url: '/pow/:pow_keyno',
                    component: 'pow',
                })

                .state('poworks', {
                    url: '/poworks/:argtype/:argvalue',
                    component: 'poWorks',
                })
                .state('productdataharvest', {
                    url: '/productdataharvest/:argtype/:argvalue',
                    //component: 'productDataHarvest',
                    component: ProductDataHarvestComponent,
                })
                .state('tsmenu', {
                    url: '/tsmenu',
                    component: TimestampMenuComponent,
                    // component: 'tsMenu',
                    header: {
                        backButton: {
                            text: 'main_menu',
                            fallback: {
                                state: 'mainmenu',
                            },
                        },
                    },
                })

                .state('fossproduction', {
                    url: '/fossproduction/:gridpage_keyno/:p2_datatask_keyno/:eventid/:reportnumber/:proc_parm1/:proc_parm2/:proc_parm3',
                    component: 'fossProduction',
                })
                .state('orderform', {
                    url: '/orderform/:order_internal_no',
                    component: 'orderForm',
                })
                .state('orderhead', {
                    url: '/orderhead/:order_internal_no',
                    component: 'orderhead',
                    title: '',
                })
                .state('orderheadchoice', {
                    url: '/orderheadchoice/:orderheadchoice_keyno',
                    //component: 'orderHeadChoice',
                    component: OrderHeadChoiceComponent,
                })
                .state('orderheadchoices', {
                    url: '/orderheadchoices/:order_internal_no',
                    //component: 'orderHeadChoices',
                    component: OrderHeadChoicesComponent,
                })
                .state('orderheadcreateproject', {
                    url: '/orderheadcreateproject/:order_internal_no',
                    //component: 'orderHeadCreateProject',
                    component: OrderHeadCreateProjectComponent,
                })

                .state('payouts', {
                    url: '/payouts',
                    component: 'payouts',
                })
                .state('jobqueue', {
                    url: '/jobqueue/:argtype/:argvalue',
                    component: 'jobqueue',
                    params: {
                        argtype: { squash: true, value: null },
                        argvalue: { squash: true, value: null },
                    },
                })

                .state('jobqueuedetails', {
                    url: '/jobqueuedetails/:jobqueue_keyno',
                    component: 'jobqueueDetails',
                })

                // BJS 20220512
                .state('shipment', {
                    url: '/shipment/:shipmentcontainer_keyno',
                    component: 'shipment',
                    params: {
                        shipmentcontainer_keyno: { squash: true, value: null },
                    },
                })

                .state('textilemodels', {
                    url: '/textilemodels',
                    component: 'textileModels',
                })

                .state('textilemodel', {
                    url: '/textilemodel/:textilemodel_id',
                    component: 'textileModel',
                })

                .state('edisetup', {
                    url: '/edisetup/:argtype/:argvalue/:new_customer',
                    component: 'ediSetup',
                    params: {
                        argtype: { squash: false },
                        argvalue: { squash: false },
                        new_customer: { squash: true, value: null },
                    },
                })

                .state('about', {
                    url: '/about',
                    component: 'about',
                    component: AboutViewComponent,
                })

                // not in use?
                .state('campaigns', {
                    url: '/campaigns',
                    //component: 'campaigns',
                    component: CampaignsComponent,
                })

                // not in use?
                .state('campaignedit', {
                    url: '/campaignedit/:campaign_keyno',
                    //component: 'campaignEdit',
                    component: CampaignEditComponent,
                })

                // not in use?
                .state('campaignproducts', {
                    url: '/campaignproducts/:campaign_keyno',
                    //component: 'campaignProducts',
                    component: CampaignProductsComponent,
                })

                .state('captaskplans', {
                    url: '/captaskplans/:argtype/:argvalue',
                    component: 'capTaskPlans',
                })

                .state('captaskresource', {
                    url: '/captaskresource/:captaskresource_keyno',
                    component: 'capTaskResource',
                })
                .state('confirmationterminalscan', {
                    url: '/confirmationterminalscan/:mode',
                    component: 'confirmationTerminalScan',
                })
                .state('deliverymethodlangs', {
                    url: '/deliverymethodlangs/:deliverymethod_no',
                    component: DeliveryMethodLangsComponent,
                    //component: 'deliveryMethodLangs',
                })
                .state('factories', {
                    url: '/factories',
                    //component: 'factories',
                    component: FactoriesComponent,
                })
                .state('factoring', {
                    url: '/factoring/:factoring_no',
                    //component: 'factoring',
                    component: FactoringComponent,
                })
                .state('factorings', {
                    url: '/factorings',
                    //component: 'factorings',
                    component: FactoringsComponent,
                })
                .state('factory', {
                    url: '/factory/:factory_id',
                    //component: 'factory',
                    component: FactoryComponent,
                })

                .state('factorymenu', {
                    url: '/factorymenu/:factory_id',
                    //component: 'factoryMenu',
                    component: FactoryMenuComponent,
                })

                .state('operationfactories', {
                    url: '/operationfactories/:argtype/:argvalue',
                    //component: 'operationFactories',
                    component: OperationFactoriesComponent,
                })

                .state('operationfactory', {
                    url: '/operationfactory/:operationfactory_keyno',
                    //component: 'operationFactory',
                    component: OperationFactoryComponent,
                })

                .state('paperlessproduction', {
                    url: '/paperlessproduction',
                    //component: 'paperLessProduction',
                    component: PaperlessProductionComponent,
                })
                .state('pickjobgrpbatch', {
                    url: '/pickjobgrpbatch/:stocktransfer_keyno',
                    component: 'pickJobGrpBatch',
                })
                .state('pickjobgrpbatchaddo', {
                    url: '/pickjobgrpbatchaddo/:stocktransfer_keyno',
                    component: 'pickJobGrpBatchAddO',
                })
                .state('pickjobgrpbatchaddr', {
                    url: '/pickjobgrpbatchaddr/:stocktransfer_keyno',
                    component: 'pickJobGrpBatchAddr',
                })
                .state('pickjobgrpbatches', {
                    url: '/pickjobgrpbatches',
                    //component: 'pickJobGrpBatches',
                    component: PickJobGrpBatchesComponent,
                })
                .state('pickjobgrpbatchespicker', {
                    url: '/pickjobgrpbatchespicker',
                    //component: 'pickJobGrpBatchesPicker',
                    component: PickJobGrpBatchesPickerComponent,
                })
                .state('postaccrual', {
                    url: '/postaccrual/:acledger_keyno',
                    component: 'postAccrual',
                })
                .state('postplace', {
                    url: '/postplace/:postplace_id',
                    // component: 'postPlace',
                    component: PostplaceViewComponent,
                })
                .state('postplaces', {
                    url: '/postplaces',
                    //component: 'postPlaces',
                    component: PostPlacesComponent,
                })
                .state('projectactivitytype', {
                    url: '/projectactivitytype/:projectactivitytype_keyno',
                    //component: 'projectActivityType',
                    component: ProjectActivityTypeComponent,
                })
                .state('projectactivitytypes', {
                    url: '/projectactivitytypes/:project_keyno',
                    //component: 'projectActivityTypes',
                    component: ProjectActivityTypesComponent,
                })
                .state('priceupdate', {
                    url: '/priceupdate',
                    component: 'priceUpdate',
                })

                .state('searchlog', {
                    url: '/searchlog',
                    component: 'searchLog',
                })
                .state('stockplanningpo', {
                    url: '/stockplanningpo',
                    component: 'stockPlanningPo',
                })
                .state('stockreplenishmentdetail', {
                    url: '/stockreplenishmentdetail',
                    component: 'stockReplenishmentDetail',
                })
                .state('stockreplenishmentoverview', {
                    url: '/stockreplenishmentoverview',
                    component: 'stockReplenishmentOverview',
                })
                .state('stocktransferlog', {
                    url: '/stocktransferlog/:stocktransfer_keyno',
                    //component: 'stockTransferLog',
                    component: StockTransferLogComponent,
                })
                .state('workgrp', {
                    url: '/workgrp/:workgrp_keyno',
                    //component: 'workGrp',
                    component: WorkGrpComponent,
                })

                .state('workgrpmenu', {
                    url: '/workgrpmenu/:workgrp_keyno',
                    //component: 'workGrpMenu',
                    component: WorkGrpMenuComponent,
                })

                .state('workgrps', {
                    url: '/workgrps',
                    //component: 'workGrps',
                    component: WorkGrpsComponent,
                })

                .state('orderheadcopy', {
                    url: '/orderheadcopy/:order_internal_no',
                    //component: 'orderHeadCopy',
                    component: OrderHeadCopyComponent,
                })
                .state('orderheadmi', {
                    url: '/orderheadmi/:order_internal_no',
                    // component: 'orderHeadMi',
                    component: OrderHeadMiComponent,
                    resolve: [VIEW_NAVIGATOR(OrderHeadMiComponent)],
                })
                .state('ediorderheads', {
                    url: '/ediorderheads/:argtype/:argvalue',
                    component: 'ediOrderHeads',
                })
                .state('orderheads', {
                    url: '/orderheads/:argtype/:argvalue',
                    component: OrderHeadsComponent,
                    resolve: [VIEW_NAVIGATOR(OrderHeadsComponent)],
                })
                .state('orderheadsetdisc', {
                    url: '/orderheadsetdisc/:order_internal_no',
                    //component: 'orderHeadSetDisc',
                    component: OrderHeadSetDiscComponent,
                })
                .state('orderheadcreate', {
                    url: '/orderheadcreate/:argtype/:argvalue/:ordertype_id',
                    component: 'orderHeadCreate',
                })
                .state('orderheadcreateibpurch', {
                    url: '/orderheadcreateibpurch/:order_internal_no',
                    //component: 'orderHeadCreateIbPurch',
                    component: OrderHeadCreateIbPurchComponent,
                })
                .state('orderheadcalcs', {
                    url: '/orderheadcalcs/:order_internal_no',
                    //component: 'orderHeadCalcs',
                    component: OrderHeadCalcsComponent,
                })
                .state('orderheaddeleteol', {
                    url: '/orderheaddeleteol/:order_internal_no',
                    component: 'orderHeadDeleteOl',
                })
                .state('ordertoconsignments', {
                    url: '/ordertoconsignments/:order_internal_no/:custact_no_consignmentplan',
                    component: 'orderToConsignments',
                })
                .state('selectglyphicon', {
                    url: '/selectglyphicon',
                    //component: 'selectGlyphicon',
                    component: SelectGlyphiconComponent,
                })
                .state('selectproject', {
                    url: '/selectproject/:argtype/:argvalue',
                    component: 'selectProject',
                    component: SelectProjectViewComponent,
                })
                .state('projects', {
                    url: '/projects/:argtype/:argvalue',
                    component: 'projects',
                })
                .state('project', {
                    url: '/project/:project_keyno',
                    component: ProjectComponent,
                    resolve: [VIEW_NAVIGATOR(ProjectComponent)],
                })
                .state('projectmenu', {
                    url: '/projectmenu/:project_keyno',
                    component: 'projectMenu',
                    title: '',
                    component: ProjectMenuComponent,
                    resolve: [VIEW_NAVIGATOR(ProjectMenuComponent)],
                })
                .state('projectfolders', {
                    url: '/projectfolders/:project_keyno',
                    component: ProjectFoldersViewComponent,
                })
                .state('projectprocesses', {
                    url: '/projectprocesses/:project_keyno',
                    //component: 'projectProcesses',
                    component: ProjectProcessesComponent,
                })
                .state('projectprocess', {
                    url: '/projectprocess/:project_keyno/:projectprosess_keyno/:projectprosess_keyno_belongto',
                    // component: 'projectProcess',
                    component: ProjectProcessViewComponent,
                })
                .state('projectprogresslog', {
                    url: '/projectprogresslog/:project_keyno/:reportedprogresslog_keyno',
                    component: ProjectProgressLogViewComponent,
                })
                .state('invoicecustomerbonus', {
                    url: '/invoicecustomerbonus',
                    component: 'invoiceCustomerBonus',
                })
                .state('invoicemakemulti', {
                    url: '/invoicemakemulti/:businessco_no/:invoicemethod_no/:invoice_valuta_id',
                    //component: 'invoiceMakeMulti',
                    component: InvoiceMakeMultiComponent,
                })
                .state('invoicemakemultiorders', {
                    url: '/invoicemakemultiorders/:cust_no/:invoicemethod_no/:businessco_no',
                    //component: 'invoiceMakeMultiOrders',
                    component: InvoiceMakeMultiOrdersComponent,
                })
                .state('invoicemakeoverview', {
                    url: '/invoicemakeoverview',
                    //component: 'invoiceMakeOverview',
                    component: InvoiceMakeOverviewComponent,
                })
                .state('invoicemethod', {
                    url: '/invoicemethod/:invoicemethod_no',
                    //component: 'invoiceMethod',
                    component: InvoiceMethodComponent,
                })
                .state('invoicemethodlangs', {
                    url: '/invoicemethodlangs/:invoicemethod_no',
                    //component: 'invoiceMethodLangs',
                    component: InvoiceMethodLangsComponent,
                })
                .state('invoicemethods', {
                    url: '/invoicemethods',
                    //component: 'invoiceMethods',
                    component: InvoiceMethodsComponent,
                })
                .state('invoicehead', {
                    url: '/invoicehead/:invoice_no',
                    //component: 'invoiceHead',
                    component: InvoiceHeadComponent,
                })
                .state('invoiceheads', {
                    url: '/invoiceheads/:argtype/:argvalue',
                    component: 'invoiceHeads',
                })
                .state('invoices', {
                    url: '/invoices/:argtype/:argvalue',
                    params: {
                        argtype: { squash: true, value: null },
                        argvalue: { squash: true, value: null },
                    },
                    component: 'invoices',
                })
                .state('invoiceheadehf', {
                    url: '/invoiceheadehf/:invoice_no',
                    //component: 'invoiceHeadEhf',
                    component: InvoiceHeadEhfComponent,
                })
                .state('p2exportprocmenu', {
                    url: '/p2exportprocmenu/:p2_exportproc_keyno',
                    //component: 'p2ExportProcMenu',
                    component: P2ExportProcMenuComponent,
                })
                .state('p2exportprocs', {
                    url: '/p2exportprocs',
                    //component: 'p2ExportProcs',
                    component: P2ExportProcsComponent,
                })
                .state('p2exportprocusergroups', {
                    url: '/p2exportprocusergroups/:p2_exportproc_keyno',
                    component: 'p2ExportProcUserGroups',
                    //component: P2ExportProcUserGroupsComponent,
                })
                .state('p2exportproc', {
                    url: '/p2exportproc/:p2_exportproc_keyno',
                    component: 'p2ExportProc',
                })
                .state('prodbeomethodlangs', {
                    url: '/prodbeomethodlangs/:prodbeomethod_no',
                    //component: 'prodBeoMethodLangs',
                    component: ProdBeoMethodLangsComponent,
                })
                .state('prodbeomethods', {
                    url: '/prodbeomethods',
                    //component: 'prodBeoMethods',
                    component: ProdBeoMethodsComponent,
                })
                .state('productsearch', {
                    url: '/productsearch/:functionname',
                    component: 'productSearch',
                    //component: ProductSearchComponent,
                })
                .state('products', {
                    url: '/products/:argtype/:argvalue',
                    component: ProductsComponent,
                })
                .state('productcreate', {
                    url: '/productcreate/:argtype/:argvalue',
                    component: 'productCreate',
                    component: ProductCreateComponent,
                    resolve: [VIEW_NAVIGATOR(ProductCreateComponent)],
                })
                .state('productsetting', {
                    url: '/productsetting/:productsetting_keyno',
                    //component: 'productSetting',
                    component: ProductSettingComponent,
                })
                .state('productsettingmc', {
                    url: '/productsettingmc/:productsetting_keyno/:productsettingmc_keyno',
                    component: 'productSettingMc',
                })
                .state('productsettingmcitem', {
                    url: '/productsettingmcitem/:productsettingmc_keyno/:productsettingmcitem_keyno',
                    // component: 'productSettingMcItem',
                    component: ProductSettingMcItemComponent,
                })
                .state('productsettings', {
                    url: '/productsettings',
                    //component: 'productSettings',
                    component: ProductSettingsComponent,
                })
                .state('productwaste', {
                    url: '/productwaste',
                    //component: 'productWaste',
                    component: ProductWasteComponent,
                })
                .state('csvexportarg', {
                    url: '/csvexportarg/:argtype/:argvalue/:p2_exportproc_keyno',
                    //component: 'csvExportArg',
                    component: CsvExportArgComponent,
                    resolve: [VIEW_NAVIGATOR(CsvExportArgComponent)],
                })
                .state('csvexports', {
                    url: '/csvexports/:argtype/:argvalue',
                    //component: 'csvExports',
                    component: CsvExportsComponent,
                    resolve: [VIEW_NAVIGATOR(CsvExportsComponent)],
                })
                .state('csvimport', {
                    url: '/csvimport',
                    component: 'csvImport',
                })
                .state('excelimport', {
                    url: '/excelimport',
                    component: 'excelImport',
                })
                .state('basecurrencies', {
                    url: '/basecurrencies',
                    component: BaseCurrenciesComponent,
                    //component: 'baseCurrencies',
                })
                .state('currencytypes', {
                    url: '/currencytypes/:valuta_id',
                    component: CurrencyTypesComponent,
                    //component: 'currencyTypes',
                })
                .state('currencyexrates', {
                    url: '/currencyexrates/:valuta_id/:currencytype_keyno',
                    component: CurrencyExRatesComponent,
                    //component: 'currencyExRates',
                })
                .state('currencyexrate', {
                    url: '/currencyexrate/:currencyexrate_keyno',
                    component: CurrencyExRateComponent,
                    //component: 'currencyExRate',
                })
                .state('currencyexratehist', {
                    url: '/currencyexratehist/:currencyexrate_keyno',
                    component: CurrencyExRateHistComponent,
                    //component: 'currencyExRateHist',
                });

            $stateProvider
                // NOT IN USE, AND SHOULD NOT BE IN USE JLR, SRS 09202024
                //.state('collectionmining', {
                //    url: '/collectionmining',
                //    component: 'collectionMining'
                //})
                .state('batchdeliveries', {
                    url: '/batchdeliveries/:argtype/:argvalue',
                    //component: 'batchDeliveries',
                    component: BatchDeliveriesComponent,
                })
                .state('purchplanning', {
                    url: '/purchplanning',
                    //component: 'purchPlanning',
                    component: PurchPlanningComponent,
                })
                .state('stockcalc', {
                    url: '/stockcalc',
                    component: 'stockCalc',
                })
                .state('stockminmaxadjust', {
                    url: '/stockminmaxadjust/:stock_keyno',
                    component: 'stockMinMaxAdjust',
                })
                .state('tailoraccess', {
                    url: '/tailoraccess/:tailoraccess_keyno',
                    component: 'tailorAccess',
                })
                .state('tailoraccessdata', {
                    url: '/tailoraccessdata/:tailoraccessdata_keyno/:tailoraccess_keyno',
                    component: 'tailorAccessData',
                })
                .state('tailoraccesses', {
                    url: '/tailoraccesses',
                    component: 'tailorAccesses',
                })
                .state('tailoraccesslang', {
                    url: '/tailoraccesslang/:tailoraccess_keyno',
                    component: 'tailorAccessLang',
                })
                .state('tailoraccessmenu', {
                    url: '/tailoraccessmenu/:tailoraccess_keyno',
                    component: 'tailorAccessMenu',
                })
                .state('deliveryorderstatus', {
                    url: '/deliveryorderstatus',
                    component: 'deliveryOrderStatus',
                })
                .state('invoicedstatus', {
                    url: '/invoicedstatus',
                    component: 'invoicedStatus',
                })
                .state('blkrequisition', {
                    url: '/blkrequisition/:counter',
                    component: 'blkRequisition',
                })
                .state('purchhead', {
                    url: '/purchhead/:purch_internal_no',
                    //component: 'purchHead',
                    component: PurchHeadViewComponent, //JLR commented out because it uses purchline_dynamic grid which is still being tested.
                    title: '',
                })
                .state('purchheads', {
                    url: '/purchheads/:argtype/:argvalue',
                    component: 'purchHeads',
                    component: PurchHeadsComponent,
                })
                .state('purchheadcreate', {
                    url: '/purchheadcreate/:argtype/:argvalue',
                    component: 'purchHeadCreate',
                })
                .state('purchline', {
                    url: '/purchline/:purch_internal_no/:purchline_keyno',
                    component: 'purchLine',
                })
                .state('stockvariants', {
                    url: '/stockvariants/:prod_id/:functionname',
                    //component: 'stockVariants',
                    component: StockVariantsComponent,
                })
                .state('stockplace', {
                    url: '/stockplace/:stockplace_id',
                    component: 'stockPlace',
                })
                .state('stockplaceAccounting', {
                    url: '/stockplaceAccounting',
                    component: 'stockplaceAccounting',
                })
                .state('stockplaces', {
                    url: '/stockplaces',
                    component: StockPlacesComponent,
                    //component: 'stockPlaces',
                })
                .state('stockplacedeltime', {
                    url: '/stockplacedeltime/:stockplacedeltime_keyno',
                    component: StockPlaceDelTimeComponent,
                    //component: 'stockPlaceDelTime',
                })
                .state('stockplacedeltimes', {
                    url: '/stockplacedeltimes/:stockplace_id_to',
                    component: StockPlaceDelTimesComponent,
                    //component: 'stockPlaceDelTimes',
                })
                .state('multidoc', {
                    url: '/multidoc/:doctype/:argtype/:argvalue',
                    //component: 'multiDoc',
                    component: MultiDocComponent,
                })
                .state('multiproductcalc', {
                    url: '/multiproductcalc',
                    component: 'multiProductCalc',
                })
                .state('msgcreate', {
                    url: '/msgcreate',
                    //component: 'msgCreate',
                    component: MsgCreateComponent,
                })
                .state('operationlangs', {
                    url: '/operationlangs/:operation_id',
                    //component: 'operationLangs',
                    component: OperationLangsComponent,
                })
                .state('orderstatuses', {
                    url: '/orderstatuses',
                    //component: 'orderStatuses',
                    component: OrderStatusesComponent,
                })
                .state('orderstatuslangs', {
                    url: '/orderstatuslangs/:orderstatus_id',
                    //component: 'orderStatusLangs',
                    component: OrderStatusLangsComponent,
                })
                .state('charges', {
                    url: '/charges',
                    component: ChargesComponent,
                })
                .state('charge', {
                    url: '/charge/:charge_keyno',
                    component: ChargeViewComponent,
                })
                .state('chargetest', {
                    url: '/chargetest/:charge_keyno/:chargetest_keyno',
                    component: ChargeTestViewComponent,
                })
                .state('checkinmenu', {
                    url: '/checkinmenu/:argtype/:argvalue',
                    //component: 'checkInMenu',
                    component: CheckInMenuComponent,
                })
                .state('checkinstatus', {
                    url: '/checkinstatus/:argtype/:argvalue/:viewtype',
                    //component: 'checkInStatus',
                    component: CheckInStatusComponent,
                })
                .state('checkin', {
                    url: '/checkin/:argtype/:argvalue/:checkin_keyno',
                    //component: 'checkIn',
                    component: CheckInComponent,
                })
                .state('checkpointheads', {
                    url: '/checkpointheads/:argtype/:argvalue',
                    //component: 'checkPointHeads',
                    component: CheckPointHeadsComponent,
                })
                .state('checkpoints', {
                    url: '/checkpoints/:argtype/:argvalue',
                    //component: 'checkPoints',
                    component: CheckPointsComponent,
                })
                .state('trmenu', {
                    url: '/trmenu/:labour_no',
                    //component: 'timeRegisterMenu',
                    component: TrMenuComponent,
                })
                .state('labelprint', {
                    url: '/labelprint/:argtype/:argvalue',
                    component: 'labelPrint',
                })
                .state('labourjobnote', {
                    url: '/labourjobnote/:labour_no',
                    //component: 'labourJobNote',
                    component: LabourJobNoteComponent,
                })
                .state('holidaysview', {
                    url: '/holidaysview',
                    //component: 'holidaysView',
                    component: HolidaysViewComponent,
                })
                .state('holidays', {
                    url: '/holidays/:year/:country_id',
                    //component: 'holidays',
                    component: HolidaysComponent,
                })
                .state('holiday', {
                    url: '/holiday/:p2_holyday_keyno/:country_id',
                    //component: 'holiday',
                    component: HolidayComponent,
                })
                .state('shifts', {
                    url: '/shifts',
                    component: 'shifts',
                })
                .state('shift', {
                    url: '/shift/:shift_id',
                    component: 'shift',
                })
                .state('shiftday', {
                    url: '/shiftday/:shift_id/:dayno',
                    component: 'shiftDay',
                })
                .state('shiftdaytime', {
                    url: '/shiftdaytime/:shifttime_keyno/:shift_id/:dayno',
                    component: 'shiftDayTime',
                })
                .state('shiftdaybreak', {
                    url: '/shiftdaybreak/:shiftbreak_keyno/:shift_id/:dayno',
                    component: 'shiftDayBreak',
                })
                .state('shiftview', {
                    url: '/shiftview/:labour_no',
                    component: 'shiftView',
                })
                .state('shiftplans', {
                    url: '/shiftplans',
                    component: 'shiftPlans',
                })
                .state('shiftplan', {
                    url: '/shiftplan/:shiftplan_id',
                    component: 'shiftPlan',
                })
                .state('timesheets', {
                    url: '/timesheets/:labour_no',
                    //component: 'timeSheets',
                    component: TimeSheetsComponent,
                })
                .state('timesheets_status', {
                    url: '/timesheets_status',
                    //component: 'timeSheetsStatus',
                    component: TimeSheetsStatusComponent,
                })
                .state('timesheet_powtimelist', {
                    url: '/timesheet_powtimelist/:labour_no/:dateselector',
                    //component: 'timeSheetPowTimeList',
                    component: TimeSheetPowTimeListComponent,
                })
                .state('p2offdutydatas', {
                    url: '/p2offdutydatas',
                    //component: 'p2OffDutyDatas',
                    component: P2OffDutyDatasComponent,
                })
                .state('p2offdutydata', {
                    url: '/p2offdutydata/:p2_offdutydata_keyno/:labour_no',
                    //component: 'p2OffDutyData',
                    component: P2OffDutyDataComponent,
                })
                .state('trnewjob', {
                    url: '/trnewjob/:labour_no',
                    component: 'timeRegisterNewJob',
                })
                .state('selectshift', {
                    url: '/selectshift/:labour_no',
                    //component: 'selectShift',
                    component: SelectShiftComponent,
                })
                .state('trnewjobselect_op', {
                    url: '/trnewjobselect_op/:labour_no',
                    //component: 'timeRegisterNewJobSelectOp',
                    component: TrNewJobSelectOpComponent,
                })
                .state('trnewjobconf', {
                    url: '/trnewjobconf/:labour_no/:argtype/:argvalue',
                    component: 'timeRegisterNewJobConf',
                    //component: TrNewJobConfComponent,
                })
                .state('webpagesettingmenu', {
                    url: '/webpagesettingmenu/:webpage_name',
                    component: 'webpageSettingMenu',
                    component: WebpageSettingMenuComponent,
                    resolve: [VIEW_NAVIGATOR(WebpageSettingMenuComponent)],
                })
                .state('workingorders', {
                    url: '/workingorders/:ok',
                    //component: 'workingOrders',
                    component: WorkingOrdersComponent,
                    header: {
                        backButton: {
                            fallback: {
                                state: 'timesheet',
                            },
                        },
                    },
                })
                .state('workdetails', {
                    url: '/workdetails/:custact_no',
                    component: 'workDetails',
                    component: WorkDetailsComponent,
                    resolve: [VIEW_NAVIGATOR(WorkDetailsComponent)],
                    title: '',
                    header: {
                        backButton: {
                            fallback: {
                                state: 'workingorders',
                                parms: { ok: 'L' },
                            },
                        },
                    },
                })
                .state('work', {
                    url: '/work/:prod_id/:work_keyno',
                    component: 'work',
                })
                .state('prepayments', {
                    url: '/prepayments/:argtype/:argvalue',
                    //component: 'prePayments',
                    component: PrepaymentsComponent,
                })
                .state('paycheck', {
                    url: '/paycheck/:paycheck_keyno',
                    component: 'payCheck',
                })
                .state('paycheckbatch', {
                    url: '/paycheckbatch/:paycheckbatch_keyno',
                    component: 'payCheckBatch',
                })
                .state('paycheckbatches', {
                    url: '/paycheckbatches',
                    //component: 'payCheckBatches',
                    component: PayCheckBatchesComponent,
                })
                .state('payment', {
                    url: '/payment/:payment_id',
                    component: PaymentComponent,
                })
                .state('payments', {
                    url: '/payments',
                    //component: 'payments',
                    component: PaymentsComponent,
                })
                .state('prepayment', {
                    url: '/prepayment/:argtype/:argvalue/:prepayment_keyno',
                    //component: 'prePayment',
                    component: PrepaymentComponent,
                })
                .state('ftpaccount', {
                    url: '/ftpaccount/:ftpaccount_keyno',
                    component: 'ftpAccount',
                    //component: FtpAccountComponent,
                })
                .state('ftpaccounts', {
                    url: '/ftpaccounts',
                    //component: 'ftpAccounts',
                    component: FtpAccountsComponent,
                })
                .state('selectreport', {
                    url: '/selectreport/:webpage_name/:argtype/:argvalue',
                    //component: 'selectReport',
                    component: SelectReportComponent,
                })
                .state('printarg', {
                    url: '/printarg/:webpage_name/:argtype/:argvalue/:p2_reportdef_keyno',
                    component: 'printArg',
                })
                .state('printdialogue', {
                    url: '/printdialogue/:webpage_name/:argtype/:argvalue/:p2_reportdef_keyno',
                    component: 'printDialogue',
                })
                .state('printpreview', {
                    url: '/printpreview/:webpage/:argtype/:argvalue/:report_keyno/:printer_keyno',
                    component: 'printPreview',
                })
                .state('email', {
                    url: '/email',
                    component: 'email',
                })
                .state('emailaccountshared', {
                    url: '/emailaccountshared/:current_account_email',
                    component: 'emailAccountShared',
                })
                .state('emailaccountsharededit', {
                    url: '/emailaccountsharededit/:emailaccount_shared_keyno/:current_account_email',
                    component: 'emailAccountSharedEdit',
                })
                .state('emailsmarttags', {
                    url: '/emailsmarttags/:account_keyno/:isclick',
                    component: 'emailSmartTags',
                })
                .state('emailinbox', {
                    url: '/emailinbox/:account_keyno/:isclick',
                    component: 'emailInbox',
                })
                .state('emailadd', {
                    url: '/emailadd/:argtype/:argvalue/:functionname',
                    component: 'emailAdd',
                })
                .state('emailedit', {
                    url: '/emailedit/:message_id',
                    component: 'emailEdit',
                })
                .state('emailcreate', {
                    url: '/emailcreate/:webpage/:argtype/:argvalue?replyAll',
                    component: 'emailCreate',
                    component: EmailCreateViewComponent,
                })
                .state('emailtemplate', {
                    url: '/emailtemplate/:emailtemplate_keyno',
                    //component: 'emailtemplate',
                    component: EmailTemplateComponent,
                })
                .state('emailtemplates', {
                    url: '/emailtemplates',
                    //component: 'emailTemplates',
                    component: EmailTemplatesComponent,
                })
                .state('emailview', {
                    url: '/emailview/:email_keyno',
                    component: 'emailView',
                })
                .state('facts', {
                    url: '/facts',
                    component: 'facts',
                })
                .state('factsedit', {
                    url: '/factsedit/:facts_id',
                    component: 'factsedit',
                })
                .state('persfacts', {
                    url: '/persfacts',
                    //component: 'persfacts',
                    component: PersFactsComponent,
                })
                .state('persfactsedit', {
                    url: '/persfactsedit/:pers_facts_id',
                    //component: 'persfactsedit',
                    component: PersFactsEditComponent,
                })
                .state('calculationcategory', {
                    url: '/calculationcategory/:calculationhead_keyno',
                    component: 'calculationCategory',
                })
                .state('calculationoverview', {
                    url: '/calculationoverview/:calculationseasonyear_keyno',
                    //component: 'calculationOverview',
                    component: CalculationOverviewComponent,
                })
                .state('calculationseasonyear', {
                    url: '/calculationseasonyear',
                    //component: 'calculationSeasonyear',
                    component: CalculationSeasonYearComponent,
                })
                .state('calculationtextilemodel', {
                    url: '/calculationtextilemodel/:calculationhead_keyno/:textilemodelcategory7_keyno',
                    component: 'calculationTextilemodel',
                })
                .state('calview', {
                    url: '/calview/:viewtype/:argtype/:argvalue',
                    component: 'calView',
                    component: CalViewViewComponent,
                })
                .state('captasksview', {
                    url: '/captasksview/:argtype/:argvalue',
                    component: 'capTasksView',
                })
                .state('componentreplacements', {
                    url: '/componentreplacements',
                    //component: 'componentReplacements',
                    component: ComponentReplacementsComponent,
                })
                .state('componentreplacement', {
                    url: '/componentreplacement/:bom_component_replace_keyno',
                    component: 'componentReplacement',
                })
                .state('custactplanning', {
                    url: '/custactplanning/:argtype/:argvalue',
                    component: 'custactPlanning',
                })
                .state('custactplanningedit', {
                    url: '/custactplanningedit/:custactplanning_keyno',
                    component: 'custactPlanningEdit',
                })
                .state('custactprocess', {
                    url: '/custactprocess/:custact_no',
                    component: 'custactProcess',
                })
                .state('custprodaccbcs', {
                    url: '/custprodaccbcs',
                    //component: 'custprodaccbcs',
                    // Migrated Angular alternative for manual testing:
                    component: CustProdAccBcsComponent,
                })
                .state('pplanning', {
                    url: '/pplanning',
                    component: 'pPlanning',
                })
                .state('dndedit', {
                    url: '/dndedit',
                    component: 'dndEdit',
                    header: {
                        backButton: {
                            fallback: {
                                state: 'testbhw',
                            },
                        },
                    },
                })
                .state('deliverymethods', {
                    url: '/deliverymethods',
                    component: DeliveryMethodsComponent,
                    //component: 'deliveryMethods',
                })
                .state('deliverymethod', {
                    url: '/deliverymethod/:deliverymethod_no',
                    //component: 'deliveryMethod',
                    component: DeliveryMethodComponent,
                })
                .state('deliverymethodbusinessco', {
                    url: '/deliverymethodbusinessco/:deliverymethod_no',
                    component: 'deliveryMethodBusinessco',
                })
                .state('deliveryterm', {
                    url: '/deliveryterm/:deliveryterm_no',
                    component: DeliveryTermComponent,
                    //component: 'deliveryTerm',
                })
                .state('deliverytermlangs', {
                    url: '/deliverytermlangs/:deliveryterm_no',
                    component: DeliveryTermLangsComponent,
                    //component: 'deliveryTermLangs',
                })
                .state('deliveryterms', {
                    url: '/deliveryterms',
                    component: DeliveryTermsComponent,
                    //component: 'deliveryTerms',
                })
                .state('freightrate', {
                    url: '/freightrate/:freightrate_keyno',
                    //component: 'freightRate',
                    component: FreightRateComponent,
                })
                .state('freightratetype', {
                    url: '/freightratetype/:freightratetype_keyno',
                    //component: 'freightRateType',
                    component: FreightRateTypeComponent,
                })
                .state('freightratetypes', {
                    url: '/freightratetypes',
                    //component: 'freightRateTypes',
                    component: FreightRateTypesComponent,
                })
                .state('freightrateset', {
                    url: '/freightrateset/:freightrateset_keyno',
                    component: 'freightRateSet',
                })
                .state('freightratesetcreate', {
                    url: '/freightratesetcreate/:cust_no',
                    //component: 'freightRateSetCreate',
                    component: FreightRateSetCreateComponent,
                })
                .state('freightratesets', {
                    url: '/freightratesets/:cust_no',
                    //component: 'freightRateSets',
                    component: FreightRateSetsComponent,
                })
                .state('riskelements', {
                    url: '/riskelements/:argtype/:argvalue',
                    component: 'riskElements',
                })
                .state('riskelement', {
                    url: '/riskelement/:riskelement_keyno/:argtype/:argvalue',
                    component: 'riskElement',
                })
                .state('bsp', {
                    url: '/bsp/:bsp_keyno',
                    component: 'bsp',
                })
                .state('bspmenu', {
                    url: '/bspmenu/:bsp_keyno',
                    component: 'bspMenu',
                    title: '',
                })
                .state('bsps', {
                    url: '/bsps',
                    //component: 'bsps',
                    component: BspsComponent,
                })
                .state('bspsetup', {
                    url: '/bspsetup',
                    component: 'bspSetup',
                })
                .state('bspsub', {
                    url: '/bspsub/:bspsub_keyno',
                    component: 'bspSub',
                })
                .state('bspug', {
                    url: '/bspug/:bsp_keyno/:bspug_keyno',
                    component: 'bspUg',
                })
                .state('checklist', {
                    url: '/checklist/:checklist_keyno',
                    //component: 'checkList',
                    component: CheckListComponent,
                })
                .state('checklists', {
                    url: '/checklists',
                    //component: 'checkLists',
                    component: CheckListsComponent,
                })
                .state('checklistitem', {
                    url: '/checklistitem/:checklistitem_keyno/:checklist_keyno',
                    // component: 'checkListItem',
                    component: ChecklistItemComponent,
                })
                .state('checklistitemcvs', {
                    url: '/checklistitemcvs/:checklistitem_keyno',
                    component: 'checkListItemCvs',
                })
                .state('checklistitemitems', {
                    url: '/checklistitemitems/:checklistitem_keyno',
                    //component: 'checkListItemItems',
                    component: CheckListItemItemsComponent,
                })
                .state('checklistitemitem', {
                    url: '/checklistitemitem/:checklistitem_keyno/:checklistitemitem_keyno',
                    //component: 'checkListItemItem',
                    component: CheckListItemItemComponent,
                })
                .state('checklistitemtw', {
                    url: '/checklistitemtw/:argtype/:argvalue/:checklistitemtw_keyno',
                    //component: 'checkListItemTw',
                    component: CheckListItemTwComponent,
                })
                .state('checklistitemtws', {
                    url: '/checklistitemtws/:argtype/:argvalue',
                    //component: 'checkListItemTws',
                    component: CheckListItemTwsComponent,
                })
                .state('checklistdatas', {
                    url: '/checklistdatas/:argtype/:argvalue',
                    //component: 'checkListDatas',
                    component: CheckListDatasComponent,
                })
                .state('checklistdata', {
                    url: '/checklistdata/:checklistdata_keyno',
                    component: ChecklistDataComponent,
                    resolve: [VIEW_NAVIGATOR(ChecklistDataComponent)],
                })
                .state('selectchecklistadd', {
                    url: '/selectchecklistadd/:argtype/:argvalue',
                    //component: 'selectCheckListAdd',
                    component: SelectCheckListAddComponent,
                })
                .state('timeregister', {
                    url: '/timeregister/:custact_no/:powtime_keyno',
                    component: 'timeRegister',
                    header: {
                        backButton: {
                            fallback: {
                                state: 'workdetails',
                                parms: { custact_no: undefined },
                            },
                        },
                    },
                })
                .state('timeregistergraph', {
                    url: '/timeregistergraph',
                    component: 'timeRegisterGraph',
                    header: {
                        text: 'p2_m_timeregister_graph',
                        backButton: {
                            fallback: {
                                state: 'timesheet',
                            },
                        },
                    },
                })
                .state('timeregistersplit', {
                    url: '/timeregistersplit/:powtime_keyno',
                    //component: 'timeRegisterSplit',
                    component: TimeRegisterSplitComponent,
                })
                .state('webpagesetting', {
                    url: '/webpagesetting/:argtype/:argvalue',
                    component: 'webpageSetting', //,
                    component: WebpageSettingComponent,
                    resolve: [VIEW_NAVIGATOR(WebpageSettingComponent)],

                    //header: {
                    //    translate: function (params) {
                    //        return params.argtype === 'webpage_name';
                    //    },
                    //    backButton: {
                    //        fallback: {
                    //            state: { type: 'parm', source: 'argvalue' }
                    //        }
                    //    }
                    //}
                })
                .state('materialregister', {
                    url: '/materialregister/:custact_no/:powtime_keyno/:pkey/:materialtype',
                    component: 'materialRegister',
                    header: {
                        backButton: {
                            fallback: {
                                state: 'workdetails',
                                parms: { custact_no: undefined },
                            },
                        },
                    },
                })
                .state('materialgrades', {
                    url: '/materialgrades',
                    component: MaterialGradesViewComponent,
                })
                .state('materialgrade', {
                    url: '/materialgrade/:materialgrade_keyno',
                    component: MaterialGradeViewComponent,
                })
                .state('materialitems', {
                    url: '/materialitems',
                    component: MaterialItemsComponent,
                })
                .state('certificaterequirements', {
                    url: '/certificaterequirements',
                    component: CertificateRequirementsViewComponent,
                })
                .state('ultrasonicclasses', {
                    url: '/ultrasonicclasses',
                    component: UltraSonicClassesViewComponent,
                })
                .state('matcertcreate', {
                    url: '/matcertcreate/:order_internal_no',
                    component: MatcertCreateComponent,
                })
                .state('matcert', {
                    url: '/matcert/:matcert_keyno',
                    component: MatcertComponent,
                })
                .state('materialitem', {
                    url: '/materialitem/:stockbatch_keyno/:stockbatch_keyno_copyfrom',
                    component: MaterialItemViewComponent,
                })
                .state('materialitempick', {
                    url: '/materialitempick/:stockbatch_keyno/:argtype/:argvalue',
                    component: MaterialItemPickComponent,
                })
                .state('deviation', {
                    url: '/deviation/:argtype/:argvalue/:custact_no_deviation',
                    //component: 'deviation',
                    component: DeviationComponent,

                    //header: {
                    //    backButton: {
                    //        fallback: {
                    //            state: 'workdetails',
                    //            parms: { custact_no: undefined }
                    //        }
                    //    }
                    //}
                })
                .state('deviations', {
                    url: '/deviations/:argtype/:argvalue',
                    //component: 'deviations',
                    component: DeviationsComponent,

                    //header: {
                    //    backButton: {
                    //        fallback: {
                    //            state: 'workdetails',
                    //            parms: { custact_no: undefined },
                    //        },
                    //    },
                    //},
                })
                .state('deviationsettings', {
                    url: '/deviationsettings',
                    component: DeviationSettingsComponent,
                })
                .state('deviationtype', {
                    url: '/deviationtype/:deviationtype_keyno',
                    component: DeviationTypeViewComponent,
                    // component: 'deviationType',
                })
                .state('deviationcause', {
                    url: '/deviationcause/:deviationsource_keyno',
                    component: DeviationSourceViewComponent,
                    // component: 'deviationType',
                })
                .state('deviationsource', {
                    url: '/deviationsource/:deviationsource2_keyno',
                    component: DeviationSource2ViewComponent,
                    // component: 'deviationType',
                })
                .state('activitytypedevtype', {
                    url: '/activitytypedevtype/:activitytypedevtype_keyno',
                    component: ActivityTypeDevTypeComponent,
                    //component: 'activityTypeDevType',
                })
                .state('activitytypedevtypes', {
                    url: '/activitytypedevtypes/:argtype/:argvalue',
                    //component: 'activityTypeDevTypes',
                    component: ActivityTypeDevTypesComponent,
                })
                .state('activitytypeactstatus', {
                    url: '/activitytypeactstatus/:activitytypeactstatus_keyno',
                    component: ActivityTypeActStatusComponent,
                    //component: 'activityTypeActStatus',
                })
                .state('activitytypeactstatuses', {
                    url: '/activitytypeactstatuses/:argtype/:argvalue',
                    component: ActivityTypeActStatusesComponent,
                    //component: 'activityTypeActStatuses',
                })
                .state('actstatus', {
                    url: '/actstatus/:actstatus_keyno',
                    //component: 'actStatus',
                    component: ActStatusComponent,
                })
                .state('actstatuses', {
                    url: '/actstatuses',
                    component: ActStatusesComponent,
                    //component: 'actStatuses',
                })
                .state('actstatusmenu', {
                    url: '/actstatusmenu/:actstatus_keyno',
                    component: ActStatusMenuComponent,
                    //component: 'actStatusMenu',
                })
                .state('actstatuslangs', {
                    url: '/actstatuslangs/:actstatus_keyno',
                    component: ActStatusLangsComponent,
                    //component: 'actStatusLangs',
                })
                .state('acvatcodedata', {
                    url: '/acvatcodedata/:acvatcode_keyno/:acvatcodedata_keyno',
                    //component: 'acVatCodeData',
                    component: AcVatCodeDataComponent,
                })
                .state('acvatcode', {
                    url: '/acvatcode/:acvatcode_keyno',
                    //component: 'acVatCode',
                    component: AcVatCodeComponent,
                })
                .state('acvatcodes', {
                    url: '/acvatcodes',
                    //component: 'acVatCodes',
                    component: AcVatCodesComponent,
                })
                .state('acvouchertypes', {
                    url: '/acvouchertypes',
                    component: AcVoucherTypesComponent,
                    resolve: [VIEW_NAVIGATOR(AcVoucherTypesComponent)],
                })
                .state('account', {
                    url: '/account/:account_no/:businessco_no',
                    //component: 'account',
                    component: AccountComponent,
                })
                .state('accountingallocation', {
                    url: '/accountingallocation/:accountingallocation_keyno',
                    //component: 'accountingAllocation',
                    component: AccountingAllocationComponent,
                })
                .state('accountingallocationbasis', {
                    url: '/accountingallocationbasis',
                    //component: 'accountingAllocation',
                    component: AccountingAllocationBasisComponent,
                    resolve: [VIEW_NAVIGATOR(AccountingAllocationBasisComponent)],
                })
                .state('accountingallocationline', {
                    url: '/accountingallocationline/:accountingallocation_keyno/:accountingallocationline_keyno',
                    //component: 'accountingAllocationLine',
                    component: AccountingAllocationLineComponent,
                })
                .state('accountingallocations', {
                    url: '/accountingallocations',
                    //component: 'accountingAllocations',
                    component: AccountingAllocationsComponent,
                })
                .state('accountingbs', {
                    url: '/accountingbs',
                    // component: 'accountingBs',
                    component: AccountingBsComponent,
                })
                .state('accountingbunt', {
                    url: '/accountingbunt/:accountingbunt_keyno',
                    //component: 'accountingBunt',
                    component: AccountingBuntComponent,
                })
                .state('accountingbunts', {
                    url: '/accountingbunts',
                    //component: 'accountingBunts',
                    component: AccountingBuntsComponent,
                })
                .state('accountingpl', {
                    url: '/accountingpl',
                    component: 'accountingPl',
                })
                .state('accountingprocessing', {
                    url: '/accountingprocessing/:custact_no',
                    component: 'accountingProcessing',
                })
                .state('accounts', {
                    url: '/accounts',
                    //component: 'accounts',
                    component: AccountsComponent,
                })
                .state('acreportlayoutline', {
                    url: '/acreportlayoutline/:acreportlayout_keyno/:acreportlayoutline_keyno',
                    component: AcReportLayoutLineComponent,
                    //component: 'acReportLayoutLine',
                })
                .state('acreportlayoutmenu', {
                    url: '/acreportlayoutmenu/:acreportlayout_keyno',
                    component: 'acReportLayoutMenu',
                })
                .state('acreportlayout', {
                    url: '/acreportlayout/:acreportlayout_keyno',
                    component: AcReportLayoutComponent,
                    //component: 'acReportLayout',
                })
                .state('acreportlayouts', {
                    url: '/acreportlayouts',
                    component: AcReportLayoutsComponent,
                    //component: 'acReportLayouts',
                })
                .state('customerinvoicing', {
                    url: '/customerinvoicing/:argtype/:argvalue',
                    //component: 'customerInvoicing',
                    component: CustomerInvoicingComponent,
                })
                .state('customerinvoicings', {
                    url: '/customerinvoicings',
                    //component: 'customerInvoicings',
                    component: CustomerInvoicingsComponent,
                })
                .state('dataminingtable', {
                    url: '/dataminingtable/:p2_statsource_keyno/:level_no',
                    //component: 'dataMiningTable',
                    component: DataMiningTableComponent,
                })
                .state('dataimp', {
                    url: '/dataimp/:dataimp_keyno',
                    //component: 'dataImp',
                    component: DataImpComponent,
                })
                .state('dataimps', {
                    url: '/dataimps',
                    //component: 'dataImps',
                    component: DataImpsComponent,
                })
                .state('dodataimps', {
                    url: '/dodataimps',
                    //component: 'doDataImps',
                    component: DoDataImpsComponent,
                })
                .state('dodataimp', {
                    url: '/dodataimp/:dataimp_keyno',
                    component: 'doDataImp',
                    // component: DoDataImpViewComponent, // TODO: hjelp med testing før den tas i bruk.
                })
                .state('dbstation', {
                    url: '/dbstation',
                    component: DbStationComponent,
                    //component: 'dbStation',
                })
                .state('equipmentgrp', {
                    url: '/equipmentgrp/:equipmentgrp_id',
                    //component: 'equipmentGrp',
                    component: EquipmentGrpComponent,
                })
                .state('equipmentgrplang', {
                    url: '/equipmentgrplang/:equipmentgrp_id',
                    //component: 'equipmentGrpLang',
                    component: EquipmentGrpLangComponent,
                })

                .state('equipmentgrpmenu', {
                    url: '/equipmentgrpmenu/:equipmentgrp_id',
                    //component: 'equipmentGrpMenu',
                    component: EquipmentGrpMenuComponent,
                })

                .state('equipmentgrps', {
                    url: '/equipmentgrps',
                    //component: 'equipmentGrps',
                    component: EquipmentGrpsComponent,
                })

                .state('equipmentlist', {
                    url: '/equipmentlist/:argtype/:argvalue',
                    //component: 'equipmentList',
                    component: EquipmentListComponent,
                })

                .state('factoringbunt', {
                    url: '/factoringbunt/:factoringbunt_keyno',
                    //component: 'factoringBunt',
                    component: FactoringBuntComponent,
                    resolve: [VIEW_NAVIGATOR(FactoringBuntComponent)],
                })

                .state('factoringbunts', {
                    url: '/factoringbunts',
                    //component: 'factoringBunts',
                    component: FactoringBuntsComponent,
                })
                .state('furniturefabricscolor', {
                    url: '/furniturefabricscolor/:furniturefabrics_id/:furniturefabricscolor_id',
                    //component: 'furnitureFabricsColor',
                    component: FurnitureFabricsColorComponent,
                })
                .state('furniturefabricscolors', {
                    url: '/furniturefabricscolors/:furniturefabrics_id',
                    //component: 'furnitureFabricsColors',
                    component: FurnitureFabricsColorsComponent,
                })
                .state('furniturefabricsmenu', {
                    url: '/furniturefabricsmenu/:furniturefabrics_id',
                    //component: 'furnitureFabricsMenu',
                    component: FurnitureFabricsMenuComponent,
                })
                .state('metacolumn', {
                    url: '/metacolumn/:metatable_keyno/:metacolumn_keyno',
                    //component: 'metaColumn',
                    component: MetaColumnComponent,
                })
                .state('metacolumnitem', {
                    url: '/metacolumitem/:metacolumn_keyno/:metacolumnitem_keyno',
                    component: MetaColumnItemComponent,
                })
                .state('metacolumns', {
                    url: '/metacolumns/:metatable_keyno',
                    //component: 'metaColumns',
                    component: MetaColumnsComponent,
                })
                .state('metatable', {
                    url: '/metatable/:metatable_keyno',
                    //component: 'metaTable',
                    component: MetaTableComponent,
                })
                .state('metatabledata', {
                    url: '/metatabledata/:metatable_keyno/:metatableview_keyno',
                    component: 'metaTableData',
                })
                .state('metatabledatadetail', {
                    url: '/metatabledatadetail/:metatable_keyno/:pkey',
                    component: 'metaTableDataDetail',
                })
                .state('metatabledatas', {
                    url: '/metatabledatas',
                    //component: 'metaTableDatas',
                    component: MetaTableDatasComponent,
                })
                .state('metatablemenu', {
                    url: '/metatablemenu/:metatable_keyno',
                    //component: 'metaTableMenu',
                    component: MetaTableMenuComponent,
                })
                .state('metatables', {
                    url: '/metatables',
                    //component: 'metaTables',
                    component: MetaTablesComponent,
                })
                .state('operationequipments', {
                    url: '/operationequipments/:argtype/:argvalue',
                    component: 'operationEquipments',
                })
                .state('metatableview', {
                    url: '/metatableview/:metatable_keyno/:metatableview_keyno',
                    //component: 'metaTableView',
                    component: MetaTableViewComponent,
                })
                .state('metatableviews', {
                    url: '/metatableviews/:metatable_keyno',
                    //component: 'metaTableViews',
                    component: MetaTableViewsComponent,
                })
                .state('orderheadcapjob', {
                    url: '/orderheadcapjob/:order_internal_no',
                    //component: 'orderHeadCapJob',
                    component: OrderHeadCapJobComponent,
                    resolve: [VIEW_NAVIGATOR(OrderHeadCapJobComponent)],
                })

                .state('operationmenu', {
                    url: '/operationmenu/:operation_id',
                    //component: 'operationMenu',
                    component: OperationMenuComponent,
                })

                .state('pohtopop', {
                    url: '/pohtopop/:poh_keyno_top',
                    //component: 'pohTopOp',
                    component: PohTopOpComponent,
                    resolve: [VIEW_NAVIGATOR(PohTopOpComponent)],
                })
                .state('popurchplanning', {
                    url: '/popurchplanning',
                    //component: 'poPurchPlanning',
                    component: PoPurchPlanningComponent,
                    resolve: [VIEW_NAVIGATOR(PoPurchPlanningComponent)],
                })
                .state('pos', {
                    url: '/pos/:argtype/:argvalue',
                    component: 'pos',
                })
                .state('powtimes', {
                    url: '/powtimes/:argtype/:argvalue',
                    component: 'powTimes',
                })
                .state('producthazardlabels', {
                    url: '/producthazardlabels/:prod_id',
                    component: 'productHazardLabels',
                })
                .state('projectinvoicing', {
                    url: '/projectinvoicing/:project_keyno/:invoice_cust_no',
                    //component: 'projectInvoicing',
                    component: ProjectInvoicingComponent,
                })
                .state('projectinvoicings', {
                    url: '/projectinvoicings',
                    //component: 'projectInvoicings',
                    component: ProjectInvoicingsComponent,
                })
                .state('purchpriceupdate', {
                    url: '/purchpriceupdate/:argtype/:argvalue',
                    component: 'purchPriceUpdate',
                })
                .state('deviationtypelangs', {
                    url: '/deviationtypelangs/:deviationtype_keyno',
                    //component: 'deviationTypeLangs',
                    component: DeviationTypeLangsComponent,
                })
                .state('deviationtypemenu', {
                    url: '/deviationtypemenu/:deviationtype_keyno',
                    //component: 'deviationTypeMenu',
                    component: DeviationTypeMenuComponent,
                })
                .state('deviationtypes', {
                    url: '/deviationtypes/:activitytype_no',
                    //component: 'deviationTypes',
                    component: DeviationTypesComponent,
                })
                .state('custactedit', {
                    url: '/custactedit/:custact_no/:filterfield/:filtervalue',
                    // component: 'custactEdit',
                    component: CustactEditComponent,
                    resolve: [VIEW_NAVIGATOR(CustactEditComponent)],

                    //header: {
                    //    backButton: {
                    //        fallback: {
                    //            state: 'workdetails',
                    //            parms: { custact_no: undefined }
                    //        }
                    //    }
                    //}
                })
                .state('custactdeadlines', {
                    url: '/custactdeadlines/:argtype/:argvalue',
                    //component: 'custactDeadLines',
                    component: CustactDeadLinesComponent,
                })
                .state('activitytype', {
                    url: '/activitytype/:activitytype_no',
                    //component: 'activityType',
                    component: ActivityTypeComponent,
                })
                .state('activitytypelangs', {
                    url: '/activitytypelangs/:activitytype_no',
                    component: ActivityTypeLangsComponent,
                    //component: 'activityTypeLangs',
                })
                .state('activitytypes', {
                    url: '/activitytypes',
                    //component: 'activityTypes',
                    component: ActivityTypesComponent,
                })
                .state('powtimegroup', {
                    url: '/powtimegroup/:cust_no/:project_keyno/:projectprosess_keyno/:custact_no/:date_start/:date_end/:grouptype/:equipment_id/:labour_no/:prod_id',
                    component: 'powtimeGroup',
                    header: {
                        backButton: {
                            fallback: {
                                state: 'workdetails',
                                parms: { custact_no: undefined },
                            },
                        },
                    },
                })
                .state('powtimeapproval', {
                    url: '/powtimeapproval/:argtype/:argvalue',
                    component: 'powTimeApproval',
                })
                .state('powtimeapprovals', {
                    url: '/powtimeapprovals',
                    //component: 'powTimeApprovals',
                    component: PowTimeApprovalsComponent,
                })
                .state('powtimepaycheckls', {
                    url: '/powtimepaycheckls/:argtype/:argvalue',
                    //component: 'powTimePayCheckLs',
                    component: PowTimePayCheckLsComponent,
                })
                .state('timeinouts', {
                    url: '/timeinouts/:argtype/:argvalue',
                    //component: 'timeInOuts',
                    component: TimeInOutsComponent,
                })
                .state('custactcomp', {
                    url: '/custactcomp/:custact_no/:custactcomp_keyno',
                    component: 'custactComp',
                })
                .state('custactcomps', {
                    url: '/custactcomps/:custact_no',
                    component: 'custactComps',
                })
                .state('custactcompadd', {
                    //    url: '/custactcompadd/:custact_no/:custactcomp_keyno',
                    component: 'custactCompAdd',
                })
                .state('ordercustomerservice', {
                    url: '/ordercustomerservice/:order_internal_no',
                    component: 'orderCustomerService',
                })
                .state('orderline', {
                    url: '/orderline/:order_internal_no/:orderline_keyno',
                    component: 'orderLine',
                })
                .state('orderlinebom', {
                    url: '/orderlinebom/:orderline_keyno',
                    component: 'orderLineBom',
                })
                .state('poconnectedpositions', {
                    url: '/poconnectedpositions/:po_keyno',
                    component: PoConnectedPositionsComponent,
                    resolve: [VIEW_NAVIGATOR(PoConnectedPositionsComponent)],
                })
                .state('orderlineedit', {
                    url: '/orderlineedit/:argtype/:argvalue/:orderline_keyno',
                    component: 'orderLineEdit',
                })
                .state('orderlinems', {
                    url: '/orderlinems/:argtype/:headno/:lineno',
                    //component: 'orderLineMs',
                    component: SelectLineModelViewComponent,
                })
                .state('orderlineps', {
                    url: '/orderlineps/:argtype/:headno/:lineno/:selected_item_id',
                    //component: 'orderLinePs',
                    component: SelectLineProductsViewComponent,
                })
                .state('productsconfig', {
                    url: '/productsconfig/:argtype/:headno/:lineno',
                    // component: 'productsConfig',
                    component: ProductsConfigViewComponent,
                })
                .state('productstructures', {
                    url: '/productstructures',
                    component: 'productStructures',
                })
                .state('productbom', {
                    url: '/productbom/:prod_id',
                    // component: 'productBom',
                    component: ProductBomComponent,
                    resolve: [VIEW_NAVIGATOR(ProductBomComponent)],
                })
                .state('selectprodsize', {
                    url: '/selectprodsize/:webpage_name/:parm1/:parm2/:prod_id',
                    component: 'selectProdsize',
                })
                .state('selectprodchoice', {
                    url: '/selectprodchoice/:choice_keyno/:argtype/:argvalue',
                    component: 'selectProdChoice',
                })
                .state('postcalc', {
                    url: '/postcalc/:argtype/:argvalue',
                    //component: 'postCalc',
                    component: PostCalcComponent,
                })
                .state('custactcalc', {
                    url: '/custactcalc/:argtype/:argvalue',
                    // component: 'custactCalc',
                    component: CustactCalcComponent,
                })
                .state('custactcalcadjustdisc', {
                    url: '/custactcalcadjustdisc/:custact_no',
                    //component: 'custactCalcAdjustDisc',
                    component: CustactCalcAdjustDiscComponent,
                })
                .state('custactcalcedit', {
                    url: '/custactcalcedit/:custact_no',
                    component: 'custactCalcEdit',
                })
                .state('custactcalceditmodal', {
                    url: '/custactcalceditmodal/:custact_no',
                    component: 'custactCalcEditModal',
                })
                .state('custactcalcpick', {
                    url: '/custactcalcpick/:p2_pofinish_keyno/:custact_no',
                    //component: 'custactCalcPick',
                    component: CustactCalcPickComponent,
                    resolve: [VIEW_NAVIGATOR(CustactCalcPickComponent)],
                })
                .state('custactcalcpickselect', {
                    url: '/custactcalcpickselect/:p2_pofinish_keyno/:custact_no',
                    //component: 'custactCalcPickSelect',
                    component: CustactCalcPickSelectComponent,
                })
                .state('custactcalcjobexit', {
                    url: '/custactcalcjobexit/:labour_no/:custactcalc_custact_no/:function_name',
                    component: 'custactCalcJobExit',
                    // component: CustactCalcJobExitComponent,
                    // resolve: [VIEW_NAVIGATOR(CustactCalcJobExitComponent)],
                })
                .state('custactworks', {
                    url: '/custactworks/:custact_no',
                    //component: 'custactWorks',
                    component: CustactWorksComponent,
                })
                .state('custactwork', {
                    url: '/custactwork/:custact_no/:custactwork_keyno',
                    //component: 'custactWork',
                    component: CustactWorkComponent,
                })
                .state('custactmembers', {
                    url: '/custactmembers/:custact_no',
                    //component: 'custactMembers',
                    component: CustactMembersComponent,
                })
                .state('custactmemberedit', {
                    url: '/custactmemberedit/:custact_no/:custact_member_keyno',
                    //component: 'custactMemberEdit',
                    component: CustactMemberEditComponent,
                })
                .state('selectportaluser', {
                    url: '/selectportaluser/:webpage/:arg1',
                    //component: 'selectPortalUser',
                    component: SelectPortalUserComponent,
                })
                .state('custactdialogs', {
                    url: '/custactdialogs/:custact_no',
                    // component: 'custactDialogs',
                    component: CustactDialogsComponent,
                    resolve: [VIEW_NAVIGATOR(CustactDialogsComponent)],
                })
                .state('subtasks', {
                    url: '/subtasks/:custact_no/:retrievetype/:include_top',
                    component: 'subtasks',
                    //component: SubtasksComponent,
                })
                .state('custactgantt', {
                    url: '/custactgantt/:connectto/:connectto_value',
                    component: 'custactGantt',
                })
                .state('categorylistmain', {
                    url: '/categorylistmain',
                    component: CategoryListMainComponent,
                    //component: 'categoryListMain',
                })
                .state('categorylinks', {
                    url: '/categorylinks/:category_keyno_belongto/:categorylink_keyno',
                    //component: 'categoryLinks',
                    component: CategoryLinksComponent,
                })
                .state('categorylinkadd', {
                    url: '/categorylinkadd/:category_keyno_belongto',
                    //component: 'categoryLinkAdd',
                    component: CategoryLinkAddComponent,
                })
                .state('categorydatas', {
                    url: '/categorydatas/:argtype/:argvalue',
                    //component: 'categoryDatas',
                    component: CategoryDatasComponent,
                })
                .state('categorydataselect', {
                    url: '/categorydataselect/:argtype/:argvalue',
                    component: 'categoryDataSelect',
                    //component: CategoryDataSelectComponent,
                })
                .state('subtaskselect', {
                    url: '/subtaskselect/:argtype/:argvalue/:custact_no_addto',
                    component: 'subtaskSelect',
                })
                .state('consignmentbatches', {
                    url: '/consignmentbatches',
                    component: 'consignmentBatches',
                })
                .state('consignmentbatchconsignments', {
                    url: '/consignmentbatchconsignments/:consignmentbatch_keyno',
                    //component: 'consignmentBatchConsignments',
                    component: ConsignmentBatchConsignmentsComponent,
                })
                .state('docarticlemenu', {
                    url: '/docarticlemenu',
                    // component: 'docArticleMenu',
                    component: DocarticleMenuComponent,
                })
                .state('ohdirectdelivery', {
                    url: '/ohdirectdelivery/:order_internal_no',
                    //component: 'ohDirectDelivery',
                    component: OhDirectDeliveryComponent,
                })
                .state('ohdispatches', {
                    url: '/ohdispatches/:argtype/:argvalue',
                    component: 'ohDispatches',
                    //component: OhDispatchesComponent,
                })
                .state('productionmenu', {
                    url: '/productionmenu',
                    // component: 'productionMenu',
                    component: ProductionMenuComponent,
                })

                .state('productionconfirmation', {
                    url: '/productionconfirmation',
                    component: 'productionConfirmation',
                })

                .state('productionrouting', {
                    url: '/productionrouting/:productionrouting_keyno',
                    //component: 'productionRouting',
                    component: ProductionRoutingComponent,
                })

                .state('productionroutingadd', {
                    url: '/productionroutingadd/:prod_id',
                    //component: 'productionRoutingAdd',
                    component: ProductionRoutingAddComponent,
                })

                .state('productionroutingmenu', {
                    url: '/productionroutingmenu/:productionrouting_keyno',
                    //component: 'productionRoutingMenu',
                    component: ProductionRoutingMenuComponent,
                })
                .state('productionroutingcomp', {
                    url: '/productionroutingcomp/:productionroutingcomp_keyno/:productionrouting_keyno',
                    //component: 'productionRoutingMenu',
                    component: ProductionRoutingCompViewComponent,
                })

                .state('productionroutings', {
                    url: '/productionroutings',
                    //component: 'productionRoutings',
                    component: ProductionRoutingsComponent,
                })

                .state('productionroutingwork', {
                    url: '/productionroutingwork/:productionroutingwork_keyno/:productionrouting_keyno',
                    component: 'productionRoutingWork',
                })

                .state('epmenu', {
                    url: '/epmenu',
                    // component: 'epMenu',
                    component: ExternalProductionMenuComponent,
                })

                .state('epproductioncompletion', {
                    url: '/epproductioncompletion',
                    component: 'epProductionCompletion',
                })

                .state('epblockorders', {
                    url: '/epblockorders',
                    component: 'epBlockOrders',
                })

                .state('epblockordersfinished', {
                    url: '/epblockordersfinished',
                    component: 'epBlockOrdersFinished',
                })

                .state('epblockordersfinishedshipments', {
                    url: '/epblockordersfinishedshipments/:pohKeyno',
                    component: 'epBlockOrdersFinishedShipments',
                })

                .state('epblockorderedit', {
                    url: '/epblockorder/edit/:pohKeyno',
                    component: 'epBlockOrderEdit',
                })

                .state('epblockorderplan', {
                    url: '/epblockorder/plan/:pohKeyno',
                    component: 'epBlockOrderPlan',
                })

                .state('epshipmentprevious', {
                    url: '/epshipmentprevious',
                    component: 'epShipmentPrevious',
                })

                .state('epshipmentpreviousview', {
                    url: '/epshipmentpreviousview/:shipmentContainerKeyno',
                    component: 'epShipmentPreviousView',
                })

                .state('epshipmentcompletion', {
                    url: '/epshipmentcompletion',
                    component: 'epShipmentCompletion',
                })

                .state('epshipmentcompletionscan', {
                    url: '/epshipmentcompletionscan/:shipmentContainerKeyno',
                    component: 'epShipmentCompletionScan',
                })

                .state('epschenkeroverview', {
                    url: '/epschenkeroverview',
                    component: 'epSchenkerOverview',
                })

                .state('epschenkeroverviewgetedi', {
                    url: '/epschenkeroverviewgetedi/:shipmentContainerKeyno',
                    component: 'epSchenkerOverviewGetEdi',
                })

                .state('favorites', {
                    url: '/favorites',
                    component: 'favorites',
                })

                .state('productionstatus', {
                    url: '/productionstatus',
                    //component: 'productionStatus',
                    component: ProductionStatusComponent,
                })
                .state('po', {
                    url: '/po/:po_keyno',
                    //component: 'po',
                    component: PoComponent,
                })
                .state('pocreate', {
                    url: '/pocreate/:stock_keyno',
                    component: 'poCreate',
                })
                .state('poh', {
                    url: '/poh/:poh_keyno',
                    //component: 'poh',
                    component: PohComponent,
                })
                .state('pohkeynotopstatus', {
                    url: '/pohkeynotopstatus/:poh_keyno_top',
                    //component: 'pohKeynoTopStatus',
                    component: PohKeynoTopStatusComponent,
                })
                .state('pohtop', {
                    url: '/pohtop/:poh_keyno_top',
                    //component: 'pohTop',
                    component: PohTopComponent,
                })
                .state('pohtops', {
                    url: '/pohtops/:argtype/:argvalue',
                    component: 'pohTops',
                })
                .state('pickjobgrp', {
                    url: '/pickjobgrp/:stockplace_id/:pickjobgrp_keyno',
                    // component: 'pickJobGrp',
                    component: PickJobGroupComponent,
                })
                .state('pickjobgrps', {
                    url: '/pickjobgrps/:stockplace_id',
                    component: PickJobGrpsComponent,
                    //component: 'pickJobGrps',
                })
                .state('prodsizes', {
                    url: '/prodsizes/:prod_id',
                    //component: 'prodSizes',
                    component: ProdSizesComponent,
                })
                .state('productionhtops', {
                    url: '/productionhtops/:argtype/:argvalue/:counter',
                    component: 'productionhTops',
                })

                .state('productionpo', {
                    url: '/productionpo', // /:argtype/:argvalue/:counter'
                    component: 'productionPo',
                })
                .state('stockplacesto', {
                    url: '/stockplacesto/:stockplace_id_from',
                    component: StockPlacesToComponent,
                    //component: 'stockPlacesTo',
                })
                .state('vatreport', {
                    url: '/vatreport/:businessco_no/:accounting_year/:vatreport_keyno',
                    //component: 'vatReport',
                    component: VatReportComponent,
                })
                .state('vatreportmenu', {
                    url: '/vatreportmenu/:vatreport_keyno',
                    component: 'vatReportMenu',
                })
                .state('vatreports', {
                    url: '/vatreports',
                    //component: 'vatReports',
                    component: VatReportsComponent,
                })
                .state('vatspesification', {
                    url: '/vatspesification',
                    component: VatSpesificationComponent,
                })
                .state('vt', {
                    url: '/vt/:vt_keyno',
                    component: 'vt',
                })
                .state('vtlink', {
                    url: '/vtlink/:vt_keyno/:vtlink_keyno',
                    component: 'vtLink',
                })
                .state('vts', {
                    url: '/vts',
                    component: 'vts',
                })
                .state('productionhtopscomponents', {
                    url: '/productionhtopscomponents/:argtype/:argvalue/:counter',
                    component: 'productionhTopsComponents',
                })
                .state('orderlinestatus', {
                    url: '/orderlinestatus/:order_internal_no',
                    //component: 'orderlineStatus',
                    component: OrderLineStatusComponent,
                })
                .state('webpagesettingedit', {
                    url: '/webpagesettingedit/:p2_webpage_setting_keyno',
                    component: 'webpageSettingEdit',
                })

                .state('consignmentmenu', {
                    url: '/consignmentmenu',
                    // component: 'consignmentMenu',
                    component: ConsignmentMenuComponent,
                })

                .state('consignmentdelivery', {
                    url: '/consignmentdelivery',
                    //component: 'consignmentDelivery',
                    component: ConsignmentDeliveryComponent,
                })

                .state('consignmentdeliveryactivity', {
                    url: '/consignmentdeliveryactivity/:custact_no/:order_order_no',
                    component: 'consignmentDeliveryActivity',
                })

                .state('consignmentdeliveryconfirm', {
                    url: '/consignmentdeliveryconfirm/:checklistdata_keyno/:custact_no/:order_order_no',
                    component: 'consignmentDeliveryConfirm',
                })

                .state('toolsmenu', {
                    url: '/toolsmenu',
                    // component: 'toolsMenu',
                    component: ToolsMenuComponent,
                })
                .state('p2importprocs', {
                    url: '/p2importprocs',
                    //component: 'p2ImportProcs',
                    component: P2ImportProcsComponent,
                })
                .state('p2importproc', {
                    url: '/p2importproc/:p2_importproc_keyno',
                    //component: 'p2ImportProc',
                    component: P2ImportProcComponent,
                })
                .state('purchasecreate', {
                    url: '/purchasecreate/:textilemodel_id',
                    component: 'purchaseCreate',
                })
                .state('purchasemenu', {
                    url: '/purchasemenu',
                    // component: 'purchaseMenu',
                    component: PurchaseMenuComponent,
                })
                .state('purchaseplanning', {
                    url: '/purchaseplanning',
                    component: 'purchasePlanning',
                })
                .state('purchaseplanningorderoverviewstyle', {
                    url: '/purchaseplanningorderoverviewstyle/:textilemodel_id',
                    component: 'purchasePlanningOrderOverviewStyle',
                })
                .state('deliverymethodservices', {
                    url: '/deliverymethodservices/:deliverymethod_no',
                    component: DeliveryMethodServicesComponent,
                    //component: 'deliveryMethodServices',
                })
                .state('transcarrierserviceactive', {
                    url: '/transcarrierserviceactive/:transcarrier_service_active_keyno/:deliverymethod_no',
                    component: TranscarrierServiceActiveComponent,
                    //component: 'transcarrierServiceActive',
                })
                .state('carrier', {
                    url: '/carrier/:carrier_keyno',
                    component: 'carrier',
                })
                .state('carrierlist', {
                    url: '/carrierlist',
                    //component: 'carrierList',
                    component: CarrierListComponent,
                })
                .state('carriers', {
                    url: '/carriers',
                    component: 'carriers',
                })
                .state('crmmenu', {
                    // SKAL DEFINERE NAMNET PÅ SIDA
                    url: '/crmmenu',
                    // component: 'crmMenu', // SKAL INFORMERE OM NAMNET PÅ COMPONENT HTML-SIDA ER BUNDEN TIL
                    component: CrmMenuComponent,
                    header: {
                        // SKAL DEFINERE FUNKSJONALITETEN I HEADER
                        backButton: {
                            // SKAL DEFINERE TILBAKE-KNAPPEN
                            text: 'main_menu', // SKAL DEKLARERE NAMNET PÅ TILBAKE-KNAPPEN
                            fallback: {
                                // FUNKSJON SOM SKAL DEKLARERE FØRRE SIDE I TILBAKE-KNAPPEN
                                state: 'mainmenu', // SKAL DEKLARERE NAMN PÅ FØRRE SIDE
                            },
                        },
                    },
                })
                .state('ecommercemenu', {
                    url: '/ecommercemenu',
                    component: EcommerceMenuComponent,
                    // component: 'eCommerceMenu',
                    header: {
                        backButton: {
                            text: 'main_menu',
                            fallback: {
                                state: 'mainmenu',
                            },
                        },
                    },
                })
                .state('settings', {
                    url: '/settings',
                    component: 'settings',
                    // component: SettingsComponent,
                    header: {
                        backButton: {
                            text: 'main_menu',
                            fallback: {
                                state: 'mainmenu',
                            },
                        },
                    },
                });

            $stateProvider
                .state('diary', {
                    url: '/diary',
                    component: 'diary',
                })
                .state('subscription', {
                    url: '/subscription/:subscription_keyno',
                    component: 'subscription',
                })
                .state('subscriptiongrid', {
                    url: '/subscriptiongrid/:argtype/:argvalue',
                    //component: 'subscriptionGrid',
                    component: SubscriptionGridComponent,
                })
                .state('subscriptionline', {
                    url: '/subscriptionline/:subscription_keyno/:subscriptionline_keyno',
                    component: 'subscriptionLine',
                })
                .state('subscriptions', {
                    url: '/subscriptions',
                    //component: 'subscriptions',
                    component: SubscriptionsComponent,
                })
                .state('business', {
                    url: '/business/:business_id',
                    //component: 'business',
                    component: BusinessComponent,
                })
                .state('businessco', {
                    url: '/businessco/:businessco_no',
                    //component: 'businessCo',
                    component: BusinessCoComponent,
                })
                .state('businesscodefaultcounter', {
                    url: '/businesscodefaultcounter/:defaultcounter_keyno/:businessco_no',
                    component: BusinessCoDefaultCounterComponent,
                })
                .state('businesscodefaultcounters', {
                    url: '/businesscodefaultcounters/:businessco_no',
                    component: BusinessCoDefaultCountersComponent,
                })
                .state('businessco_bankaccount', {
                    url: '/businessco_bankaccount/:businessco_no/:businessco_bankaccount_keyno',
                    component: 'businessCoBankAccount',
                    //component: BusinessCoBankAccountComponent,
                })
                .state('businesscoaccounting', {
                    url: '/businesscoaccounting/:businessco_no',
                    component: 'businesscoaccounting',
                    //component: BusinessCoAccountingComponent,
                })
                .state('businesscoonboarding', {
                    url: '/businesscoonboarding',
                    //component: 'businesscoOnBoarding',
                    component: BusinessCoOnBoardingComponent,
                })
                .state('businesscos', {
                    url: '/businesscos',
                    //component: 'businesscos',
                    component: BusinessCosComponent,
                })
                .state('businesscosettings', {
                    url: '/businesscosettings/:businessco_no',
                    component: BusinesscoSettingsComponent,
                    //component: 'businesscoSettings',
                })
                .state('businesscosettingsmtp', {
                    url: '/businesscosettingsmtp/:businessco_no',
                    // component: 'businesscoSettingSmtp',
                    component: BusinesscoSettingSmtpComponent,
                })
                .state('businesscosettingcargonizer', {
                    url: '/businesscosettingcargonizer/:businessco_no',
                    //component: 'businesscoSettingCargonizer',
                    component: BusinessCoSettingCargonizerComponent,
                })
                .state('businesscosettingsvea', {
                    url: '/businesscosettingsvea/:businessco_no',
                    component: 'businesscoSettingSvea',
                })
                .state('businesslang', {
                    url: '/businesslang/:business_id',
                    //component: 'businessLang',
                    component: BusinessLangComponent,
                })
                .state('businessmenu', {
                    url: '/businessmenu/:business_id',
                    //component: 'businessMenu',
                    component: BusinessMenuComponent,
                })
                .state('businesss', {
                    url: '/businesss',
                    //component: 'businessS',
                    component: BusinessSComponent,
                })
                .state('businesssite', {
                    url: '/businesssite/:businesssite_keyno',
                    component: BusinessSiteComponent,
                    //component: 'businessSite',
                })
                .state('businesssites', {
                    url: '/businesssites',
                    component: BusinessSitesComponent,
                    //component: 'businessSites',
                })
                .state('cargonizerprinters', {
                    url: '/cargonizerprinters',
                    //component: 'cargonizerPrinters',
                    component: CargonizerPrintersComponent,
                })
                .state('externalapis', {
                    url: '/externalapis',
                    //component: 'externalApis',
                    component: ExternalApisComponent,
                })
                .state('externalapi', {
                    url: '/externalapi/:external_api_keyno',
                    //component: 'externalApi',
                    component: ExternalApiComponent,
                })
                .state('poplans', {
                    url: '/poplans',
                    component: 'poPlans',
                })
                .state('poplansprod', {
                    url: '/poplansprod/:stock_keyno/:date_to',
                    component: 'poPlansProd',
                })
                .state('cargonizerprinteredit', {
                    url: '/cargonizerprinteredit/:cargonizer_printer_keyno',
                    //component: 'cargonizerPrinterEdit',
                    component: CargonizerPrinterEditComponent,
                })
                .state('portaluserstockplace', {
                    url: '/portaluserstockplace/:portal_user_keyno',
                    component: 'portalUserStockplace',
                })
                .state('portalusersignature', {
                    url: '/portalusersignature/:portal_user_keyno',
                    //component: 'portalUserSignature',
                    component: PortalUserSignatureComponent,
                })
                // === Migration: Choice Possibility Rule ===

                // Legacy route
                .state('choicepossrule', {
                    url: '/choicepossrule/:choicepossrule_keyno',
                    component: 'choicePossRule',
                })
                // Angular test route
                .state('choicepossrule-test', {
                    url: '/choicepossrule-test/:choicepossrule_keyno',
                    component: ChoicePossRuleComponent,
                })
                // === Migration: Choice Possibility Rules Run ===

                // Legacy route
                .state('choicepossrulesrun', {
                    url: '/choicepossrulesrun',
                    component: 'choicePossRulesRun',
                })
                // Angular test route
                .state('choicepossrulesrun-test', {
                    url: '/choicepossrulesrun-test',
                    component: ChoicePossRulesRunComponent,
                })
                // === Migration: Choice Possibility Rules ===

                // Legacy route
                .state('choicepossrules', {
                    url: '/choicepossrules/:argtype/:argvalue',
                    component: 'choicePossRules',
                })
                // Angular test route
                .state('choicepossrules-test', {
                    url: '/choicepossrules-test/:argtype/:argvalue',
                    component: ChoicePossRulesComponent,
                })
                .state('choiceprodpricegrp', {
                    url: '/choiceprodpricegrp/:choiceprodpricegrp_keyono/:prod_id_choice',
                    //component: 'choiceProdPriceGrp',
                    component: ChoiceProdPriceGrpComponent,
                })
                .state('choiceprodpricegrps', {
                    url: '/choiceprodpricegrps/:prod_id',
                    //component: 'choiceProdPriceGrps',
                    component: ChoiceProdPriceGrpsComponent,
                })
                .state('choice', {
                    url: '/choice/:choice_keyno',
                    //component: 'choice',
                    component: ChoiceComponent,
                })
                .state('choicepossibilitylist', {
                    url: '/choicepossibilitylist/:choice_keyno',
                    //component: 'choicePossibilityList',
                    component: ChoicePossibilityListComponent,
                })
                .state('pricegrid', {
                    url: '/pricegrid',
                    component: 'priceGrid',
                })
                .state('priceindex', {
                    url: '/priceindex/:priceindex_keyno',
                    //component: 'priceIndex',
                    component: PriceIndexComponent,
                })
                .state('priceindexes', {
                    url: '/priceindexes',
                    //component: 'priceIndexes',
                    component: PriceIndexesComponent,
                })
                .state('priceindexmenu', {
                    url: '/priceindexmenu/:priceindex_keyno',
                    component: 'priceIndexMenu',
                    //component: PriceIndexMenuComponent,
                })
                .state('activitygrid', {
                    url: '/activitygrid/:argtype/:argvalue',
                    //component: 'activityGrid',
                    component: ActivityGridComponent,
                })
                .state('addexistingdocarc', {
                    url: '/addexistingdocarc/:argtype/:argvalue',
                    component: 'addExistingDocArc',
                })
                .state('choices', {
                    url: '/choices/:prod_id',
                    //component: 'choices',
                    component: ChoicesComponent,
                })
                .state('collection', {
                    url: '/collection/:collection_keyno',
                    //component: 'collection',
                    component: CollectionComponent,
                })
                .state('collectionlangs', {
                    url: '/collectionlangs/:collection_keyno',
                    //component: 'collectionLangs',
                    component: CollectionLangsComponent,
                })
                .state('collectionmenu', {
                    url: '/collectionmenu/:collection_keyno',
                    //component: 'collectionMenu',
                    component: CollectionMenuComponent,
                })
                .state('collections', {
                    url: '/collections',
                    //component: 'collections',
                    component: CollectionsComponent,
                })
                .state('colorgrpmenu', {
                    url: '/colorgrpmenu/:colorgrp_id',
                    //component: 'colorGrpMenu',
                    component: ColorGrpMenuComponent,
                })
                .state('colorgrp', {
                    url: '/colorgrp/:colorgrp_id',
                    //component: 'colorGrp',
                    component: ColorGrpComponent,
                })
                .state('colorgrps', {
                    url: '/colorgrps',
                    //component: 'colorGrps',
                    component: ColorGrpsComponent,
                })
                .state('colorgrplang', {
                    url: '/colorgrplang/:colorgrp_id',
                    //component: 'colorGrpLang',
                    component: ColorGrpLangComponent,
                })
                .state('crmselection', {
                    url: '/crmselection',
                    component: 'crmselection',
                })
                .state('custactacmatch', {
                    url: '/custactacmatch/:custactac_keyno',
                    component: 'custactAcMatch',
                })
                .state('custactcomplaint', {
                    url: '/custactcomplaint/:custact_no',
                    component: 'custactComplaint',
                })
                .state('custactcomplaintline', {
                    url: '/custactcomplaintline/:custactproduct_keyno',
                    component: 'custactComplaintLine',
                })
                .state('custfacts', {
                    url: '/custfacts/:cust_no',
                    //component: 'custfacts',
                    component: CustFactsComponent,
                })
                .state('edidestination', {
                    url: '/edidestination/:edi_destination_keyno',
                    //component: 'ediDestination',
                    component: EdiDestinationComponent,
                })
                .state('edidestinations', {
                    url: '/edidestinations',
                    //component: 'ediDestinations',
                    component: EdiDestinationsComponent,
                })
                .state('ediimportfileupload', {
                    url: '/ediimportfileupload',
                    component: EdiImportFileUploadComponent,
                    resolve: [VIEW_NAVIGATOR(EdiImportFileUploadComponent)],
                })
                .state('ediexport', {
                    url: '/ediexport/:edi_export_keyno',
                    //component: 'ediExport',
                    component: EdiExportComponent,
                })
                .state('ediexports', {
                    url: '/ediexports',
                    //component: 'ediExports',
                    component: EdiExportsComponent,
                })
                .state('ediimport', {
                    url: '/ediimport/:edi_import_keyno',
                    //component: 'ediImport',
                    component: EdiImportComponent,
                })
                .state('ediimports', {
                    url: '/ediimports',
                    //component: 'ediImports',
                    component: EdiImportsComponent,
                })
                .state('edimenu', {
                    url: '/edimenu',
                    component: 'ediMenu',
                })
                .state('edisource', {
                    url: '/edisource/:edi_source_keyno',
                    //component: 'ediSource',
                    component: EdiSourceComponent,
                })
                .state('edisources', {
                    url: '/edisources',
                    //component: 'ediSources',
                    component: EdiSourcesComponent,
                })
                .state('mietables', {
                    url: '/mietables',
                    //component: 'mieTables',
                    component: MieTablesComponent,
                })
                .state('model', {
                    url: '/model/:model_id',
                    //component: 'model',
                    component: ModelComponent,
                })
                .state('modellangs', {
                    url: '/modellangs/:model_id',
                    //component: 'modelLangs',
                    component: ModelLangsComponent,
                })
                .state('models', {
                    url: '/models',
                    //component: 'models',
                    component: ModelsComponent,
                })
                .state('modelmenu', {
                    url: '/modelmenu/:model_id',
                    //component: 'modelMenu',
                    component: ModelMenuComponent,
                })
                .state('newproceduredocumentation', {
                    url: '/newproceduredocumentation',
                    component: 'newProcedureDocumentation',
                })
                .state('p2subscriptions_edit', {
                    url: '/p2subscriptions_edit/:p2_subscription_keyno',
                    component: 'p2SubscriptionsEdit',
                    //component: P2SubscriptionsEditComponent,
                })
                .state('receivables', {
                    url: '/receivables',
                    //component: 'receivables',
                    component: ReceivablesComponent,
                })
                .state('subscriptionusergroup', {
                    url: '/subscriptionusergroup/:argtype/:argvalue',
                    component: 'subscriptionUsergroup',
                })
                .state('subscriptionusergroupedit', {
                    url: '/subscriptionusergroupedit/:p2_subscription_usergroup_keyno',
                    component: 'subscriptionUsergroupEdit',
                })
                .state('sractivity', {
                    url: '/sractivity',
                    component: 'srActivity',
                })
                .state('srchecklistcrewchange', {
                    url: '/srchecklistcrewchange/:checklistdata_keyno',
                    component: 'srCheckListCrewChange',
                })
                .state('srchecklistcrews', {
                    url: '/srchecklistcrews/:checklistdata_keyno',
                    component: 'srCheckListCrews',
                })
                .state('srchecklistld', {
                    url: '/srchecklistld/:checklistdata_keyno/:srrefundinput_keyno',
                    component: 'srCheckListLd',
                })
                .state('srchecklistlds', {
                    url: '/srchecklistlds/:checklistdata_keyno',
                    component: 'srCheckListLds',
                })
                .state('srchecklistequipment', {
                    url: '/srchecklistequipment/:checklistdata_keyno/:srrefundtype_id/:srrefundinput_keyno',
                    component: 'srCheckListEquipment',
                })
                .state('srchecklistequipments', {
                    url: '/srchecklistequipments/:checklistdata_keyno/:srrefundtype_id',
                    component: 'srCheckListEquipments',
                })
                .state('srchecklistexpense', {
                    url: '/srchecklistexpense/:checklistdata_keyno/:srrefundinput_keyno',
                    component: 'srCheckListExpense',
                })
                .state('srchecklistexpenses', {
                    url: '/srchecklistexpenses/:checklistdata_keyno',
                    component: 'srCheckListExpenses',
                })
                .state('srcrew', {
                    url: '/srcrew/:resource_id/:srcrew_keyno',
                    component: 'srCrew',
                })
                .state('srcrewmenu', {
                    url: '/srcrewmenu/:resource_id/:srcrew_keyno',
                    component: 'srCrewMenu',
                })
                .state('srcrewresource', {
                    url: '/srcrewresource/:srcrewresource_keyno/:resource_id/:srcrew_keyno',
                    component: 'srCrewResource',
                })
                .state('srcrewresourceview', {
                    url: '/srcrewresourceview',
                    component: 'srCrewResourceView',
                })
                .state('srcrews', {
                    url: '/srcrews/:argtype/:argvalue',
                    component: 'srCrews',
                })
                .state('srcustomeredit', {
                    url: '/srcustomeredit/:cust_no',
                    component: 'srCustomerEdit',
                })
                .state('srequipment', {
                    url: '/srequipment/:resource_id/:srequipment_keyno',
                    component: 'srEquipment',
                })
                .state('srequipmentresourceview', {
                    url: '/srequipmentresourceview',
                    component: 'srEquipmentResourceView',
                })
                .state('srequipments', {
                    url: '/srequipments/:resource_id',
                    component: 'srEquipments',
                })
                .state('srnotcompleted', {
                    url: '/srnotcompleted/:resource_id',
                    component: 'srNotCompleted',
                })
                .state('srnotcompletednew', {
                    url: '/srnotcompletednew/:resource_id',
                    component: 'srNotCompletedNew',
                })
                .state('srexpenses', {
                    url: '/srexpenses/:argtype/:argvalue',
                    component: 'srExpenses',
                })
                .state('srfindreport', {
                    url: '/srfindreport',
                    component: 'srFindReport',
                })
                .state('sroperation', {
                    url: '/sroperation/:custact_no',
                    component: 'srOperation',
                })
                .state('sroperationaddr', {
                    url: '/sroperationaddr/:custact_no',
                    component: 'srOperationAddr',
                })
                .state('sroperationar', {
                    url: '/sroperationar/:custact_no',
                    component: 'srOperationAr',
                })
                .state('sroperationresource', {
                    url: '/sroperationresource/:special_hrs_custactresource_keyno',
                    component: 'srOperationResource',
                })
                .state('sroperations', {
                    url: '/sroperations',
                    component: 'srOperations',
                })
                .state('srrefundbasis', {
                    url: '/srrefundbasis/:custact_no/:checklistdata_keyno',
                    component: 'srRefundBasis',
                })
                .state('srrefundcreate', {
                    url: '/srrefundcreate/:custact_no/:checklistdata_keyno',
                    component: 'srRefundCreate',
                })
                .state('srrefundinputcrew', {
                    url: '/srrefundinputcrew/:checklistdata_keyno/:srrefundinput_keyno',
                    component: 'srRefundInputCrew',
                })
                .state('srreportmenu', {
                    url: '/srreportmenu/:checklistdata_keyno',
                    component: 'srReportMenu',
                })
                .state('srtravelbill', {
                    url: '/srtravelbill/:travelbill_no',
                    component: 'srTravelBill',
                })
                .state('srtravelbillspec', {
                    url: '/srtravelbillspec/:travelbill_no/:argtype/:argvalue',
                    component: 'srTravelBillSpec',
                })
                .state('sruser', {
                    url: '/sruser/:portal_user_keyno',
                    component: 'srUser',
                })
                .state('sruseradmin', {
                    url: '/sruseradmin',
                    component: 'srUserAdmin',
                })
                .state('srusers', {
                    url: '/srusers',
                    component: 'srUsers',
                })
                .state('textileoladd', {
                    url: '/textileoladd/:order_internal_no/:orderline_keyno/:textilemodel_id',
                    component: 'textileOlAdd',
                })
                .state('textilestocksearch', {
                    url: '/textilestocksearch',
                    //component: 'textileStockSearch',
                    component: TextileStockSearchComponent,
                })
                .state('p2clientupdate', {
                    url: '/p2clientupdate',
                    //component: 'p2ClientUpdate',
                    component: P2ClientUpdateComponent,
                })
                .state('p2clientupdateedit', {
                    url: '/p2clientupdateedit/:clientupdate_id',
                    //component: 'p2ClientUpdateEdit',
                    component: P2ClientUpdateEditComponent,
                })
                .state('developmenu', {
                    url: '/developmenu',
                    // component: 'developMenu',
                    component: DevelopMenuComponent,
                    header: {
                        backButton: {
                            text: 'main_menu',
                            fallback: {
                                state: 'mainmenu',
                            },
                        },
                    },
                })
                .state('menugrp', {
                    url: '/menugrp/:menugrp_keyno',
                    //component: 'menuGrp',
                    component: MenuGrpComponent,
                })
                .state('menugrps', {
                    url: '/menugrps',
                    //component: 'menuGrps',
                    component: MenuGrpsComponent,
                })
                .state('p2settings', {
                    url: '/p2settings',
                    component: 'p2Settings',
                    component: P2SettingsComponent,
                })
                .state('p2settingedit', {
                    url: '/p2settingedit/:p2_setting_keyno',
                    component: 'p2SettingEdit',
                    component: P2SettingEditViewComponent,
                })
                .state('p2webpage', {
                    url: '/p2webpage',
                    component: 'p2Webpage',
                })
                .state('p2subscription', {
                    url: '/p2subscription',
                    component: 'p2Subscription',
                })
                .state('p2table', {
                    url: '/p2table',
                    component: 'p2Table',
                })
                .state('p2datatasklogs', {
                    url: '/p2datatasklogs/:portal_user_keyno',
                    // component: 'p2DataTaskLogs',
                    component: P2DatataskLogsComponent,
                })
                .state('p2datatasklog', {
                    url: '/p2datatasklog/:p2_datatasklog_keyno',
                    // component: 'p2DataTaskLog',
                    component: P2DatataskLogComponent,
                })
                .state('p2datatask', {
                    url: '/p2datatask',
                    component: 'p2DataTask',
                })
                .state('p2datataskedit', {
                    url: '/p2datataskedit/:p2_datatask_keyno',
                    component: 'p2DataTaskEdit',
                })
                .state('p2updatescripts', {
                    url: '/p2updatescripts',
                    // component: 'p2UpdateScripts',
                    component: P2UpdateScriptsComponent,
                })
                .state('p2updatescriptedit', {
                    url: '/p2updatescriptedit/:p2_updatescript_keyno',
                    // component: 'p2UpdateScriptEdit',
                    component: P2UpdateScriptEditViewComponent,
                })
                .state('p2releasenote', {
                    url: '/p2releasenote',
                    component: 'p2ReleaseNote',
                })
                .state('p2releasenoteedit', {
                    url: '/p2releasenoteedit/:p2_releasenote_keyno',
                    component: 'p2ReleaseNoteEdit',
                })
                .state('p2updatetables', {
                    url: '/p2updatetables',
                    component: 'p2UpdateTables',
                })
                .state('p2updatetableedit', {
                    url: '/p2updatetableedit/:p2_updatetable_keyno',
                    component: 'p2UpdateTableEdit',
                })
                .state('p2updateprocedures', {
                    url: '/p2updateprocedures',
                    component: 'p2UpdateProcedures',
                })
                .state('p2updateprocedureedit', {
                    url: '/p2updateprocedureedit/:p2_updateprocedure_keyno',
                    component: 'p2UpdateProcedureEdit',
                })
                .state('p2tableedit', {
                    url: '/p2tableedit/:p2_table_keyno',
                    component: 'p2TableEdit',
                })
                .state('p2webpagetable', {
                    url: '/p2webpagetable/:argtype/:argvalue',
                    // component: 'p2WebpageTable',
                    component: P2WebpageTableComponent,
                    resolve: [VIEW_NAVIGATOR(P2WebpageTableComponent)],
                })
                .state('relatedpurchorders', {
                    url: '/relatedpurchorders/:argtype/:argvalue',
                    //component: 'relatedPurchOrders',
                    component: RelatedPurchOrdersComponent,
                })
                .state('webpagetableedit', {
                    url: '/webpagetableedit/:p2_webpage_table_keyno',
                    component: 'webpageTableEdit',
                    component: WebpageTableEditComponent,
                    resolve: [VIEW_NAVIGATOR(WebpageTableEditComponent)],
                })
                .state('p2webpageedit', {
                    url: '/p2webpageedit/:p2_webpage_keyno',
                    component: 'p2WebpageEdit',
                })
                .state('webpagelink', {
                    url: '/webpagelink/:p2_webpage_keyno',
                    component: 'webpageLink',
                    component: WebPageLinkComponent,
                    resolve: [VIEW_NAVIGATOR(WebPageLinkComponent)],
                })
                .state('p2webpagelinkedit', {
                    url: '/p2webpagelinkedit/:p2_webpage_keyno_belongto/:p2_webpagelink_keyno',
                    component: 'p2WebpageLinkEdit',
                })
                .state('salarytypes', {
                    url: '/salarytypes',
                    //component: 'salaryTypes',
                    component: SalaryTypesComponent,
                })
                .state('salarytype', {
                    url: '/salarytype/:salarytype_id',
                    component: 'salaryType',
                })
                .state('salarytypelang', {
                    url: '/salarytypelang/:salarytype_id',
                    //component: 'salaryTypeLang',
                    component: SalaryTypeLangComponent,
                })
                .state('salesprospects', {
                    url: '/salesprospects/:argtype/:argvalue',
                    component: 'salesProspects',
                })
                .state('saftmaingroup', {
                    url: '/saftmaingroup/:saft_maingroup_no',
                    //component: 'saftMainGroup',
                    component: SaftMainGroupComponent,
                })
                .state('saftmaingroups', {
                    url: '/saftmaingroups',
                    //component: 'saftMainGroups',
                    component: SaftMainGroupsComponent,
                })
                .state('scanstocklocation', {
                    url: '/scanstocklocation/:argtype/:argvalue/:functionname/:stock_keyno/:autoscan',
                    component: 'scanStockLocation',
                })
                .state('seasonalities', {
                    url: '/seasonalities',
                    //component: 'seasonalities',
                    component: SeasonalitiesComponent,
                })
                .state('seasonality', {
                    url: '/seasonality/:seasonality_keyno',
                    component: 'seasonality',
                    //component: SeasonalityComponent,
                })
                .state('offdutycodes', {
                    url: '/offdutycodes',
                    //component: 'offDutyCodes',
                    component: OffDutyCodesComponent,
                })
                .state('offdutycode', {
                    url: '/offdutycode/:offdutycode_keyno',
                    //component: 'offDutyCode',
                    component: OffDutyCodeComponent,
                })
                .state('selectlabour', {
                    url: '/selectlabour/:webpage_name',
                    component: 'selectLabour',
                })
                .state('selectoeestate', {
                    url: '/selectoeestate/:arrowside',
                    component: 'selectOeeState',
                })
                .state('selectoeestateremark', {
                    url: '/selectoeestateremark/:oeestate_keyno',
                    component: 'selectOeeStateRemark',
                })
                .state('selectlabourpu', {
                    url: '/selectlabourpu/:webpagename',
                    component: 'selectLabourPu',
                })
                .state('selectoperationpu', {
                    url: '/selectoperationpu/:webpagename',
                    //component: 'selectOperationPu',
                    component: SelectOperationPuComponent,
                })
                .state('selectworkingorder', {
                    url: '/selectworkingorder/:webpagename',
                    component: 'selectWorkingOrder',
                })
                .state('selectpofinish', {
                    url: '/selectpofinish/:webpagename/:labour_no',
                    component: 'selectPoFinish',
                })
                .state('selectequipmentpu', {
                    url: '/selectequipmentpu/:webpagename/:operation_id',
                    //component: 'selectEquipmentPu',
                    component: SelectEquipmentPuComponent,
                })
                .state('paperlesspo', {
                    url: '/paperlesspo',
                    //component: 'paperLessPo',
                    component: PaperlessPoComponent,
                })
                .state('translate', {
                    url: '/translate',
                    component: 'translate',
                })
                .state('transportarea', {
                    url: '/transportarea/:transportarea_keyno/:stockplace_id',
                    component: TransportAreaComponent,
                    resolve: [VIEW_NAVIGATOR(TransportAreaComponent)],
                    //component: 'transportArea',
                })
                .state('transportareapp', {
                    url: '/transportareapp/:transportareapp_keyno',
                    component: TransportAreaPpComponent,
                    //component: 'transportAreaPp',
                })
                .state('transportareappadd', {
                    url: '/transportareappadd/:transportarea_keyno',
                    component: TransportAreaPpAddComponent,
                    resolve: [VIEW_NAVIGATOR(TransportAreaPpAddComponent)],
                    //component: 'transportAreaPpAdd',
                })
                .state('transportareappmove', {
                    url: '/transportareappmove/:stockplace_id/:transportarea_keyno',
                    component: TransportAreaPpMoveComponent,
                    resolve: [VIEW_NAVIGATOR(TransportAreaPpMoveComponent)],
                    //component: 'transportAreaPpAdd',
                })
                .state('transportareas', {
                    url: '/transportareas/:stockplace_id',
                    component: TransportAreasComponent,
                    resolve: [VIEW_NAVIGATOR(TransportAreasComponent)],
                    //component: 'transportAreas',
                })
                .state('transportareamenu', {
                    url: '/transportareamenu/:transportarea_keyno?stockplace_id',
                    component: TransportAreaMenuComponent,
                    resolve: [VIEW_NAVIGATOR(TransportAreaMenuComponent)],
                    //component: 'transportAreaMenu',
                })
                .state('travelbill', {
                    url: '/travelbill/:argtype/:argvalue/:travelbill_no',
                    component: 'travelBill',
                })
                .state('travelbilllog', {
                    url: '/travelbilllog/:travelbillog_keyno',
                    component: 'travelBillLog',
                    //component: TravelBillLogComponent,
                })
                .state('travelbilllogs', {
                    url: '/travelbilllogs/:travelbill_no',
                    //component: 'travelBillLogs',
                    component: TravelBillLogsComponent,
                })
                .state('travelbillmenu', {
                    url: '/travelbillmenu/:travelbill_no',
                    //component: 'travelBillMenu',
                    component: TravelBillMenuComponent,
                })
                .state('travelbillreject', {
                    url: '/travelbillreject/:travelbill_no',
                    //component: 'travelBillReject',
                    component: TravelBillRejectComponent,
                })
                .state('travelbills', {
                    url: '/travelbills/:argtype/:argvalue',
                    //component: 'travelBills',
                    component: TravelBillsComponent,
                })
                .state('travelexpence', {
                    url: '/travelexpence/:travelbill_no/:travelexpence_keyno',
                    //component: 'travelExpence',
                    component: TravelExpenceComponent,
                })
                .state('travexptypemenu', {
                    url: '/travexptypemenu/:trextype_id',
                    //component: 'travExpTypeMenu',
                    component: TravExpTypeMenuComponent,
                })
                .state('travexptype', {
                    url: '/travexptype/:trextype_id',
                    //component: 'travExpType',
                    component: TravExpTypeComponent,
                })
                .state('travexptypebuscos', {
                    url: '/travexptypebuscos/:trextype_id',
                    component: 'travExpTypeBusCos',
                })
                .state('travexptypes', {
                    url: '/travexptypes',
                    //component: 'travExpTypes',
                    component: TravExpTypesComponent,
                })
                .state('travelwage', {
                    url: '/travelwage/:travelwage_id',
                    //component: 'travelWage',
                    component: TravelWageComponent,
                })
                .state('travelwagedata', {
                    url: '/travelwagedata/:travelbill_no/:travelwagedata_keyno',
                    //component: 'travelWageData',
                    component: TravelWageDataComponent,
                })
                .state('travelwagemenu', {
                    url: '/travelwagemenu/:travelwage_id',
                    //component: 'travelWageMenu',
                    component: TravelWageMenuComponent,
                })
                .state('travelwages', {
                    url: '/travelwages',
                    //component: 'travelWages',
                    component: TravelWagesComponent,
                })
                .state('travelwageset', {
                    url: '/travelwageset/:travelwageset_keyno',
                    //component: 'travelWageSet',
                    component: TravelWageSetComponent,
                })
                .state('travelwagesetmenu', {
                    url: '/travelwagesetmenu/:travelwageset_keyno',
                    //component: 'travelWageSetMenu',
                    component: TravelWageSetMenuComponent,
                })
                .state('travelwagesetrates', {
                    url: '/travelwagesetrates/:travelwageset_keyno',
                    component: 'travelWageSetRates',
                })
                .state('travelwagesets', {
                    url: '/travelwagesets',
                    //component: 'travelWageSets',
                    component: TravelWageSetsComponent,
                })
                .state('verticalpurchasing', {
                    url: '/verticalpurchasing/:order_internal_no',
                    component: 'verticalPurchasing',
                })
                .state('labours', {
                    url: '/labours',
                    component: 'labours',
                })
                .state('labouredit', {
                    url: '/labouredit/:labour_no',
                    component: 'labourEdit',
                })
                .state('laboursalarytype', {
                    url: '/laboursalarytype/:laboursalarytype_keyno',
                    //component: 'labourSalaryType',
                    component: LabourSalaryTypeComponent,
                })
                .state('laboursalarytypes', {
                    url: '/laboursalarytypes/:argtype/:argvalue',
                    //component: 'labourSalaryTypes',
                    component: LabourSalaryTypesComponent,
                })
                .state('language', {
                    url: '/language/:language_id',
                    //component: 'language',
                    component: LanguageComponent,
                })
                .state('languagelangs', {
                    url: '/languagelangs/:language_id',
                    //component: 'languageLangs',
                    component: LanguageLangsComponent,
                })
                .state('languages', {
                    url: '/languages',
                    //component: 'languages',
                    component: LanguagesComponent,
                })
                .state('selectcity', {
                    url: '/selectcity/:webpage_name/:parm1/:searchtext',
                    component: 'selectCity',
                })
                .state('searchstock', {
                    url: '/searchstock',
                    component: 'searchStock',
                    //component: SearchStockComponent,
                })
                .state('translateedit', {
                    url: '/translateedit/:item_id',
                    component: 'translateEdit',
                })
                .state('case', {
                    url: '/case/:case_keyno',
                    component: 'case',
                })
                .state('counter', {
                    url: '/counter/:counter_keyno',
                    //component: 'counter',
                    component: CounterComponent,
                })
                .state('counters', {
                    url: '/counters',
                    //component: 'counters',
                    component: CountersComponent,
                })
                .state('createcase', {
                    url: '/createcase/:argtype/:argvalue',
                    component: 'createCase',
                })
                .state('custactcustomer', {
                    url: '/custactcustomer/:custact_no/:custact_customer_keyno',
                    //component: 'custactCustomer',
                    component: CustactCustomerComponent,
                })
                .state('custactcustomers', {
                    url: '/custactcustomers/:argtype/:argvalue',
                    //component: 'custactCustomers',
                    component: CustactCustomersComponent,
                })
                .state('customerbusco', {
                    url: '/customerbusco/:customerbusco_keyno',
                    //component: 'customerBusCo',
                    component: CustomerBusCoComponent,
                })
                .state('customerbuscos', {
                    url: '/customerbuscos/:cust_no',
                    //component: 'customerBusCos',
                    component: CustomerBusCosComponent,
                })
                .state('custactsearch', {
                    url: '/custactsearch/:filterfield/:filtervalue/:custacttype',
                    component: 'custactSearch',
                })
                .state('orderlinecredit', {
                    url: '/orderlinecredit/:orderline_keyno',
                    component: 'orderLineCredit',
                })
                .state('orderlinecancelcause', {
                    url: '/orderlinecancelcause/:orderlinecancelcause_keyno',
                    //component: 'orderLineCancelCause',
                    component: OrderLineCancelCauseComponent,
                })
                .state('orderlinecancelcauselang', {
                    url: '/orderlinecancelcauselang/:orderlinecancelcause_keyno',
                    //component: 'orderLineCancelCauseLang',
                    component: OrderLineCancelCauseLangComponent,
                })
                .state('orderlinecancelcauses', {
                    url: '/orderlinecancelcauses',
                    //component: 'orderLineCancelCauses',
                    component: OrderLineCancelCausesComponent,
                })
                .state('orderlinecreditcause', {
                    url: '/orderlinecreditcause/:orderlinecreditcause_keyno',
                    component: OrderLineCreditCauseComponent,
                    //component: 'orderLineCreditCause',
                })
                .state('orderlinecreditcauselang', {
                    url: '/orderlinecreditcauselang/:orderlinecreditcause_keyno',
                    component: OrderLineCreditCauseLangComponent,
                    //component: 'orderLineCreditCauseLang',
                })
                .state('orderlinecreditcauses', {
                    url: '/orderlinecreditcauses',
                    component: OrderLineCreditCausesComponent,
                    //component: 'orderLineCreditCauses',
                })
                .state('orderlinecredits', {
                    url: '/orderlinecredits/:argtype/:argvalue',
                    //component: 'orderLineCredits',
                    component: OrderLineCreditsComponent,
                })
                .state('orderconfirmation', {
                    url: '/orderconfirmation/:argtype/:argvalue',
                    params: {
                        argtype: { squash: true, value: null },
                        argvalue: { squash: true, value: null },
                    },
                    component: 'orderConfirmation',
                })
                .state('postcalcm', {
                    url: '/postcalcm/:argtype/:argvalue',
                    //component: 'postCalcM',
                    component: PostCalcMComponent,
                })
                .state('postcalcw', {
                    url: '/postcalcw/:argtype/:argvalue',
                    //component: 'postCalcW',
                    component: PostCalcWComponent,
                })
                .state('stockmenu', {
                    url: '/stockmenu',
                    // component: 'stockMenu',
                    component: StockMenuComponent,
                    header: {
                        backButton: {
                            text: 'main_menu',
                            fallback: {
                                state: 'mainmenu',
                            },
                        },
                    },
                })
                .state('fabricsgrp', {
                    url: '/fabricsgrp/:fabricsgrp_id',
                    //component: 'fabricsGrp',
                    component: FabricsGrpComponent,
                })
                .state('fabricsgrps', {
                    url: '/fabricsgrps',
                    //component: 'fabricsGrps',
                    component: FabricsGrpsComponent,
                })
                .state('furniturefabrics', {
                    url: '/furniturefabrics/:furniturefabrics_id',
                    //component: 'furnitureFabrics',
                    component: FurnitureFabricsComponent,
                })
                .state('furniturefabricss', {
                    url: '/furniturefabricss',
                    //component: 'furnitureFabricsS',
                    component: FurnitureFabricsSComponent,
                })
                .state('furniturefabricssuppliers', {
                    url: '/furniturefabricssuppliers',
                    //component: 'furnitureFabricsSuppliers',
                    component: FurnitureFabricsSuppliersComponent,
                })
                .state('findstock', {
                    url: '/findstock',
                    component: 'findStock',
                })
                .state('finishpohscan', {
                    url: '/finishpohscan',
                    //component: 'finishPohScan',
                    component: FinishPohScanComponent,
                })
                .state('labourposition', {
                    url: '/labourposition/:labourposition_keyno/:argtype/:argvalue',
                    component: 'labourPosition',
                })
                .state('labourpositions', {
                    url: '/labourpositions/:argtype/:argvalue',
                    //component: 'labourPositions',
                    component: LabourPositionsComponent,
                })
                //.state('pohfinish', {
                //    //    url: '/pohfinish/:poh_keyno',
                //    component: 'pohFinish'
                //})
                .state('stocksearch', {
                    url: '/stocksearch/:functionname',
                    component: 'stockSearch',
                })
                .state('stockbatchonlocation', {
                    url: '/stockbatchonlocation/:stock_keyno/:stocklocation_keyno/:functionname',
                    component: 'stockBatchOnLocation',
                })
                .state('stockassign', {
                    url: '/stockassign/:stock_keyno/:stockbatch_keyno/:stocklocation_keyno/:functionname/:p2_pofinishprodcomp_keyno',
                    component: 'stockAssign',
                })
                .state('stockcontrollist', {
                    url: '/stockcontrollist/:stockplace_id',
                    component: 'stockControlList',
                })
                .state('stockcontrolloclist', {
                    url: '/stockcontrolloclist/:stocklocation_keyno',
                    component: 'stockControlLocList',
                })
                .state('stockcontrollocstock', {
                    url: '/stockcontrollocstock/:stocklocation_keyno/:stock_keyno',
                    component: 'stockControlLocStock',
                })
                .state('stockcontrolsplist', {
                    url: '/stockcontrolsplist',
                    //component: 'stockControlSpList',
                    component: StockControlSpListComponent,
                })
                .state('stockonlocation', {
                    url: '/stockonlocation/:stock_keyno/:functionname',
                    //component: 'stockOnLocation',
                    component: StockOnLocationComponent,
                })
                .state('stocksonlocation', {
                    url: '/stocksonlocation/:stocklocation_keyno',
                    component: 'stocksOnLocation',
                })
                .state('coop', {
                    url: '/coop/:coop_id',
                    //component: 'coop',
                    component: CoopComponent,
                })
                .state('cooplangs', {
                    url: '/cooplangs/:coop_id',
                    //component: 'coopLangs',
                    component: CoopLangsComponent,
                })
                .state('coops', {
                    url: '/coops',
                    //component: 'coops',
                    component: CoopsComponent,
                })
                .state('stockzones', {
                    url: '/stockzones',
                    component: 'stockZones',
                })
                .state('stockzonemenu', {
                    url: '/stockzonemenu/:stockzone_keyno',
                    //component: 'stockZoneMenu',
                    component: StockZoneMenuComponent,
                })
                .state('stockzone', {
                    url: '/stockzone/:stockplace_id/:stockzone_keyno',
                    //component: 'stockZone',
                    component: StockZoneComponent,
                })
                .state('stocklocation', {
                    url: '/stocklocation/:stockzone_keyno/:stocklocation_keyno',
                    //component: 'stockLocation',
                    component: StockLocationComponent,
                })
                .state('stocklocationctrl', {
                    url: '/stocklocationctrl/:stock_keyno',
                    //component: 'stockLocationCtrl',
                    component: StockLocationCtrlComponent,
                })
                .state('stocktransmenu', {
                    url: '/stocktransmenu/:stocktrans_keyno',
                    //component: 'stockTransMenu',
                    component: StockTransMenuComponent,
                })
                .state('stocktransallocations', {
                    url: '/stocktransallocations/:argtype/:argvalue',
                    //component: 'stockTransAllocations',
                    component: StockTransAllocationsComponent,
                })
                .state('stocktransfer', {
                    url: '/stocktransfer/:stocktransfer_keyno',
                    component: 'stockTransfer',
                })
                .state('stocktransfercreate', {
                    url: '/stocktransfercreate/:stockplace_id',
                    component: 'stockTransferCreate',
                    //component: StockTransferCreateComponent,
                })
                .state('stocktransferload', {
                    url: '/stocktransferload/:stocktransfer_keyno',
                    component: 'stockTransferLoad',
                })
                .state('stocktransferloaditem', {
                    url: '/stocktransferloaditem/:stocktransfer_keyno/:stock_keyno/:stockbatch_keyno/:stocklocation_keyno_from/:quantity',
                    component: 'stockTransferLoadItem',
                })
                .state('stocktransferunload', {
                    url: '/stocktransferunload/:stocktransfer_keyno/:stock_keyno/:stockbatch_keyno/:stocklocation_keyno_suggestion',
                    component: 'stockTransferUnLoad',
                })
                .state('stocktransferreception', {
                    url: '/stocktransferreception/:stocklocation_keyno',
                    component: 'stockTransferReception',
                })
                .state('stocktransfers', {
                    url: '/stocktransfers',
                    //component: 'stockTransfers',
                    component: StockTransfersComponent,
                })
                .state('infoscreen', {
                    url: '/infoscreen',
                    component: 'infoScreen',
                    component: InfoScreenComponent,
                })
                .state('inventoryarticlesearch', {
                    url: '/inventoryarticlesearch',
                    //component: 'inventoryArticleSearch',
                    component: InventoryArticleSearchComponent,
                })
                .state('inventoryscan', {
                    url: '/inventoryscan',
                    component: 'inventoryScan',
                })
                .state('paymentlang', {
                    url: '/paymentlang/:payment_id',
                    component: 'paymentLang',
                })
                .state('paymentlangs', {
                    url: '/paymentlangs/:payment_id',
                    //component: 'paymentLangs',
                    component: PaymentLangsComponent,
                })
                .state('paymentplan', {
                    url: '/paymentplan/:argtype/:argvalue/:paymentplan_keyno',
                    component: 'paymentPlan',
                })
                .state('paymentplans', {
                    url: '/paymentplans/:argtype/:argvalue',
                    component: 'paymentPlans',
                })
                .state('acledger', {
                    url: '/acledger/:argtype/:argvalue',
                    component: 'acLedger',
                    component: AcLedgerComponent,
                    resolve: [VIEW_NAVIGATOR(AcLedgerComponent)],
                })
                .state('acledgerview', {
                    url: '/acledgerview',
                    component: 'acLedgerView',
                    component: AcLedgerViewComponent,
                })
                .state('acledgerhistoryimport', {
                    url: '/acledgerhistoryimport',
                    component: 'acledgerhistoryimport',
                })
                .state('acsupptrans', {
                    url: '/acsupptrans/:acsupptrans_keyno',
                    //component: 'acSuppTrans',
                    component: AcSuppTransComponent,
                    resolve: [VIEW_NAVIGATOR(AcSuppTransComponent)],
                })
                .state('acsupptranses', {
                    url: '/acsupptranses/:acc_supp_no',
                    //component: 'acSuppTranses',
                    // Angular migration alternative:
                    component: AcSuppTransesComponent,
                    resolve: [VIEW_NAVIGATOR(AcSuppTransesComponent)],
                })
                .state('accusttrans', {
                    url: '/accusttrans/:accusttrans_keyno',
                    // component: 'acCustTrans',
                    component: AcCustTransComponent,
                    resolve: [VIEW_NAVIGATOR(AcCustTransComponent)],
                })
                .state('accusttranses', {
                    url: '/accusttranses/:argtype/:argvalue',
                    //component: 'acCustTranses',
                    // Angular migration alternative:
                    component: AcCustTransesComponent,
                    resolve: [VIEW_NAVIGATOR(AcCustTransesComponent)],
                })
                .state('accusttransesage', {
                    url: '/accusttransesage',
                    //component: 'acCustTransesAge',
                    component: AcCustTransesAgeComponent,
                })
                .state('acsupptransesage', {
                    url: '/acsupptransesage',
                    //component: 'acSuppTransesAge',
                    component: AcSuppTransesAgeComponent,
                })

                //bhw
                .state('bulkreturn', {
                    url: '/bulkreturn/:counter',
                    component: 'bulkReturn',
                })
                .state('bulkmail', {
                    url: '/bulkmail/:bulkmail_keyno',
                    //component: 'bulkMail',
                    component: BulkMailComponent,
                })
                .state('bulkmailmenu', {
                    url: '/bulkmailmenu/:bulkmail_keyno',
                    component: 'bulkMailMenu',
                })
                .state('bulkmails', {
                    url: '/bulkmails',
                    //component: 'bulkMails',
                    component: BulkMailsComponent,
                })
                .state('department', {
                    url: '/department/:department_id',
                    //component: 'department',
                    component: DepartmentComponent,
                })
                .state('departmentlang', {
                    url: '/departmentlang/:department_id',
                    component: DepartmentLangComponent,
                    //component: 'departmentLang',
                })
                .state('departmentmenu', {
                    url: '/departmentmenu/:department_id',
                    component: DepartmentMenuComponent,
                    //component: 'departmentMenu',
                })
                .state('departments', {
                    url: '/departments',
                    component: DepartmentsComponent,
                    //component: 'departments',
                })
                .state('dispatchplanning', {
                    url: '/dispatchplanning',
                    // component: 'dispatchPlanning',
                    component: DispatchPlanningComponent,
                })

                .state('dispatchplanningorderlines', {
                    url: '/dispatchplanningorderlines/:argtype/:argvalue/:counter',
                    component: 'dispatchPlanningOrderLines',
                })
                .state('dispatchplanningstock', {
                    url: '/dispatchplanningstock',
                    component: 'dispatchPlanningStock',
                })
                .state('dispatchplanningblockorder', {
                    url: '/dispatchplanningblockorder/:order_internal_no',
                    //component: 'dispatchPlanningBlockOrder',
                    component: DispatchPlanningBlockOrderComponent,
                })
                .state('dispatchplanningconsignment', {
                    url: '/dispatchplanningconsignment/:dispatch_no',
                    component: 'dispatchPlanningConsignment',
                })
                .state('textilemodelcategory3', {
                    url: '/textilemodelcategory3/:textilemodelcategory3_keyno',
                    //component: 'textileModelCategory3',
                    component: TextileModelCategory3Component,
                })
                .state('textilemodelcategory3lang', {
                    url: '/textilemodelcategory3lang/:textilemodelcategory3_keyno',
                    //component: 'textileModelCategory3Lang',
                    component: TextileModelCategory3LangComponent,
                })
                .state('textilemodelcategory3s', {
                    url: '/textilemodelcategory3s',
                    //component: 'textileModelCategory3s',
                    component: TextileModelCategory3sComponent,
                })
                .state('textilemodelcategory4lang', {
                    url: '/textilemodelcategory4lang/:textilemodelcategory4_keyno',
                    //component: 'textileModelCategory4Lang',
                    component: TextileModelCategory4LangComponent,
                })
                .state('textilemodelcategory4', {
                    url: '/textilemodelcategory4/:textilemodelcategory4_keyno',
                    //component: 'textileModelCategory4',
                    component: TextileModelCategory4Component,
                })
                .state('textilemodelcategory4s', {
                    url: '/textilemodelcategory4s',
                    //component: 'textileModelCategory4s',
                    component: TextileModelCategory4sComponent,
                })
                .state('textilemodelcategory5lang', {
                    url: '/textilemodelcategory5lang/:textilemodelcategory5_keyno',
                    //component: 'textileModelCategory5Lang',
                    component: TextileModelCategory5LangComponent,
                })
                .state('textilemodelcategory5', {
                    url: '/textilemodelcategory5/:textilemodelcategory5_keyno',
                    //component: 'textileModelCategory5',
                    component: TextileModelCategory5Component,
                })
                .state('textilemodelcategory5s', {
                    url: '/textilemodelcategory5s',
                    //component: 'textileModelCategory5s',
                    component: TextileModelCategory5sComponent,
                })
                .state('textilemodelcategory6lang', {
                    url: '/textilemodelcategory6lang/:textilemodelcategory6_keyno',
                    //component: 'textileModelCategory6Lang',
                    component: TextileModelCategory6LangComponent,
                })
                .state('textilemodelcategory6', {
                    url: '/textilemodelcategory6/:textilemodelcategory6_keyno',
                    //component: 'textileModelCategory6',
                    component: TextileModelCategory6Component,
                })
                .state('textilemodelcategory6s', {
                    url: '/textilemodelcategory6s',
                    //component: 'textileModelCategory6s',
                    component: TextileModelCategory6sComponent,
                })
                .state('textilemodelcategory7lang', {
                    url: '/textilemodelcategory7lang/:textilemodelcategory7_keyno',
                    //component: 'textileModelCategory7Lang',
                    component: TextileModelCategory7LangComponent,
                })
                .state('textilemodelcategory7', {
                    url: '/textilemodelcategory7/:textilemodelcategory7_keyno',
                    //component: 'textileModelCategory7',
                    component: TextileModelCategory7Component,
                })
                .state('textilemodelcategory7s', {
                    url: '/textilemodelcategory7s',
                    //component: 'textileModelCategory7s',
                    component: TextileModelCategory7sComponent,
                })
                .state('textilemodelcategory8lang', {
                    url: '/textilemodelcategory8lang/:textilemodelcategory8_keyno',
                    //component: 'textileModelCategory8Lang',
                    component: TextileModelCategory8LangComponent,
                })
                .state('textilemodelcategory8', {
                    url: '/textilemodelcategory8/:textilemodelcategory8_keyno',
                    //component: 'textileModelCategory8',
                    component: TextileModelCategory8Component,
                })
                .state('textilemodelcategory8s', {
                    url: '/textilemodelcategory8s',
                    //component: 'textileModelCategory8s',
                    component: TextileModelCategory8sComponent,
                });

            $stateProvider
                .state('productcomposition', {
                    url: '/productcomposition/:productcomposition_keyno',
                    //component: 'productComposition',
                    component: ProductCompositionComponent,
                })
                .state('productcompositionlang', {
                    url: '/productcompositionlang/:productcomposition_keyno',
                    //component: 'productCompositionLang',
                    component: ProductCompositionLangComponent,
                })
                .state('productcompositions', {
                    url: '/productcompositions',
                    //component: 'productCompositions',
                    component: ProductCompositionsComponent,
                })
                .state('productcategorylang', {
                    url: '/productcategorylang/:productcategory_keyno',
                    //component: 'productCategoryLang',
                    component: ProductCategoryLangComponent,
                })
                .state('productcategory', {
                    url: '/productcategory/:productcategory_keyno',
                    //component: 'productCategory',
                    component: ProductCategoryComponent,
                })
                .state('productcategorys', {
                    url: '/productcategorys',
                    //component: 'productCategorys',
                    component: ProductCategorysComponent,
                })
                .state('listdatalang', {
                    url: '/listdatalang/:listdata_keyno',
                    //component: 'listDataLang',
                    component: ListDataLangComponent,
                })
                .state('listdata', {
                    url: '/listdata/:listdata_keyno/:list_keyno',
                    //component: 'listData',
                    component: ListDataComponent,
                })
                .state('listdatas', {
                    url: '/listdatas/:list_keyno',
                    //component: 'listDatas',
                    component: ListDatasComponent,
                })
                .state('list', {
                    url: '/list/:list_keyno',
                    //component: 'list',
                    component: ListNameComponent,
                })
                .state('lists', {
                    url: '/lists',
                    //component: 'lists',
                    component: ListsComponent,
                })
                .state('selectstocklocation', {
                    url: '/selectstocklocation/:stockplace_id',
                    //component: 'selectStockLocation',
                    component: SelectStockLocationComponent,
                })
                .state('stockcount', {
                    url: '/stockcount/:stockplace_id/:stockcount_keyno',
                    //component: 'stockCount',
                    component: StockCountComponent,
                })
                .state('stockcountapprove', {
                    url: '/stockcountapprove/:stockcount_keyno',
                    component: 'stockCountApprove',
                })
                .state('stockcounts', {
                    url: '/stockcounts',
                    //component: 'stockCounts',
                    component: StockCountsComponent,
                })
                .state('stockcountmenu', {
                    url: '/stockcountmenu/:stockcount_keyno',
                    //component: 'stockCountMenu',
                    component: StockCountMenuComponent,
                })
                .state('stockcountrefresh', {
                    url: '/stockcountrefresh/:stockcount_keyno',
                    //component: 'stockCountRefresh',
                    component: StockCountRefreshComponent,
                })
                .state('stockcountresult', {
                    url: '/stockcountresult/:stockcount_keyno',
                    //component: 'stockCountResult',
                    component: StockCountResultComponent,
                })
                .state('stockcountdata', {
                    url: '/stockcountdata/:stockcountdata_keyno',
                    //component: 'stockCountData',
                    component: StockCountDataComponent,
                })
                .state('stockcountdataitem', {
                    url: '/stockcountdataitem/:stockcountdataitem_keyno/:argtype/:argvalue',
                    component: 'stockCountDataItem',
                })
                .state('stockcountdatas', {
                    url: '/stockcountdatas/:stockcount_keyno',
                    component: 'stockCountDatas',
                    //component: StockCountDatasComponent,
                })
                .state('consignmentscan', {
                    url: '/consignmentscan',
                    //component: 'consignmentScan',
                    component: ConsignmentScanComponent,
                })
                .state('consignmentserialnumber', {
                    url: '/consignmentserialnumber/:consignment_keyno',
                    component: 'consignmentSerialNumber',
                })
                .state('consignmentplan', {
                    url: '/consignmentplan/:custact_no',
                    component: 'consignmentPlan',
                })
                .state('consignmentplanbuild', {
                    url: '/consignmentplanbuild/:custact_no',
                    component: 'consignmentPlanBuild',
                })
                .state('consignmentplanning', {
                    url: '/consignmentplanning',
                    component: 'consignmentPlanning',
                })
                .state('consignmentplans', {
                    url: '/consignmentplans',
                    component: 'consignmentPlans',
                })
                .state('consignmentplansdelivery', {
                    url: '/consignmentplansdelivery',
                    //component: 'consignmentPlansDelivery',
                    component: ConsignmentPlansDeliveryComponent, // BJS 20250404
                })
                .state('consignmentplansdeliverylabour', {
                    url: '/consignmentplansdeliverylabour',
                    //component: 'consignmentPlansDeliveryLabour',
                    component: ConsignmentPlansDeliveryLabourComponent,
                })
                .state('consignmentplansdeliverylocation', {
                    url: '/consignmentplansdeliverylocation',
                    //component: 'consignmentPlansDeliveryLocation',
                    component: ConsignmentPlansDeliveryLocationComponent,
                })
                .state('consignmentplansconsignments', {
                    url: '/consignmentplansconsignments/:custact_no',
                    //component: 'consignmentPlansConsignments',
                    component: ConsignmentPlansConsignmentsComponent, // BJS 20250407
                })
                .state('consignmentplansorders', {
                    url: '/consignmentplansorders/:argtype/:argvalue',
                    component: 'consignmentPlansOrders',
                })
                .state('consignmentplansconsignmentcontent', {
                    url: '/consignmentplansconsignmentcontent/:consignment_keyno/:custact_no',
                    component: 'consignmentPlansConsignmentContent',
                    component: ConsignmentPlansConsignmentContentComponent,
                })
                .state('consignmentplansdeliverydriver', {
                    url: '/consignmentplansdeliverydriver/:argtype/:argvalue',
                    //component: 'consignmentPlansDeliveryDriver',
                    component: ConsignmentPlansDeliveryDriverComponent,
                })
                .state('consignmentplansdeliverysettings', {
                    url: '/consignmentplansdeliverysettings',
                    //component: 'consignmentPlansDeliverySettings',
                    component: ConsignmentPlansDeliverySettingsComponent,
                })
                .state('consignments', {
                    url: '/consignments/:argtype/:argvalue',
                    component: 'consignments',
                })
                .state('consignmentlineassign', {
                    url: '/consignmentlineassign/:consignmentline_keyno',
                    component: 'consignmentLineAssign',
                })
                .state('consignmentlines', {
                    url: '/consignmentlines/:argtype/:argvalue',
                    //component: 'consignmentLines',
                    component: ConsignmentLinesComponent,
                })
                .state('consignmentlinesb', {
                    url: '/consignmentlinesb/:consignmentlinesb_keyno',
                    //component: 'consignmentLinesB',
                    component: ConsignmentLinesBComponent,
                })
                .state('consignmentlinesbs', {
                    url: '/consignmentlinesbs/:argtype/:argvalue',
                    //component: 'consignmentLinesBs',
                    component: ConsignmentLinesBsComponent,
                })
                .state('consignmentline', {
                    url: '/consignmentline/:consignmentline_keyno',
                    //component: 'consignmentLine',
                    component: ConsignmentLineComponent,
                })
                .state('consignmentlineselect', {
                    url: '/consignmentlineselect/:consignment_keyno',
                    //component: 'consignmentLineSelect',
                    component: ConsignmentLineSelectComponent,
                })
                .state('consignmentshipment', {
                    url: '/consignmentshipment/:consignmentshipment_keyno/:stockplace_id',
                    //component: 'consignmentShipment',
                    component: ConsignmentShipmentComponent,
                })
                .state('consignmentshipments', {
                    url: '/consignmentshipments',
                    //component: 'consignmentShipments',
                    component: ConsignmentShipmentsComponent,
                })
                .state('consignment', {
                    url: '/consignment/:consignment_keyno',
                    component: 'consignment',
                })
                .state('consignmentol', {
                    url: '/consignmentol/:consignmentol_keyno',
                    //component: 'consignmentOl',
                    component: ConsignmentOlComponent,
                })
                .state('consignmentsplit', {
                    url: '/consignmentsplit/:consignment_keyno_splitfrom',
                    //component: 'consignmentSplit',
                    component: ConsignmentSplitComponent,
                })
                .state('consignmentsplitedit', {
                    url: '/consignmentsplitedit/:consignment_keyno_splitfrom',
                    //component: 'consignmentSplitEdit',
                    component: ConsignmentSplitEditComponent,
                })
                .state('consignmentsplitline', {
                    url: '/consignmentsplitline/:consignmentline_keyno',
                    component: 'consignmentSplitLine',
                    //component: ConsignmentSplitLineComponent,
                })
                .state('consignmentcollidetail', {
                    url: '/consignmentcollidetail/:consignment_keyno/:consignmentcolli_keyno',
                    //component: 'consignmentColliDetail',
                    component: ConsignmentColliDetailComponent,
                })
                .state('consignmentcarrierone', {
                    url: '/consignmentcarrierone/:consignment_keyno',
                    //component: 'consignmentCarrierOne',
                    component: ConsignmentCarrierOneComponent,
                })
                .state('containershipment', {
                    url: '/containershipment',
                    component: 'containerShipment',
                })
                .state('prodsizeedit', {
                    url: '/prodsizeedit/:prodsize_keyno',
                    //component: 'prodSizeEdit',
                    component: ProdSizeEditComponent,
                })
                .state('prodsizecolli', {
                    url: '/prodsizecolli/:prodsize_keyno/:prodsizecolli_keyno',
                    //component: 'prodSizeColli',
                    component: ProdSizeColliComponent,
                })
                .state('prodgrp', {
                    url: '/prodgrp/:prodgrp_id',
                    //component: 'prodGrp',
                    component: ProdGrpComponent,
                })
                .state('prodgrp2', {
                    url: '/prodgrp2/:prodgrp_id/:prodgrp2_id',
                    //component: 'prodGrp2',
                    component: ProdGrp2Component,
                })
                .state('prodgrp3', {
                    url: '/prodgrp3/:prodgrp2_id/:prodgrp3_id',
                    component: 'prodGrp3',
                })
                .state('prodgrp4', {
                    url: '/prodgrp4/:prodgrp3_id/:prodgrp4_id',
                    //component: 'prodGrp4',
                    component: ProdGrp4Component,
                })
                .state('prodgrp2menu', {
                    url: '/prodgrp2menu/:prodgrp2_id',
                    //component: 'prodGrp2Menu',
                    component: ProdGrp2MenuComponent,
                })
                .state('prodgrp3menu', {
                    url: '/prodgrp3menu/:prodgrp3_id',
                    //component: 'prodGrp3Menu',
                    component: ProdGrp3MenuComponent,
                })
                .state('prodgrp4menu', {
                    url: '/prodgrp4menu/:prodgrp4_id',
                    //component: 'prodGrp4Menu',
                    component: ProdGrp4MenuComponent,
                })
                .state('prodgrplangs', {
                    url: '/prodgrplangs/:prodgrp_id',
                    //component: 'prodGrpLangs',
                    component: ProdGrpLangsComponent,
                })
                .state('prodgrpmenu', {
                    url: '/prodgrpmenu/:prodgrp_id',
                    component: 'prodGrpMenu',
                })
                .state('prodgrps', {
                    url: '/prodgrps',
                    //component: 'prodGrps',
                    component: ProdGrpsComponent,
                })
                .state('pocf', {
                    url: '/pocf/:argtype/:argvalue',
                    component: 'pocf',
                })
                .state('pofinishpofinishcomps', {
                    url: '/pofinishpofinishcomps/:p2_pofinish_keyno',
                    //component: 'poFinishPoFinishComps',
                    component: PoFinishPoFinishCompsComponent,
                })
                .state('poloadplan', {
                    url: '/poloadplan',
                    //component: 'poLoadPlan',
                    component: PoLoadPlanComponent,
                })
                .state('p2reportdefs', {
                    url: '/p2reportdefs',
                    component: 'p2ReportDefs',
                })
                .state('p2reportdef', {
                    url: '/p2reportdef/:p2_reportdef_keyno',
                    component: 'p2ReportDef',
                })
                .state('htmlreports', {
                    url: '/htmlreports',
                    component: 'htmlReports',
                })
                .state('htmlreport', {
                    url: '/htmlreport/:htmlreport_keyno',
                    component: 'htmlReport',
                })
                .state('htmlproc', {
                    url: '/htmlproc/:htmlreport_keyno/:htmlproc_keyno_belongto/:htmlproc_keyno',
                    component: 'htmlProc',
                })
                .state('component', {
                    url: '/component/:prod_id/:comp_keyno',
                    // component: 'component',
                    component: ComponentComponent,
                    resolve: [VIEW_NAVIGATOR(ComponentComponent)],
                })
                .state('componentreplaceables', {
                    url: '/componentreplaceables/:comp_keyno',
                    //component: 'componentReplaceAbles',
                    component: ComponentReplaceAblesComponent,
                })
                .state('components', {
                    url: '/components/:prod_id',
                    //component: 'components',
                    component: ComponentsComponent,
                })
                .state('compvalidationset', {
                    url: '/compvalidationset/:comp_keyno',
                    component: 'compValidationSet',
                })
                .state('hrmenu', {
                    url: '/hrmenu',
                    // component: 'hrMenu',
                    component: HrMenuComponent,
                })
                .state('jobqueuemonitor', {
                    url: '/jobqueuemonitor',
                    //component: 'jobQueueMonitor',
                    component: JobQueueMonitorComponent,
                })
                .state('jobschedule', {
                    url: '/jobschedule/:jobschedule_keyno',
                    //component: 'jobSchedule',
                    component: JobScheduleComponent,
                })
                .state('jobschedules', {
                    url: '/jobschedules',
                    //component: 'jobSchedules',
                    component: JobSchedulesComponent,
                })
                .state('productcalc', {
                    url: '/productcalc/:prod_id/:argtype/:argvalue',
                    component: 'productCalc',
                })
                .state('product', {
                    url: '/product/:prod_id',
                    component: 'product',
                    component: ProductComponent,
                    resolve: [VIEW_NAVIGATOR(ProductComponent)],
                })
                .state('productlabel', {
                    url: '/productlabel/:p2_reportdef_keyno',
                    component: 'productLabel',
                    params: {
                        p2_reportdef_keyno: { squash: true, value: '' },
                    },
                })
                .state('sirvsetup', {
                    url: '/sirvsetup',
                    //component: 'sirvSetup'
                    component: SirvSetupComponent,
                })
                .state('productean', {
                    url: '/productean/:prod_id/:productean_keyno',
                    component: 'productEan',
                })
                .state('producteans', {
                    url: '/producteans/:prod_id',
                    //component: 'productEans',
                    component: ProductEansComponent,
                })
                .state('productlang', {
                    url: '/productlang/:prodlang_keyno',
                    //component: 'productLang',
                    component: ProductLangComponent,
                })
                .state('productlangs', {
                    url: '/productlangs/:prod_id',
                    //component: 'productLangs',
                    component: ProductLangsComponent,
                })
                .state('productlink', {
                    url: '/productlink/:productlink_keyno',
                    //component: 'productLink',
                    component: ProductLinkComponent,
                })
                .state('productlinks', {
                    url: '/productlinks/:argtype/:argvalue/:productlinktype_keyno',
                    //component: 'productLinks',
                    component: ProductLinksComponent,
                })
                .state('productlinkschange', {
                    url: '/productlinkschange/:argtype/:argvalue/:productlinktype_keyno',
                    //component: 'productLinksChange',
                    component: ProductLinksChangeComponent,
                })
                .state('productmultiunit', {
                    url: '/productmultiunit/:prod_id',
                    //component: 'productMultiUnit',
                    component: ProductMultiUnitComponent,
                })
                .state('productpic', {
                    url: '/productpic/:productpicturebank_keyno/:prod_id',
                    //component: 'productPic',
                    component: ProductPicComponent,
                })
                .state('productpics', {
                    url: '/productpics/:prod_id',
                    //component: 'productPics',
                    component: ProductPicsComponent,
                })
                .state('productprices', {
                    url: '/productprices/:prod_id',
                    //component: 'productPrices',
                    component: ProductPricesComponent,
                })
                .state('productview', {
                    url: '/productview/:prod_id',
                    //component: 'productView',
                    component: ProductViewComponent,
                })
                .state('propertyclasses', {
                    url: '/propertyclasses',
                    //component: 'propertyClasses',
                    component: PropertyClassesComponent,
                })
                .state('propertyclasslangs', {
                    url: '/propertyclasslangs/:propertyclass_id',
                    //component: 'propertyClassLangs',
                    component: PropertyClassLangsComponent,
                })
                .state('price', {
                    url: '/price/:pricegrp_keyno/:price_keyno',
                    //component: 'price',
                    component: PriceComponent,
                })
                .state('pricelist', {
                    url: '/pricelist/:pricelist_id',
                    //component: 'priceList',
                    component: PriceListComponent,
                })
                .state('pricelists', {
                    url: '/pricelists',
                    //component: 'priceLists',
                    component: PriceListsComponent,
                })
                .state('pricelistprice', {
                    url: '/pricelistprice/:argtype/:argvalue',
                    component: 'priceListPrice',
                })
                .state('pricelistbusco', {
                    url: '/pricelistbusco/:pricelist_id/:businessco_no',
                    //component: 'priceListBusCo',
                    component: PriceListBusCoComponent,
                })
                .state('pricelistbuscos', {
                    url: '/pricelistbuscos/:pricelist_id',
                    //component: 'priceListBusCos',
                    component: PriceListBusCosComponent,
                })
                .state('pricelistfactors', {
                    url: '/pricelistfactors/:argtype/:argvalue',
                    //component: 'priceListFactors',
                    component: PriceListFactorsComponent,
                })
                .state('skillscertificate', {
                    url: '/skillscertificate/:labour_no/:skillscertificate_keyno',
                    //component: 'skillsCertificate',
                    component: SkillsCertificateComponent,
                })
                .state('skillscertificates', {
                    url: '/skillscertificates/:argtype/:argvalue',
                    //component: 'skillsCertificates',
                    component: SkillsCertificatesComponent,
                })
                .state('skillscertificatetable', {
                    url: '/skillscertificatetable',
                    //component: 'skillsCertificateTable',
                    component: SkillsCertificateTableComponent,
                })
                .state('skillscertificatetype', {
                    url: '/skillscertificatetype/:skillscertificatetype_keyno',
                    //component: 'skillsCertificateType',
                    component: SkillsCertificateTypeComponent,
                })
                .state('skillscertificatetypes', {
                    url: '/skillscertificatetypes',
                    //component: 'skillsCertificateTypes',
                    component: SkillsCertificateTypesComponent,
                })
                .state('timestampstartcorr', {
                    url: '/timestampstartcorr/:labour_no',
                    //component: 'timeStampStartCorr',
                    component: TimeStampStartCorrComponent,
                })
                .state('purchprice', {
                    url: '/purchprice/:prodsize_keyno/:purchprice_keyno',
                    component: 'purchPrice',
                })
                .state('productunits', {
                    url: '/productunits/:prod_id',
                    //component: 'productUnits',
                    component: ProductUnitsComponent,
                })
                .state('productunit', {
                    url: '/productunit/:prod_id/:productunit_keyno',
                    //component: 'productUnit',
                    component: ProductUnitComponent,
                })
                .state('productunitsedit', {
                    url: '/productunitsedit/:prod_id',
                    //component: 'productUnitsEdit',
                    component: ProductUnitsEditComponent,
                })
                .state('productunitdata', {
                    url: '/productunitdata/:productunitdata_keyno',
                    //component: 'productUnitData',
                    component: ProductUnitDataComponent,
                })
                .state('pomenu', {
                    url: '/pomenu/:po_keyno',
                    //component: 'poMenu',
                    component: PoMenuComponent,
                })
                .state('pofinish', {
                    url: '/pofinish/:p2_pofinish_keyno',
                    //component: 'poFinish',
                    component: PoFinishComponent,
                })
                .state('pofinishlist', {
                    url: '/pofinishlist',
                    component: 'poFinishList',
                })
                .state('pofinishprodworks', {
                    url: '/pofinishprodworks/:p2_pofinishprod_keyno',
                    //component: 'poFinishProdWorks',
                    component: PoFinishProdWorksComponent,
                })
                .state('pofinishprodwork', {
                    url: '/pofinishprodwork/:p2_pofinishprodwork_keyno',
                    //component: 'poFinishProdWork',
                    component: PoFinishProdWorkComponent,
                })
                .state('pofinishprod', {
                    url: '/pofinishprod/:po_keyno/:p2_pofinishprod_keyno',
                    component: 'poFinishProd',
                })
                .state('suboperation', {
                    url: '/suboperation/:operation_id/:suboperation_keyno',
                    //component: 'subOperation',
                    component: SubOperationComponent,
                })
                .state('suboperations', {
                    url: '/suboperations/:operation_id',
                    //component: 'subOperations',
                    component: SubOperationsComponent,
                })
                .state('suboperationlang', {
                    url: '/suboperationlang/:suboperation_keyno',
                    //component: 'subOperationLang',
                    component: SubOperationLangComponent,
                })
                .state('pofinishprodlist', {
                    url: '/pofinishprodlist/:p2_pofinish_keyno',
                    component: 'poFinishProdList',
                    //component: PoFinishProdListComponent,
                })
                //.state('pohfinishcomp', {
                //    //    url: '/pohfinishcomp/:poh_keyno/:quantity_finished_now',
                //    component: 'pohFinishComp'
                //})
                .state('pofinishprodpack', {
                    url: '/pofinishprodpack/:poh_keyno_top/:counter',
                    component: 'poFinishProdPack',
                })
                .state('pofinishcomplist', {
                    url: '/pofinishcomplist/:p2_pofinishprod_keyno',
                    component: 'poFinishCompList',
                })
                .state('pofinishprodcompassign', {
                    url: '/pofinishprodcompassign/:p2_pofinishprodcomp_keyno',
                    component: 'poFinishProdCompAssign',
                })
                .state('pofinishprodcompsbs', {
                    url: '/pofinishprodcompsbs/:p2_pofinishprodcomp_keyno',
                    //component: 'poFinishProdCompsBs',
                    component: PoFinishProdCompsBsComponent,
                })
                .state('pofinishprodcompsb', {
                    url: '/pofinishprodcompsb/:p2_pofinishprodcompsb_keyno',
                    component: 'poFinishProdCompsB',
                    //component: PoFinishProdCompsBComponent,
                })
                .state('pohcompaddscan', {
                    url: '/pohcompaddscan/:poh_keyno',
                    //component: 'pohCompAddScan',
                    component: PohCompAddScanComponent,
                })
                .state('pohcompadd', {
                    url: '/pohcompadd/:poh_keyno/:stock_keyno',
                    component: 'pohCompAdd',
                    //component: PohCompAddComponent,
                })
                //.state('pohcompaddquant', {
                //    //    url: '/pohcompaddquant/:poh_keyno/:pohcomp_keyno',
                //    component: 'pohCompAddQuant'
                //})
                .state('pofinishprodcomp', {
                    url: '/pofinishprodcomp/:p2_pofinishprod_keyno/:p2_pofinishprodcomp_keyno',
                    component: 'poFinishProdComp',
                    //component: PoFinishProdCompComponent,
                })
                .state('pofinishprodcompqty', {
                    url: '/pofinishprodcompqty/:p2_pofinishprodcomp_keyno',
                    //component: 'poFinishProdCompQty',
                    component: PoFinishProdCompQtyComponent,
                })
                .state('pofinishprodcomplistaccs', {
                    url: '/pofinishprodcomplistaccs/:p2_pofinish_keyno',
                    //component: 'poFinishProdCompListAccs',
                    component: PoFinishProdCompListAccsComponent,
                })
                .state('pofinishprodcomplistacc', {
                    url: '/pofinishprodcomplistacc/:p2_pofinish_keyno/:prodsize_keyno/:prodchoice_keyno',
                    component: 'poFinishProdCompListAcc',
                })
                .state('ni', {
                    url: '/ni',
                    component: 'ni',
                })
                .state('selectableproducts', {
                    url: '/selectableproducts',
                    //component: 'selectableProducts',
                    component: SelectableProductsComponent,
                })
                .state('selectarticles', {
                    url: '/selectarticles',
                    //component: 'selectArticles',
                    component: SelectArticlesComponent,
                })
                .state('custactplan', {
                    url: '/custactplan/:custactplan_keyno',
                    component: 'custactPlan',
                })
                .state('custactplans', {
                    url: '/custactplans',
                    //component: 'custactPlans',
                    component: CustactPlansComponent,
                })
                .state('datamining', {
                    url: '/datamining/:p2_statsource_keyno/:level_no',
                    component: 'dataMining',
                })
                .state('dataminingcreate', {
                    url: '/dataminingcreate/:p2_statsource_keyno/:level_no',
                    //component: 'dataMiningCreate',
                    component: DataMiningCreateComponent,
                })
                .state('datamininglist', {
                    url: '/datamininglist',
                    //component: 'dataMiningList',
                    component: DataMiningListComponent,
                })
                .state('p2statsource', {
                    url: '/p2statsource',
                    //component: 'p2StatSource',
                    component: P2StatSourceComponent,
                })
                .state('p2statsourceedit', {
                    url: '/p2statsourceedit/:p2_statsource_keyno',
                    //component: 'p2StatSourceEdit',
                    component: P2StatSourceEditComponent,
                })
                .state('interbranchinvoiceline', {
                    url: '/interbranchinvoiceline/:interbranchinvoiceline_keyno',
                    component: 'interBranchInvoiceLine',
                    //component: InterBranchInvoiceLineComponent,
                })
                .state('interbranchinvoicelinemultiapproval', {
                    url: '/interbranchinvoicelinemultiapproval',
                    component: 'interbranchInvoicelineMultiApproval',
                })
                .state('interbranchinvoicing', {
                    url: '/interbranchinvoicing',
                    //component: 'interBranchInvoicing',
                    component: InterbranchInvoicingComponent,
                })
                .state('interbranchinvoicingmi', {
                    url: '/interbranchinvoicingmi/:businessco_no_from/:businessco_no_to',
                    //component: 'interBranchInvoicingMi',
                    component: InterbranchInvoicingMiComponent,
                })
                .state('interbranchinvoiceoverview', {
                    url: '/interbranchinvoiceoverview',
                    component: 'interBranchInvoiceOverview',
                })
                .state('interbranchlevel', {
                    url: '/interbranchlevel/:interbranchlevel_keyno',
                    //component: 'interBranchLevel',
                    component: InterbranchLevelComponent,
                })
                .state('interbranchmulti', {
                    url: '/interbranchmulti',
                    //component: 'interBranchMulti',
                    component: InterbranchMultiComponent,
                })
                .state('interbranchmultiget', {
                    url: '/interbranchmultiget/:interbranchmulti_keyno',
                    //component: 'interBranchMultiGet',
                    component: InterbranchMultiGetComponent,
                })
                .state('interbranchmultiinvoicing', {
                    url: '/interbranchmultiinvoicing',
                    component: 'interbranchMultiInvoicing',
                })
                .state('incomingcall', {
                    url: '/incomingcall/:phoneno',
                    //component: 'incomingCall',
                    component: IncomingCallComponent,
                })
                .state('olmrequisition', {
                    url: '/olmrequisition/:olm_keyno',
                    component: 'olmRequisition',
                    //component: OlmRequisitionComponent,
                })
                .state('prepareboms', {
                    url: '/prepareboms',
                    //component: 'prepareBoms',
                    component: PrepareBomsComponent,
                })
                .state('requisitionplanview', {
                    url: '/requisitionplanview',
                    //component: 'requisitionPlanView',
                    component: RequisitionPlanViewComponent,
                })
                .state('requisition', {
                    url: '/requisition/:requisition_no',
                    //component: 'requisition',
                    component: RequisitionComponent,
                })
                .state('requisitiontoconsignment', {
                    url: '/requisitiontoconsignment/:stockplace_id_from/:stockplace_id_to/:consignment_keyno',
                    component: 'requisitionToConsignment',
                })
                .state('requisitions', {
                    url: '/requisitions',
                    //component: 'requisitions',
                    component: RequisitionsComponent,
                })
                .state('requisitionsbetween', {
                    url: '/requisitionsbetween',
                    //component: 'requisitionsBetween',
                    component: RequisitionsBetweenComponent,
                })
                .state('requisitioncreate', {
                    url: '/requisitioncreate/:stock_keyno_from/:stock_keyno_to',
                    //component: 'requisitionCreate',
                    component: RequisitionCreateComponent,
                })
                .state('requisitioncreatefrom', {
                    url: '/requisitioncreatefrom/:stock_keyno',
                    //component: 'requisitionCreateFrom',
                    component: RequisitionCreateFromComponent,
                })
                .state('requisitionplanning', {
                    url: '/requisitionplanning',
                    component: 'requisitionPlanning',
                })
                .state('requisitionsimplified', {
                    url: '/requisitionsimplified',
                    component: RequisitionSimplifiedComponent,
                    resolve: [VIEW_NAVIGATOR(RequisitionSimplifiedComponent)],
                })
                .state('shipmentcontainer', {
                    url: '/shipmentcontainer/:shipmentcontainer_keyno',
                    //component: 'shipmentContainer',
                    component: ShipmentContainerComponent,
                })
                .state('shipmentcontainers', {
                    url: '/shipmentcontainers',
                    //component: 'shipmentContainers',
                    component: ShipmentContainersComponent,
                })
                .state('shopfloor', {
                    url: '/shopfloor/:argtype/:argvalue/:comp_is_prod_id',
                    component: 'shopFloor',
                    component: ShopFloorComponent,
                })
                .state('shopfloorselectoh', {
                    url: '/shopfloorselectoh',
                    //component: 'shopFloorSelectOh',
                    component: ShopFloorSelectOhComponent,
                })
                .state('stockget', {
                    url: '/stockget/:stock_keyno',
                    //component: 'stockGet',
                    component: StockGetComponent,
                })
                .state('stockforecast', {
                    url: '/stockforecast/:prod_id/:prodsize_keyno/:prodchoice_keyno/:stockplace_id',
                    component: 'stockForecast',
                })
                .state('stockall', {
                    url: '/stockall/:stock_keyno',
                    //component: 'stockAll',
                    component: StockAllComponent,
                })
                .state('stockcorrection', {
                    url: '/stockcorrection/:stock_keyno/:stocklocation_keyno',
                    component: 'stockCorrection',
                })
                .state('stockstockbatchassigned', {
                    url: '/stockstockbatchassigned/:stock_keyno',
                    //component: 'stockStockBatchAssigned',
                    component: StockStockBatchAssignedComponent,
                })
                .state('stockhistoric', {
                    url: '/stockhistoric',
                    //component: 'stockHistoric',
                    component: StockHistoricComponent,
                })
                .state('stockhistory', {
                    url: '/stockhistory/:stock_keyno',
                    //component: 'stockHistory',
                    component: StockHistoryComponent,
                })
                .state('stockincoming', {
                    url: '/stockincoming/:stock_keyno',
                    //component: 'stockIncoming',
                    component: StockIncomingComponent,
                })
                .state('stockoutgoing', {
                    url: '/stockoutgoing/:stock_keyno',
                    //component: 'stockOutgoing',
                    component: StockOutgoingComponent,
                })
                .state('stockstatus', {
                    url: '/stockstatus/:stock_keyno',
                    component: StockStatusComponent,
                    resolve: [VIEW_NAVIGATOR(StockStatusComponent)],
                })
                .state('stockstatusdrilldown', {
                    url: '/stockstatusdrilldown/:stock_keyno/:argtype',
                    component: StockStatusDrillDownComponent,
                    resolve: [VIEW_NAVIGATOR(StockStatusDrillDownComponent)],
                })
                .state('createpopu', {
                    url: '/createpopu/:stock_keyno',
                    //component: 'createPoPu',
                    component: CreatePoPuComponent,
                })
                .state('stockbatchlist', {
                    url: '/stockbatchlist/:stock_keyno',
                    //component: 'stockBatchList',
                    component: StockBatchListComponent,
                })
                .state('stockbatchget', {
                    url: '/stockbatchget/:stockbatch_keyno',
                    //component: 'stockBatchGet',
                    component: StockBatchGetComponent,
                })
                .state('stockbatchtrace', {
                    url: '/stockbatchtrace/:stockbatch_keyno',
                    component: 'stockBatchTrace',
                })
                .state('guardlist', {
                    url: '/guardlist/:argtype/:argvalue',
                    //component: 'guardList',
                    component: GuardListComponent,
                })
                .state('gisposition', {
                    url: '/gisposition/:gisposition_keyno',
                    //component: 'gisPosition',
                    component: GisPositionComponent,
                })
                .state('gispositionadd', {
                    url: '/gispositionadd/:argtype/:argvalue/:lat/:lng',
                    //component: 'gisPositionAdd',
                    component: GisPositionAddComponent,
                })
                .state('gridexportarg', {
                    url: '/gridexportarg/:argtype/:argvalue/:p2_exportproc_keyno',
                    component: 'gridExportArg',
                })
                .state('gridexports', {
                    url: '/gridexports/:argtype/:argvalue',
                    //component: 'gridExports',
                    component: GridExportsComponent,
                })
                .state('mapview', {
                    url: '/mapview/:argtype/:argvalue',
                    component: 'mapView',
                })
                .state('myfontsize', {
                    url: '/myfontsize',
                    component: 'myFontSize',
                })
                .state('mypage', {
                    url: '/mypage/:labour_no',
                    // component: 'myPage',
                    component: MyPageComponent,
                })
                .state('myposition', {
                    url: '/myposition',
                    component: 'myPosition',
                })
                .state('position', {
                    url: '/position/:argtype/:argvalue/:position_keyno',
                    //component: 'position',
                    component: PositionComponent,
                })
                .state('positions', {
                    url: '/positions/:argtype/:argvalue',
                    //component: 'positions',
                    component: PositionsComponent,
                })
                .state('bcr', {
                    url: '/bcr/:barcode',
                    component: 'bcr',
                })
                .state('findcustomers', {
                    url: '/findcustomers',
                    //component: 'findCustomers',
                    component: FindCustomersComponent,
                    resolve: [VIEW_NAVIGATOR(FindCustomersComponent)],

                    pageChanged: {
                        header: {
                            translate: true,
                        },
                        backButton: {
                            translate: true,
                            fallback: {
                                state: 'mainmenu',
                            },
                        },
                        //bigButton: { visible: false },
                        homeButton: { visible: false },
                    },
                })
                .state('accessinfo', {
                    url: '/accessinfo/:argtype/:argvalue',
                    //component: 'accessInfo',
                    component: AccessInfoComponent,
                })
                .state('aichat', {
                    url: '/aichat',
                    component: AiChatComponent,
                    resolve: [VIEW_NAVIGATOR(AiChatComponent)],
                })
                .state('acreminderproposal', {
                    url: '/acreminderproposal',
                    component: 'acReminderProposal',
                    //component: AcReminderProposalComponent,
                })
                .state('acremltr', {
                    url: '/acremltr/:businessco_no/:acremltr_keyno',
                    //component: 'acRemLtr',
                    component: AcRemLtrComponent,
                })
                .state('findperson', {
                    url: '/findperson',
                    //component: 'findPerson',
                    component: FindPersonComponent,
                })
                .state('forecast', {
                    url: '/forecast/:forecast_keyno',
                    //component: 'forecast',
                    component: ForecastComponent,
                })
                .state('forecasts', {
                    url: '/forecasts',
                    //component: 'forecasts',
                    component: ForecastsComponent,
                })
                .state('forecastdatagrid', {
                    url: '/forecastdatagrid',
                    //component: 'forecastDataGrid',
                    component: ForecastDataGridComponent,
                })
                .state('tracesb', {
                    url: '/tracesb/:stockbatch_keyno',
                    //component: 'tracesB',
                    component: TracesBComponent,
                })
                .state('tracesearch', {
                    url: '/tracesearch/:argtype/:argvalue',
                    //component: 'traceSearch',
                    component: TraceSearchComponent,
                })
                .state('selectcustomer', {
                    url: '/selectcustomer',
                    component: 'selectCustomer',
                })
                .state('customersmenu', {
                    url: '/customersmenu/:cust_no',
                    component: 'customersMenu',
                    component: CustomersMenuComponent,
                    resolve: [VIEW_NAVIGATOR(CustomersMenuComponent)],
                    title: '',
                })
                .state('deliverycustomer', {
                    url: '/deliverycustomer/:deliverycustomer_keyno/:cust_no',
                    //component: 'deliveryCustomer',
                    component: DeliveryCustomerComponent,
                })
                .state('deliverycustomers', {
                    url: '/deliverycustomers/:cust_no',
                    //component: 'deliveryCustomers',
                    component: DeliveryCustomersComponent,
                })
                .state('deliveryplanning', {
                    url: '/deliveryplanning',
                    component: 'deliveryPlanning',
                })
                .state('defaultcounters', {
                    url: '/defaultcounters',
                    component: DefaultCountersComponent,
                })
                .state('discgrpcust', {
                    url: '/discgrpcust/:discgrpcust_keyno',
                    //component: 'discGrpCust',
                    component: DiscGrpCustComponent,
                })
                .state('discgrpdatas', {
                    url: '/discgrpdatas',
                    //component: 'discGrpDatas',
                    component: DiscGrpDatasComponent,
                })
                .state('discgrpcustlangs', {
                    url: '/discgrpcustlangs/:discgrpcust_keyno',
                    //component: 'discGrpCustLangs',
                    component: DiscGrpCustLangsComponent,
                })
                .state('discgrpcusts', {
                    url: '/discgrpcusts',
                    //component: 'discGrpCusts',
                    component: DiscGrpCustsComponent,
                })
                .state('discgrpprod', {
                    url: '/discgrpprod/:discgrpprod_keyno',
                    //component: 'discGrpProd',
                    component: DiscGrpProdComponent,
                })
                .state('discgrpprodlangs', {
                    url: '/discgrpprodlangs/:discgrpprod_keyno',
                    //component: 'discGrpProdLangs',
                    component: DiscGrpProdLangsComponent,
                })
                .state('discgrpprods', {
                    url: '/discgrpprods',
                    //component: 'discGrpProds',
                    component: DiscGrpProdsComponent,
                })
                .state('pictures', {
                    url: '/pictures/:argtype/:argvalue',
                    component: 'pictures',
                })
                .state('doccategories', {
                    url: '/doccategories',
                    //component: 'docCategories',
                    component: DocCategoriesComponent,
                })
                .state('doccategory', {
                    url: '/doccategory/:doccategory_keyno',
                    //component: 'docCategory',
                    component: DocCategoryComponent,
                })
                .state('doccategorylang', {
                    url: '/doccategorylang/:doccategory_keyno',
                    //component: 'docCategoryLang',
                    component: DocCategoryLangComponent,
                })
                .state('docpack', {
                    url: '/docpack/:docpack_keyno',
                    component: DocPackComponent,
                    resolve: [VIEW_NAVIGATOR(DocPackComponent)],
                    // component: 'docPack',
                })
                .state('docpackdocadd', {
                    url: '/docpackdocadd/:docpackchapter_keyno',
                    component: 'docPackDocAdd',
                })
                .state('docpacksbadd', {
                    url: '/docpacksbadd/:docpack_keyno',
                    component: 'docPacksBAdd',
                })
                .state('docpacktype', {
                    url: '/docpacktype/:docpacktype_keyno',
                    //component: 'docPackType',
                    component: DocPackTypeComponent,
                    resolve: [VIEW_NAVIGATOR(DocPackTypeComponent)],
                })
                .state('docpacktypechapter', {
                    url: '/docpacktypechapter/:docpacktype_keyno/:docpacktypechapter_keyno',
                    //component: 'docPackTypeChapter',
                    component: DocPackTypeChapterComponent,
                })
                .state('docpacktypechapters', {
                    url: '/docpacktypechapters',
                    component: 'docPackTypeChapters',
                })
                .state('docpacktypemenu', {
                    url: '/docpacktypemenu/:docpacktype_keyno',
                    //component: 'docPackTypeMenu',
                    component: DocPackTypeMenuComponent,
                })
                .state('docpacktypes', {
                    url: '/docpacktypes',
                    //component: 'docPackTypes',
                    component: DocPackTypesComponent,
                })
                .state('documents', {
                    url: '/documents/:argtype/:argvalue',
                    component: 'documents',
                    component: DocumentsViewComponent,
                })
                .state('dodataimpswizard', {
                    url: '/dodataimpswizard',
                    component: DoDataImpsWizardComponent,
                })
                .state('dodataimpswizardedit', {
                    url: '/dodataimpswizardedit/:bsp_keyno/:bsp_wizard_keyno',
                })
                .state('domobject', {
                    url: '/domobject/:domobject_keyno_parent/:domobject_keyno_child',
                    component: 'domObject',
                    // Migrated Angular alternative for manual testing:
                    // component: DomObjectComponent,
                })
                .state('domobjectchild', {
                    url: '/domobjectchild/:domobject_keyno_parent/:domobjectchild_keyno/:language_id/:domobject_keyno_selected',
                    component: 'domObjectChild',
                })
                .state('domobjectsview', {
                    url: '/domobjectsview/:domobject_keyno',
                    component: 'domObjectsView',
                    title: '',
                })
                .state('domobjecttype', {
                    url: '/domobjecttype/:domobjecttype_keyno',
                    //component: 'domObjectType',
                    component: DomObjectTypeComponent,
                })
                .state('domobjecttypemenu', {
                    url: '/domobjecttypemenu/:domobjecttype_keyno',
                    //component: 'domObjectTypeMenu',
                    component: DomObjectTypeMenuComponent,
                })
                .state('domobjecttypeprop', {
                    url: '/domobjecttypeprop/:domobjecttype_keyno/:domobjecttypeprop_keyno',
                    //component: 'domObjectTypeProp',
                    component: DomObjectTypePropComponent,
                })
                .state('domobjecttypes', {
                    url: '/domobjecttypes',
                    //component: 'domObjectTypes',
                    component: DomObjectTypesComponent,
                })
                .state('dynamicdatataskgoto', {
                    url: '/dynamicdatataskgoto/:p2_datatask_keyno',
                    redirectTo: (trans) => {
                        const datatask = trans.injector().get('$ihttp');
                        const $state = trans.injector().get('$state');

                        return datatask.post({ method: 3926, parameters: trans.params() }).then((response) => {
                            if (!response[0].item_state) return;

                            const params = {};
                            const values = response[0].item_parms?.split('?')[0]?.split('/');
                            const paramsKeys =
                                $state
                                    .get(response[0].item_state)
                                    .url?.split('?')[0]
                                    .split('/')
                                    .filter((part) => part.startsWith(':'))
                                    .map((part) => part.replace(':', '')) ?? [];

                            for (let i = 0; i < paramsKeys.length; i++) {
                                params[paramsKeys[i]] = values[i];
                            }

                            return { state: response[0].item_state, params: params };
                        });
                    },
                })
                .state('picturebanks', {
                    url: '/picturebanks/:argtype/:argvalue',
                    //component: 'pictureBanks'
                    component: PictureBanksComponent,
                })
                .state('picturebank', {
                    url: '/picturebank/:picturebank_keyno',
                    //component: 'pictureBank'
                    component: PictureBankComponent,
                })
                .state('selectnewdoctype', {
                    url: '/selectnewdoctype/:argtype/:argvalue',
                    //component: 'selectNewDoctype',
                    component: SelectNewDocTypeComponent,
                })
                .state('selecttextilemodel', {
                    url: '/selecttextilemodel/:order_internal_no/:orderline_keyno',
                    //component: 'selectTextileModel',
                    component: SelectTextileModelComponent,
                })
                .state('docarc', {
                    url: '/docarc/:argtype/:argvalue/:docarc_keyno',
                    component: 'docArc',
                })
                // Angular test route
                .state('docarc-test', {
                    url: '/docarc-test/:argtype/:argvalue/:docarc_keyno',
                    component: DocArcComponent,
                })
                .state('docarticle', {
                    url: '/docarticle/:docarticle_keyno',
                    component: 'docArticle',
                    component: DocArticleViewComponent,
                })
                .state('docarticleedit', {
                    url: '/docarticleedit/:docarticle_keyno',
                    // component: 'docArticleEdit',
                    component: DocArticleEditViewComponent,
                })
                .state('docarticleporus', {
                    url: '/docarticleporus/:docarticle_keyno',
                    //component: 'docArticlePorus',
                    component: DocArticlePorusComponent,
                })
                .state('docarticlesearch', {
                    url: '/docarticlesearch',
                    //component: 'docArticleSearch',
                    component: DocArticleSearchComponent,
                })
                .state('docarticletopusergroup', {
                    url: '/docarticletopusergroup/:docarticletopusergroup_keyno',
                    //component: 'docArticleTopUserGroup',
                    component: DocArticleTopUserGroupComponent,
                })
                .state('docarticletopusergroups', {
                    url: '/docarticletopusergroups/:docarticle_keyno_top',
                    //component: 'docArticleTopUserGroups',
                    component: DocArticleTopUserGroupsComponent,
                })
                .state('edgerelations', {
                    url: '/edgerelations',
                    //component: 'edgeRelations',
                    component: EdgeRelationsComponent,
                })
                .state('edgerelation', {
                    url: '/edgerelation/:edgerelation_keyno',
                    component: 'edgeRelation',
                })
                .state('special_cust_prod_calc', {
                    url: '/special_cust_prod_calc/:cust_no',
                    //component: 'specialCustProdCalc',
                    component: SpecialCustProdCalcComponent,
                    resolve: [VIEW_NAVIGATOR(SpecialCustProdCalcComponent)],
                })
                .state('customer_discgrpprod', {
                    url: '/customer_discgrpprod/:cust_no',
                    //component: 'customerDiscGrpProd',
                    component: CustomerDiscGrpProdComponent,
                })
                .state('custgrp', {
                    url: '/custgrp/:custgrp_id',
                    //component: 'custGrp',
                    component: CustGrpComponent,
                })
                .state('custgrplangs', {
                    url: '/custgrplangs/:custgrp_id',
                    //component: 'custGrpLangs',
                    component: CustGrpLangsComponent,
                })
                .state('custgrpmenu', {
                    url: '/custgrpmenu/:custgrp_id',
                    //component: 'custGrpMenu',
                    component: CustGrpMenuComponent,
                })
                .state('custgrps', {
                    url: '/custgrps',
                    //component: 'custGrps',
                    component: CustGrpsComponent,
                })
                .state('custgrp2s', {
                    url: '/custgrp2s',
                    component: CustGrp2sComponent,
                    //component: 'custGrps',
                })
                .state('custgrp2', {
                    url: '/custgrp2/:custgrp2_keyno',
                    component: CustGrp2ViewComponent,
                    //component: 'custGrps',
                })
                .state('economymenu', {
                    url: '/economymenu',
                    // component: 'economyMenu',
                    component: EconomyMenuComponent,
                })
                .state('productmenu', {
                    url: '/productmenu',
                    component: ProductMenuComponent,
                    // component: 'productMenu',
                })
                .state('productbulkedit', {
                    url: '/productbulkedit',
                    component: 'productBulkEdit',
                })
                .state('ecommercestatus', {
                    url: '/ecommercestatus',
                    //component: 'eCommerceStatus',
                    component: ECommerceStatusComponent,
                })
                .state('p2notifications', {
                    url: '/p2notifications',
                    component: 'p2Notifications',
                })
                .state('helpdoc', {
                    url: '/helpdoc/:argtype/:argvalue',
                    component: HelpdocComponent,
                    // component: 'helpdoc',
                })
                .state('helpdocsearch', {
                    url: '/helpdocsearch',
                    //component: 'helpDocSearch',
                    component: HelpDocSearchComponent,
                })
                .state('helpdocttchanged', {
                    url: '/helpdocttchanged',
                    //component: 'helpdocttChanged',
                    component: HelpDocTtChangedComponent,
                })
                .state('p2terminals', {
                    url: '/p2terminals',
                    //component: 'p2Terminals',
                    component: P2TerminalsComponent,
                })
                .state('p2terminal', {
                    url: '/p2terminal/:p2_terminal_keyno',
                    //component: 'p2Terminal',
                    component: P2TerminalComponent,
                })
                .state('customeredit', {
                    url: '/customeredit/:cust_no',
                    component: 'customerEdit',
                    component: CustomerEditComponent,
                    resolve: [VIEW_NAVIGATOR(CustomerEditComponent)],

                    // component: CustomerEditViewComponent,
                })
                .state('customerpersons', {
                    url: '/customerpersons/:cust_no/:new_customer',
                    //component: 'customerPersons',
                    component: CustomerPersonsComponent,
                    params: {
                        cust_no: { squash: false },
                        new_customer: { squash: true, value: null },
                    },
                })
                .state('customstarif', {
                    url: '/customstarif/:customstarif_id',
                    component: CustomsTarifComponent,
                    //component: 'customsTarif',
                })
                .state('customstariflang', {
                    url: '/customstariflang/:customstarif_id',
                    component: CustomsTarifLangComponent,
                    //component: 'customsTarifLang',
                })
                .state('customstarifmenu', {
                    url: '/customstarifmenu/:customstarif_id',
                    component: CustomsTarifMenuComponent,
                    //component: 'customsTarifMenu',
                })
                .state('customstarifs', {
                    url: '/customstarifs',
                    component: CustomsTarifsComponent,
                    //component: 'customsTarifs',
                })
                .state('person', {
                    url: '/person/:cust_no/:pers_no/:new_customer',
                    // component: 'person',
                    params: {
                        cust_no: { squash: false },
                        pers_no: { squash: false },
                        new_customer: { squash: true, value: null },
                    },
                    component: PersonComponent,
                    resolve: [VIEW_NAVIGATOR(PersonComponent)],
                })
                .state('notifications', {
                    url: '/notifications',
                    component: 'notifications',
                })
                .state('rfidconnect', {
                    url: '/rfidconnect/:argtype/:argvalue',
                    component: 'rfidConnect',
                })
                .state('rfidsearch', {
                    url: '/rfidsearch',
                    //component: 'rfidSearch',
                    component: RfidSearchComponent,
                })
                .state('timeprojects', {
                    url: '/timeprojects',
                    //component: 'timeProjects',
                    component: TimeProjectsComponent,
                })
                .state('timeprojectswo', {
                    url: '/timeprojectswo/:project_keyno',
                    //component: 'timeProjectsWo',
                    component: TimeProjectsWoComponent,
                })
                .state('timecustomers', {
                    url: '/timecustomers',
                    //component: 'timeCustomers',
                    component: TimeCustomersComponent,
                })
                .state('timecustomerswo', {
                    url: '/timecustomerswo/:cust_no',
                    //component: 'timeCustomersWo',
                    component: TimeCustomersWoComponent,
                })
                .state('selectproduct', {
                    url: '/selectproduct/:webpage_name/:parm1/:parm2',
                    component: 'selectProduct',
                })
                .state('seller', {
                    url: '/seller/:seller_id',
                    component: 'seller',
                })
                .state('sellers', {
                    url: '/sellers',
                    component: 'sellers',
                })
                .state('serviceobject', {
                    url: '/serviceobject/:serviceobject_keyno',
                    component: 'serviceObject',
                    //component: ServiceObjectComponent,
                })
                .state('serviceobjectmenu', {
                    url: '/serviceobjectmenu/:serviceobject_keyno',
                    component: 'serviceObjectMenu',
                })
                .state('serviceobjects', {
                    url: '/serviceobjects/:argtype/:argvalue',
                    //component: 'serviceObjects',
                    component: ServiceObjectsComponent,
                })
                .state('serviceobjectsop', {
                    url: '/serviceobjectsop/:serviceobjectsop_keyno',
                    component: 'serviceObjectSop',
                })
                .state('serviceobjectnewact', {
                    url: '/serviceobjectnewact/:serviceobject_keyno',
                    component: 'serviceObjectNewAct',
                    //component: ServiceObjectNewActComponent,
                })
                .state('serviceobjecttype', {
                    url: '/serviceobjecttype/:serviceobjecttype_keyno',
                    //component: 'serviceObjectType',
                    component: ServiceObjectTypeComponent,
                })
                .state('serviceobjecttypeint', {
                    url: '/serviceobjecttypeint/:serviceobjecttype_keyno/:serviceobjecttypeint_keyno',
                    component: 'serviceObjectTypeInt',
                })
                .state('serviceobjecttypeints', {
                    url: '/serviceobjecttypeints/:serviceobjecttype_keyno',
                    //component: 'serviceObjectTypeInts',
                    component: ServiceObjectTypeIntsComponent,
                })
                .state('serviceobjecttypemenu', {
                    url: '/serviceobjecttypemenu/:serviceobjecttype_keyno',
                    //component: 'serviceObjectTypeMenu',
                    component: ServiceObjectTypeMenuComponent,
                })
                .state('serviceobjecttypes', {
                    url: '/serviceobjecttypes',
                    //component: 'serviceObjectTypes',
                    component: ServiceObjectTypesComponent,
                })
                .state('sop', {
                    url: '/sop/:sop_keyno',
                    //component: 'sop',
                    component: SopComponent,
                })
                .state('sopcl', {
                    url: '/sopcl/:sop_keyno/:sopcl_keyno',
                    //component: 'sopCl',
                    component: SopClComponent,
                })
                .state('sopcls', {
                    url: '/sopcls/:sop_keyno',
                    //component: 'sopCls',
                    component: SopClsComponent,
                })
                .state('sopmenu', {
                    url: '/sopmenu/:sop_keyno',
                    //component: 'sopMenu',
                    component: SopMenuComponent,
                })
                .state('sops', {
                    url: '/sops',
                    //component: 'sops',
                    component: SopsComponent,
                })
                .state('sopvalid', {
                    url: '/sopvalid/:sop_keyno',
                    component: 'sopValid',
                    //component: SopValidComponent,
                })
                .state('p2subscriptionedit', {
                    url: '/p2subscriptionedit/:p2_subscription_keyno',
                    component: 'p2SubscriptionEdit',
                })
                .state('resetPassword', {
                    url: '/resetpassword/:userName',
                    component: 'resetPassword',
                })
                .state('productmovechoice', {
                    url: '/productmovechoice/:prod_id/:comp_keyno',
                    //component: 'productMoveChoice',
                    component: ProductMoveChoiceComponent,
                })
                .state('productmovechoices', {
                    url: '/productmovechoices/:prod_id',
                    //component: 'productMoveChoices',
                    component: ProductMoveChoicesComponent,
                })
                .state('srfollowup', {
                    url: '/srfollowup/:experience_keyno',
                    component: 'srFollowUp',
                })
                .state('srfollowupforward', {
                    url: '/srfollowupforward/:experience_keyno',
                    component: 'srFollowUpForward',
                })
                .state('srfollowups', {
                    url: '/srfollowups',
                    component: 'srFollowUps',
                })
                .state('sroperationmanualadd', {
                    url: '/sroperationmanualadd',
                    component: 'srOperationManualAdd',
                })
                .state('srresource', {
                    url: '/srresource/:resource_id_belongto/:resource_id',
                    component: 'srResource',
                })
                .state('srresourceview', {
                    url: '/srresourceview',
                    component: 'srResourceView',
                })
                .state('stockplanning', {
                    url: '/stockplanning',
                    component: 'stockPlanning',
                })
                .state('stockplanningproduction', {
                    url: '/stockplanningproduction',
                    component: 'stockPlanningProduction',
                });

            $stateProvider
                .state('undodeliveryonorder', {
                    url: '/undodeliveryonorder/:order_internal_no',
                    component: 'undoDeliveryOnOrder',
                })
                .state('unit', {
                    url: '/unit/:unit_no',
                    //component: 'unit',
                    component: UnitComponent,
                })
                .state('unitlang', {
                    url: '/unitlang/:unit_no',
                    //component: 'unitLang',
                    component: UnitLangComponent,
                })
                .state('units', {
                    url: '/units',
                    //component: 'units',
                    component: UnitsComponent,
                })
                .state('usergroupedit', {
                    url: '/usergroupedit/:usergroup_keyno',
                    // component: 'userGroupEdit',
                    component: UserGroupViewComponent,
                })
                .state('users', {
                    url: '/users',
                    component: 'users',
                })
                .state('usergroups', {
                    url: '/usergroups',
                    // component: 'userGroups',
                    component: UserGroupsComponent,
                })
                .state('usergroupsetting', {
                    url: '/usergroupsetting/:item_id',
                    component: 'usergroupSetting',
                })
                .state('usergroupsettingedit', {
                    url: '/usergroupsettingedit/:item_id',
                    component: 'usergroupSettingEdit',
                })
                .state('usergrouptable', {
                    url: '/usergrouptable/:argtype/:argvalue',
                    component: 'usergroupTable',
                })
                .state('usergrouptableedit', {
                    url: '/usergrouptableedit/:p2_usergroup_table_keyno',
                    component: 'usergroupTableEdit',
                })
                .state('usersettings', {
                    url: '/usersettings/:userid',
                    component: 'userSettings',
                })
                .state('usersettings_dialogue_userinfo', {
                    url: '/usersettings_dialogue_userinfo/:portalUserKeyno',
                    component: 'userSettingsDialogueUserInfo',
                })
                .state('userusergroup', {
                    url: '/userusergroup/:get_username',
                    component: 'userUsergroup',
                })
                .state('userusergroupedit', {
                    url: '/userusergroupedit/:p2_usergroup_portal_user_keyno',
                    component: 'userUsergroupEdit',
                })
                .state('valuta', {
                    url: '/valuta/:valuta_id',
                    component: ValutaComponent,
                    //component: 'valuta',
                })
                .state('valutas', {
                    url: '/valutas',
                    //component: 'valutas',
                    component: ValutasComponent,
                })
                .state('visitor', {
                    url: '/visitor',
                    component: VisitorComponent,
                    //component: 'visitor',
                    //header: {
                    //    text: 'p2_m_visitor',
                    //    backButton: {
                    //        text: 'main_menu',
                    //        fallback: {
                    //            state: 'mainmenu',
                    //        },
                    //    },
                    //},
                })
                .state('visitorconfirm', {
                    url: '/visitorconfirm/:inout/:pers_no',
                    //component: 'visitorConfirm',
                    component: VisitorConfirmComponent,
                })
                .state('webpagesubscription', {
                    url: '/webpagesubscription/:argtype/:argvalue',
                    component: 'webpageSubscription',
                    component: WebPageSubscriptionComponent,
                    resolve: [VIEW_NAVIGATOR(WebPageSubscriptionComponent)],
                })
                .state('webpagesubscriptionedit', {
                    url: '/webpagesubscriptionedit/:p2_webpage_subscription_keyno',
                    component: 'webpageSubscriptionEdit',
                })
                .state('websitenew', {
                    url: '/websitenew',
                    //component: 'webSiteNew',
                    component: WebSiteNewComponent,
                })
                .state('websites', {
                    url: '/websites',
                    //component: 'webSites',
                    component: WebsitesComponent,
                });
        },
    ]);
})();

function VIEW_NAVIGATOR(owner) {
    return {
        token: TT_VIEW_NAVIGATOR,
        deps: [Transition, 'stateService', 'translateService'],
        resolveFn: function (trans, stateService, translateService) {
            if (window.location.hash.includes('ispopup')) {
                return createPopupNavigator(trans.params(), stateService, translateService, window, owner);
            } else {
                return createPageNavigator(trans, stateService, translateService, owner);
            }
        },
    };
}
